/* Behaviour for sections/haki-rewards-page.liquid.
   Extracted from the section file: Shopify caps a section template at 256 KB
   and the inline <script> pushed it over. Edit this file, not an inline copy.
   The section is a singleton on templates/page.rewards.json, so the old
   {{ section.id }} scoping is a fixed 'rp' prefix here and in the section CSS.
   Coin image URLs arrive via data-coin-spin / data-coin-still on .hrw-rp. */
(function () {
  var root = document.querySelector('.hrw-rp');
  if (!root) return;
  var HRW_RP_COIN_SPIN = root.getAttribute('data-coin-spin') || '';
  var HRW_RP_COIN_STILL = root.getAttribute('data-coin-still') || '';
  // The support address lives in ONE place: Theme settings -> Contact (HAKI) ->
  // Support email, handed here as a data attribute because an asset file cannot
  // read Liquid. The literal is the last-resort fallback for a theme where the
  // setting has somehow not been saved yet — it is not a second source of truth.
  var HRW_SUPPORT_EMAIL = root.getAttribute('data-support-email') || 'support@haki-studios.com';
  var catalogUrl = root.getAttribute('data-catalog-url');
  var loggedIn = root.getAttribute('data-logged-in') === '1';
  var HRW_LOGIN_URL = root.getAttribute('data-login-url') || '/customer_authentication/login?return_to=%2Fpages%2Frewards';
  var HRW_JOIN_URL = root.getAttribute('data-register-url') || HRW_LOGIN_URL;
  // the Start Menu scroller (Quests/Shop/Lore) switches from a vertical list
  // to a horizontal carousel below this width — was hardcoded as the literal
  // string in 4 separate places, easy to retune one and miss the others.
  var HRW_ADVSC_MOBILE_MQ = '(max-width: 780px)';

  // ---- Seamless looping lists: WHERE to wrap --------------------------------
  // Every "infinite" list here repeats its set N times and, when the scroll
  // position drifts too far, jumps it by exactly one set (invisible — the
  // copies are identical). The bug these all had (operator, 2026-09-24:
  // "scrolling left is truly infinite, scrolling right bottoms out"): the
  // wrap points were measured from the START of the content, e.g. "< 1 set"
  // and "> N-1 sets". But the furthest a list can scroll is its content width
  // MINUS the viewport, so the right-hand trigger sat much closer to the real
  // end than the left one sat to the real start — with 5 copies and a set
  // barely wider than the screen there was ~0 px of runway on the right. A
  // flick outruns a once-per-frame check and hits the browser's hard stop.
  //
  // So: wrap when the position leaves a one-set "home" window CENTRED in the
  // actual scrollable range [0, max]. Equal runway both ways, whatever the
  // viewport and set sizes. Returns the corrected position (or the same one).
  function hrwLoopWrap(pos, setSize, maxPos) {
    if (!setSize || !(maxPos > setSize)) return pos;
    var lo = (maxPos - setSize) / 2, hi = lo + setSize;
    if (pos < lo) return pos + setSize * Math.ceil((lo - pos) / setSize);
    if (pos > hi) return pos - setSize * Math.ceil((pos - hi) / setSize);
    return pos;
  }
  // Shared "you need an account for this" gate — shown in place of (or over)
  // any panel that only makes sense for a signed-in member (Nick).
  function hrwAuthGate(whatYouSee) {
    return '<div class="hrw-rp__authgate">'
      + '<p class="hrw-rp__authgate-t">Log in to see your ' + whatYouSee + '.</p>'
      + '<p class="hrw-rp__authgate-sub">New here? Join the Members Club and start earning Credits from your first order.</p>'
      + '<div class="hrw-rp__authgate-btns">'
      + '<a class="hrw-rp__authgate-btn is-primary" href="' + HRW_LOGIN_URL + '">Log in</a>'
      + '<a class="hrw-rp__authgate-btn" href="' + HRW_JOIN_URL + '">Join now</a>'
      + '</div></div>';
  }
  // ?spend=<n> — a testing override. When present it drives EVERYTHING on the
  // page that keys off lifetime spend: the tier highlight, the Level Up bar,
  // and the quest-map — as if the member had spent exactly that much. null when
  // absent (real balance data is used).
  var HRW_SPEND_OVERRIDE = (function () {
    try {
      var q = new URLSearchParams(window.location.search).get('spend');
      if (q != null && q !== '' && !isNaN(+q)) return Math.max(0, Math.round(+q));
    } catch (e) {}
    return null;
  })();
  // Shopify-signed App Proxy base — subpath "rewards", forwards to PLM's
  // /api/loyalty. Trailing slash trimmed so `proxyBase + '/balance'` is clean.
  var proxyBase = (root.getAttribute('data-proxy-base') || '/apps/rewards').replace(/\/+$/, '');
  // Prefilled into the inline newsletter form so a logged-in member subscribes
  // in one click — and, more importantly, subscribes the address the credits
  // will attach to rather than a second one they happen to type.
  var customerEmail = root.getAttribute('data-customer-email') || '';

  // ---- Tiers: list (Classic) vs quest map (Start Menu) ------------------
  // There is no user-facing toggle. Classic shows only the tier list; the map
  // never builds. Start Menu shows the map (in place of the list's card grid)
  // with the tier drawers kept beneath it. The map is an <iframe srcdoc> built
  // once, the first time Start Menu is active, seeded with the member's real
  // lifetime spend (?spend=<n> on the URL wins, for testing).
  (function initTierMap() {
    var listEl = root.querySelector('[data-tiers-list]');
    var mapEl = root.querySelector('[data-tiermap]');
    var frame = mapEl && mapEl.querySelector('iframe');
    if (!listEl || !mapEl || !frame) return;

    var urlSpend = HRW_SPEND_OVERRIDE;   // ?spend=<n> testing override (shared, parsed once up top)
    // updated by the balance fetch below; read at srcdoc-build time
    window.__hrwTierMapSpend = urlSpend;

    var built = false;
    function buildMap() {
      if (built) return;
      var docText = window.__HAKI_TIER_MAP_DOC__;
      if (!docText) return; // asset not loaded yet — caller retries
      built = true;
      var spend = (urlSpend != null) ? urlSpend
                : (typeof window.__hrwTierMapSpend === 'number') ? window.__hrwTierMapSpend
                : 0;
      var OPEN = '\x3cscript\x3e', CLOSE = '\x3c/script\x3e';
      // the live loyalty catalog, so the map's scroll info matches PLM's admin
      // (the map only uses name / threshold / rate / perks; its own art theming
      // stays keyed by rank, and it ignores a catalog that isn't 5 tiers)
      var tierJson = '[]';
      try { if (Array.isArray(window.__hrwTierMapTiers)) tierJson = JSON.stringify(window.__hrwTierMapTiers); } catch (e) {}
      // Height sync — deliberately NOT a live loop. A continuous reporter +
      // ResizeObserver fought the map's own vh-based sizing (report height ->
      // parent resizes iframe -> map's 68vh stage recomputes -> height changes ->
      // report again), and that constant relayout is what made the animation
      // stutter in the theme. Now: a handful of posts over the first ~4s while it
      // settles, then silence. The parent locks the height once two readings agree.
      // Pass ONLY an actual hand-picked mount (from the Inventory equip / un-equip).
      // With nothing hand-picked the map runs in "auto" mode: the mount follows the
      // tier and swaps — with the change-over animation — at each checkpoint.
      // (Sending equippedMount().key here made every Scout+ look hand-picked, which
      // suppressed the auto swap.)
      var mountKey = '';
      try { mountKey = (typeof hrwLoadMount === 'function') ? (hrwLoadMount() || '') : ''; } catch (e) {}
      var payload = 'window.__HAKI_SPEND__=' + JSON.stringify(String(Math.max(0, spend))) + ';' +
        'window.__HAKI_TIERS__=' + tierJson + ';' +
        'window.__HAKI_MOUNT__=' + JSON.stringify(mountKey) + ';' +
        'window.__HAKI_TEST__=' + (HRW_SPEND_OVERRIDE != null ? 'true' : 'false') + ';' +
        'function __hrwPost(){try{parent.postMessage({__hrwTierMapHeight:' +
        'Math.ceil(document.documentElement.getBoundingClientRect().height)},"*")}catch(e){}}' +
        'addEventListener("load",__hrwPost);addEventListener("resize",__hrwPost);' +
        'document.addEventListener("DOMContentLoaded",function(){[0,400,1000,2000,3500].forEach(function(d){setTimeout(__hrwPost,d)})});';
      frame.setAttribute('srcdoc', docText.replace('<meta charset="utf-8">', '<meta charset="utf-8">' + OPEN + payload + CLOSE));
    }

    var lastH = 0, hLocked = false;
    window.addEventListener('message', function (e) {
      if (!frame || e.source !== frame.contentWindow) return;
      var h = e.data && e.data.__hrwTierMapHeight;
      if (!h || h < 560) return;   // ignore early pre-layout readings that would collapse the frame
      if (hLocked && Math.abs(h - lastH) < 48) return;   // locked: only a real change (resize) reopens it
      frame.style.height = h + 'px';
      if (lastH > 0 && Math.abs(h - lastH) < 6) hLocked = true;   // two readings agree -> settled
      lastH = h;
    });

    var advMode = root.getAttribute('data-hrw-theme') === 'start-menu';
    var polling = false, docRequested = false;

    // The ~365 KB map document is only needed in Start Menu — load it on demand.
    function loadMapDoc() {
      if (docRequested || window.__HAKI_TIER_MAP_DOC__) return;
      docRequested = true;
      var url = root.getAttribute('data-map-doc-url');
      if (!url) return;
      var s = document.createElement('script');
      s.src = url; s.defer = true;
      document.head.appendChild(s);
    }

    // Build the map once its doc asset AND (for a member) the real spend are
    // both ready, so it never renders with a stale 0. Only matters in Start Menu.
    var waited = 0;
    function tryBuild() {
      if (!advMode || built) { polling = false; return; }
      loadMapDoc();
      var spendKnown = (urlSpend != null) || !loggedIn || (typeof window.__hrwTierMapSpend === 'number');
      if (window.__HAKI_TIER_MAP_DOC__ && spendKnown) { polling = false; buildMap(); return; }
      if ((waited += 100) > 15000) { polling = false; if (window.__HAKI_TIER_MAP_DOC__) buildMap(); return; } // spend hung — open at 0
      polling = true;
      setTimeout(tryBuild, 100);
    }

    // Called by the theme switch. Start Menu: the map + list become RPG panels
    // (initAdvNav owns which one shows); we just make sure the map can display
    // and its doc/build is armed. Light/Dark: map hidden, list only.
    function applyAdv(on) {
      advMode = !!on;
      listEl.hidden = false;
      // the map is no longer an inline panel — it's built lazily when the overlay
      // is opened (__hrwOpenMap). Nothing to show/hide here.
    }
    window.__hrwApplyTierTheme = applyAdv;
    // let the RPG nav force a (re)build when the reader opens the Map panel
    window.__hrwBuildMap = function () { advMode = true; if (!built && !polling) tryBuild(); };
    // the map now lives as a full-screen overlay opened from the Retro menu (and
    // the Inventory "Use" button). Open/close toggle the overlay class + build.
    window.__hrwOpenMap = function () {
      mapEl.hidden = false;
      mapEl.classList.add('is-mapoverlay');
      document.documentElement.style.overflow = 'hidden';
      window.__hrwBuildMap();
    };
    window.__hrwCloseMap = function () {
      mapEl.classList.remove('is-mapoverlay');
      // the Game Boy's own in-Start Menu can open the map ON TOP of itself
      // without closing first (see the MAP menu item below) — don't release
      // the shared scroll-lock out from under it if it's still open (Nick).
      var gb = root.querySelector('[data-retro]');
      if (!gb || !gb.classList.contains('is-open')) document.documentElement.style.overflow = '';
      mapEl.hidden = true;
    };
    var mapClose = mapEl.querySelector('[data-tiermap-close]');
    if (mapClose) mapClose.addEventListener('click', window.__hrwCloseMap);
    mapEl.addEventListener('click', function (e) { if (e.target === mapEl) window.__hrwCloseMap(); });
    document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hrwCloseSubModal();
      if (e.key === 'Escape' && mapEl.classList.contains('is-mapoverlay')) window.__hrwCloseMap();
    });
    // the map is built once; a later mount change is pushed in as a message
    window.__hrwSetMapMount = function (key) {
      try { if (frame && frame.contentWindow) frame.contentWindow.postMessage({ __hrwMount: String(key || '') }, '*'); } catch (e) {}
    };
    applyAdv(advMode);   // initial state
  })();

  // ---- hero lockup: stretch the small bottom line to exactly the width of
  // the big line above it (like the HAKI / STUDIOS wordmark). Pure CSS can't
  // auto-tune letter-spacing to a target width, so measure and set it. Re-run
  // on resize and once webfonts load (metrics change).
  function fitBottomLine() {
    var top = root.querySelector('[data-hero-title-top]');
    var bot = root.querySelector('[data-hero-title-bottom]');
    if (!top || !bot) return;
    var n = (bot.textContent || '').replace(/\s+$/, '').length;
    if (n < 2) return;
    bot.style.letterSpacing = '0';
    bot.style.paddingLeft = '0';
    var natural = bot.getBoundingClientRect().width;
    var target = top.getBoundingClientRect().width;
    if (target <= natural) return; // bottom line already wider — leave it be
    var gap = (target - natural) / (n - 1);
    bot.style.letterSpacing = gap + 'px';
    bot.style.paddingLeft = gap + 'px'; // offset the trailing letter-space, keep it centred
  }
  fitBottomLine();
  var fitTimer;
  window.addEventListener('resize', function () { clearTimeout(fitTimer); fitTimer = setTimeout(fitBottomLine, 120); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitBottomLine);

  // ---- scroll reveal (same pattern as haki-reviews-page.liquid) ----
  if (document.documentElement.classList.contains('hk-anim') && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('hk-rw-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -4% 0px', threshold: 0.05 });
    root.querySelectorAll('.hk-rw-ent').forEach(function (el) { io.observe(el); });
  } else {
    root.querySelectorAll('.hk-rw-ent').forEach(function (el) { el.classList.add('hk-rw-in'); });
  }

  // ---- how-it-works dots (mobile carousel) — the swipe itself is pure CSS
  // scroll-snap, this only keeps the dot indicators in sync with it ----
  (function () {
    var track = root.querySelector('[data-steps-track]');
    var dots = root.querySelectorAll('[data-steps-dots] .hrw-rp__steps-dot');
    if (!track || !dots.length) return;
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        ticking = false;
      });
    }, { passive: true });
  })();

  // ---- Level Up needs BOTH the catalog fetch (tiers) and the balance
  // fetch (lifetimeSpend) — two independent requests that resolve in
  // whatever order the network gives them. levelUpState collects both;
  // maybeRenderLevelUp only actually renders once neither piece is
  // pending, from whichever fetch's .then finishes second. ----
  var levelUpState = { tiers: null, lifetimeSpend: null };
  // Logged-out visitors have no spend to fetch — show them the whole journey
  // from the start (0 XP) rather than a spinner that never resolves.
  if (!loggedIn && HRW_SPEND_OVERRIDE == null) levelUpState.lifetimeSpend = 0;
  function maybeRenderLevelUp() {
    if (!root.querySelector('[data-levelup]')) return; // logged-out: this section doesn't exist
    if (levelUpState.tiers === null || levelUpState.lifetimeSpend === null) return;
    renderLevelUp(levelUpState.tiers, levelUpState.lifetimeSpend);
    // Tiers were already rendered (unhighlighted) as soon as the catalog
    // fetch resolved — this is a second pass, once the customer's spend is
    // ALSO known, purely to add the is-achieved "collected" highlight up to
    // their rank. Re-rendering the whole list is simpler and cheap (a
    // handful of DOM nodes) rather than trying to patch classes in per card.
    renderTiers(levelUpState.tiers, computeCurrentTier(levelUpState.tiers, levelUpState.lifetimeSpend).currentIndex);
    renderSkillTreeH(levelUpState.tiers, levelUpState.lifetimeSpend);  // Start Menu "Progress" panel
  }

  /**
   * The tier's free-shipping line (Nick, 2026-09-09: "{number}x free shipping
   * tokens/yr").
   *
   * "/yr" is accurate for THIS number specifically. The catalog's
   * freeShippingAllowance is PLM's `free_shipping_allowance` — the annual,
   * current-tier-only allowance that expires at year end. It is a different
   * benefit from `free_shipping_tokens_on_unlock`, which is additive across
   * every tier reached and never expires; that one is not shown here.
   *
   * Singular at 1, or Scout reads "1× free shipping tokens/yr".
   *
   * Kept as one builder because this string was written out twice — the
   * Light/Dark tier list and the Start Menu progress panel — and two copies of
   * a sentence drift the moment one of them is edited.
   */
  function hrwShipPerk(n) {
    return n + '× free shipping token' + (n === 1 ? '' : 's') + '/yr';
  }

  // ---- Start Menu "Progress" panel: the tiers drawn as a horizontal skill tree ----
  function perksForTier(t) {
    var perks = [];
    // C3 — THE ENTRY TIER HAS NO DISCOUNT, so its card would otherwise open
    // with free shipping and read as "nothing for me yet". WELCOME10 is a real
    // offer a new member can use today, and the launch ladder (0/10/15) is
    // exactly why this line exists now: at 0% the first two tiers have nothing
    // to put in this slot.
    if (!t.discountPercent && Number(t.minLifetimeSpend) === 0) {
      perks.push('New here? Use WELCOME10 at checkout');
    }
    if (t.discountPercent) perks.push(t.discountPercent + '% ' + (t.discountScope === 'first_order' ? 'off your first order' : 'permanent discount'));
    if (t.freeShippingAllowance) perks.push(hrwShipPerk(t.freeShippingAllowance));
    if (t.earlyAccessHours) perks.push('Early access · ' + t.earlyAccessHours + 'h before');
    if (t.extendedReturnsDays) perks.push('Extended returns · ' + t.extendedReturnsDays + ' days');
    else if (t.extendedReturns) perks.push('Extended returns');
    (t.otherPerks || []).forEach(function (p) { perks.push(p); });
    return perks;
  }

  // ---- icon set for the Start Menu skill tree ----
  // Tier marks are drawn with more detail; perk marks stay simple line glyphs.
  var STH_STAR_D = 'M12 2.5 14.6 9l6.9.4-5.3 4.4 1.7 6.7L12 17l-5.9 3.5 1.7-6.7L2.5 9.4 9.4 9Z';
  var STH_ICONS = {
    // --- tier marks (blade of the sword points north-east) ---
    sword: '<circle cx="5.4" cy="18.6" r="1.8" fill="currentColor" stroke="none"/>'
      + '<path d="M6.6 17.4 9.6 14.4" stroke-width="3.2"/>'
      + '<path d="M7.1 16 8.5 17.4M8.3 14.8 9.7 16.2" stroke-width="0.9"/>'
      + '<path d="M6.9 11.8 12.4 17.3" stroke-width="2"/>'
      + '<path d="M9.9 12.6 20.6 3.2 21.4 4 12 14.7Z" fill="currentColor" stroke="none"/>',
    binoculars: '<rect x="3.4" y="9.2" width="6.6" height="9" rx="2.3"/>'
      + '<rect x="14" y="9.2" width="6.6" height="9" rx="2.3"/>'
      + '<path d="M10 11.6h4M10 14.2h4"/>'
      + '<path d="M4.6 9.2 5.5 6.3 8 6.3 8.8 9.2M15.2 9.2 16 6.3 18.5 6.3 19.4 9.2"/>'
      + '<circle cx="12" cy="12.8" r="1.1"/>',
    compass: '<circle cx="12" cy="12" r="8.7"/><circle cx="12" cy="12" r="6.1"/>'
      + '<path d="M12 3.3v1.7M12 19v1.7M3.3 12h1.7M19 12h1.7"/>'
      + '<path d="M12 7.2 14.1 12 12 16.8 9.9 12Z" fill="currentColor" stroke="none"/>'
      + '<path d="M12 16.8 9.9 12h4.2z"/>'
      + '<circle cx="12" cy="12" r="1.1" fill="currentColor" stroke="none"/>',
    cape: '<path d="M8 4.5 6.3 6.2C4.7 10 4.4 15.3 5.4 19.3 8.5 20.6 15.5 20.6 18.6 19.3 19.6 15.3 19.3 10 17.7 6.2L16 4.5"/>'
      + '<path d="M8 4.5 12 7.9 16 4.5"/><path d="M12 7.9V19.6"/>'
      + '<path d="M9 8.6C8.6 12 8.7 16 9.4 19M15 8.6C15.4 12 15.3 16 14.6 19"/>'
      + '<path d="M5.4 19.3C7 17.7 9 17.7 10.3 19.3 11.5 20.7 12.5 20.7 13.7 19.3 15 17.7 17 17.7 18.6 19.3"/>',
    crown: '<path d="M4 16.8 5.2 8.6 9 12.6 12 6.2 15 12.6 18.8 8.6 20 16.8Z"/>'
      + '<path d="M3.5 19.4h17M7.6 16.9h8.8"/>'
      + '<circle cx="12" cy="6" r="1.35" fill="currentColor" stroke="none"/>'
      + '<circle cx="5.2" cy="8.5" r="1" fill="currentColor" stroke="none"/>'
      + '<circle cx="18.8" cy="8.5" r="1" fill="currentColor" stroke="none"/>',
    // --- perk marks (simple) ---
    tag: '<path d="M4 12.5 11.5 5H19v7.5L11.5 20Z"/><circle cx="14.8" cy="9.2" r="1.5"/>',
    truck: '<path d="M3 7.5h11v9H3z"/><path d="M14 11h4l3 3v2.5h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
    clock: '<circle cx="12" cy="12" r="8.4"/><path d="M12 7v5.3l3.6 2.1"/>',
    undo: '<path d="M19.5 12a7.5 7.5 0 1 0-2.4 5.5"/><path d="M19.5 6v5h-5"/>',
    ticket: '<path d="M4 8h16v3a2 2 0 0 0 0 4v3H4v-3a2 2 0 0 0 0-4z"/><path d="M13.5 8v11" stroke-dasharray="2 2.2"/>',
    shirt: '<path d="M9 5 5 7.2l1.7 3.6L9 9.7V19h6V9.7l2.3 1.1L19 7.2 15 5l-1.6 1.7a2.4 2 0 0 1-3.8 0Z"/>',
    gift: '<path d="M5 10h14v10H5z"/><path d="M4 7.4h16V10H4z"/><path d="M12 7.4V20"/><path d="M12 7.4C11 3.6 6.6 4.6 8.6 7.4M12 7.4C13 3.6 17.4 4.6 15.4 7.4"/>',
    gem: '<path d="M7 5h10l4 5-9 10.5L3 10Z"/><path d="M3 10h18"/><path d="M7 5l2.6 5L12 20.5 14.4 10 17 5"/>',
    star5: '<path d="' + STH_STAR_D + '" fill="currentColor" stroke="none"/>',
    sparkle: '<path d="M12 3 13.6 9.4 20 11l-6.4 1.6L12 19l-1.6-6.4L4 11l6.4-1.6Z"/>'
  };
  function perkIconKey(s) {
    s = String(s).toLowerCase();
    if (/free shipping|shipping/.test(s)) return 'truck';
    if (/first order|permanent discount|% off|discount/.test(s)) return 'tag';
    if (/early access/.test(s)) return 'clock';
    if (/return/.test(s)) return 'undo';
    if (/raffle|unreleased|sample/.test(s)) return 'ticket';
    if (/top or bottom|free (top|piece|garment)/.test(s)) return 'shirt';
    if (/birthday|present|gift/.test(s)) return 'gift';
    if (/exclusive|collection/.test(s)) return 'gem';
    return 'sparkle';
  }
  function perkBlurb(s) {
    var l = String(s).toLowerCase();
    if (/first order/.test(l)) return 'A one-time discount applied to your very first order.';
    if (/permanent discount/.test(l)) return 'A standing discount on every order for as long as you hold this rank.';
    if (/free shipping/.test(l)) return 'Free-shipping credits you can apply at checkout.';
    if (/early access/.test(l)) { var eh = l.match(/(\d+)\s*h/); return eh ? ('Shop new drops ' + eh[1] + ' hours before they open to everyone else.') : 'Shop new drops before they open to everyone else.'; }
    if (/return/.test(l)) { var rd = l.match(/(\d+)\s*days?/); return rd ? ('A ' + rd[1] + '-day window to return or exchange a piece - up from the standard 7.') : 'A longer window to return or exchange a piece.'; }
    if (/raffle|unreleased|sample/.test(l)) return 'Automatic entry into raffles for unreleased pieces and samples.';
    if (/top or bottom/.test(l)) return 'Choose a free top or bottom from the current range.';
    if (/birthday/.test(l)) return 'A gift from us around your birthday.';
    if (/exclusive|collection/.test(l)) return 'Access to members-only exclusive collections.';
    return '';
  }
  // Reward "families" that ship in escalating levels get a Roman numeral (I, II, III…).
  var STH_ROMAN = ['', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII'];
  function romanNum(n) { return STH_ROMAN[n] || String(n); }
  function perkFamily(s) {
    s = String(s).toLowerCase();
    if (/first order/.test(s)) return 'firstorder';
    if (/permanent discount|% off/.test(s)) return 'discount';
    if (/free shipping/.test(s)) return 'shipping';
    if (/early access/.test(s)) return 'earlyaccess';
    if (/return/.test(s)) return 'returns';
    if (/raffle|unreleased|sample/.test(s)) return 'raffle';
    if (/top or bottom/.test(s)) return 'garment';
    if (/birthday/.test(s)) return 'birthday';
    if (/exclusive|collection/.test(s)) return 'exclusive';
    return s;
  }
  // → { num, of } for this perk's position within its family, or null if the
  // family only has one level across all tiers.
  function perkTierNum(label, allTiers) {
    var fam = perkFamily(label), variants = [];
    allTiers.forEach(function (t) {
      perksForTier(t).forEach(function (p) {
        if (perkFamily(p) === fam && variants.indexOf(p.trim()) < 0) variants.push(p.trim());
      });
    });
    if (variants.length < 2) return null;
    variants.sort(function (a, b) {
      var na = parseFloat((a.match(/[\d.]+/) || ['x'])[0]);
      var nb = parseFloat((b.match(/[\d.]+/) || ['x'])[0]);
      return (isFinite(na) && isFinite(nb)) ? na - nb : 0;
    });
    var idx = variants.indexOf(label.trim());
    return idx < 0 ? null : { num: idx + 1, of: variants.length };
  }

  // ---- "Skill points": reaching a rank lets you fill in that rank's benefit
  // nodes yourself (cosmetic — persisted per customer, across reloads). Dropping
  // your lifetime spend back below a rank forfeits that rank's claims (pruned in
  // renderSkillTreeH). A ?spend= session writes to its own "-t" key so demo play
  // never lands in a real customer's set. ----
  var HRW_SKP_KEY = 'hrw-skp-' + (root.getAttribute('data-customer-id') || 'anon')
    + (HRW_SPEND_OVERRIDE != null ? '-t' : '');
  function hrwLoadSkp() {
    try { var v = JSON.parse(localStorage.getItem(HRW_SKP_KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function hrwSaveSkp(a) { try { localStorage.setItem(HRW_SKP_KEY, JSON.stringify(a.slice(0, 80))); } catch (e) {} }

  // ---- Start Menu "Progress": a game-style skill tree (SVG) ----
  // 5 hexagon tier cores left→right (Recruit first); each perk is a diamond
  // sub-node offset to the right of its core. Icon-only — hover (desktop) or
  // tap for a detail tooltip. The spine FILLS as lifetime spend (XP) climbs,
  // measured across the *visible* track only (node footprints excluded).
  function esc(s) { return escapeHtml(s); }
  var STH_ROOT3_2 = 0.8660254;
  function sthHex(cx, cy, R) {
    var h = R * STH_ROOT3_2;
    return [[cx + R, cy], [cx + R / 2, cy + h], [cx - R / 2, cy + h], [cx - R, cy], [cx - R / 2, cy - h], [cx + R / 2, cy - h]]
      .map(function (p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' ');
  }
  function sthDia(cx, cy, d) {
    return [[cx, cy - d], [cx + d, cy], [cx, cy + d], [cx - d, cy]]
      .map(function (p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' ');
  }
  function sthIcon(key, cx, cy, sz) {
    var s = sz / 24;
    return '<g class="hrw-rp__sth-ico" transform="translate(' + (cx - sz / 2).toFixed(1) + ' ' + (cy - sz / 2).toFixed(1) + ') scale(' + s.toFixed(3) + ')" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">' + (STH_ICONS[key] || STH_ICONS.sparkle) + '</g>';
  }
  function sthIconHtml(key) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (STH_ICONS[key] || STH_ICONS.sparkle) + '</svg>';
  }
  var TIER_COL = ['--tc-recruit', '--tc-scout', '--tc-adventurer', '--tc-hero', '--tc-chosen'];
  var TIER_ICON = ['sword', 'binoculars', 'compass', 'cape', 'crown'];
  var sthState = { tiers: null, spend: null };
  // XP shown to members is lifetime spend × 100 (a $ threshold of 150 reads as
  // "15,000 XP"). All the underlying math stays in dollars.
  var XP_PER_DOLLAR = 100;
  function xp(dollars) { return Math.round((+dollars || 0) * XP_PER_DOLLAR); }
  function xpLabelFor(dollars) { return dollars > 0 ? xp(dollars).toLocaleString() + ' XP' : 'Start'; }

  // ---- Start Menu HUD (top bar): XP bar + skill points (left of the coins),
  //   Current Mount (right, before the theme toggles). Plain "digital readout"
  //   style — no pill/bubble chrome, just an icon + a label. ----
  // One shared mount model — index 0 is always "on foot"; 1..3 unlock at the
  // Scout / Adventurer / Hero ranks. The HUD, the Inventory (equip / unequip),
  // and the map all read the SAME equipped mount so a replay with a different
  // mount stays consistent everywhere.
  var MOUNT_ICON_FOOT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 4h4v7l7 3a3 3 0 0 1 2 2.8V19H5V4Z"/><path d="M5 15h13"/></svg>';
  var MOUNT_ICON_HORSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20c0-5 3-8 8-8 1-3 3-5 5-5l2-3-1 4 2 2-3 1c0 3-1 5-3 6l1 6h-3l-1-4-3 1 1 3H4Z"/></svg>';
  var MOUNT_ICON_SHIP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14h16l-2 5a3 3 0 0 1-2.8 2H8.8A3 3 0 0 1 6 19l-2-5Z"/><path d="M12 3v11M12 3l6 4-6 2M12 6 7 8l5 1"/></svg>';
  var MOUNT_ICON_DRAGON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 15c3 0 4-2 4-4 0-3 3-5 6-5 2 0 3-1 3-3 1 2 0 4-1 5 3 0 5 2 5 5 0 4-3 7-8 7-2 0-3 1-3 3-1-2-1-4 0-5-3 0-5-1-6-3l-1 3-2-2 1-2Z"/></svg>';
  var MOUNTS = [
    { key: 'foot',   name: 'Running Shoes', hud: 'None',       icon: MOUNT_ICON_FOOT,   unlock: 0, rarity: 'common' },
    { key: 'horse',  name: 'Trusty Horse',  hud: 'Horseback',  icon: MOUNT_ICON_HORSE,  unlock: 1, rarity: 'uncommon',  at: 'the Scout rank',      desc: 'A sure-footed mount for the long road inland.' },
    { key: 'ship',   name: 'Merchant Ship', hud: 'By Ship',    icon: MOUNT_ICON_SHIP,   unlock: 2, rarity: 'rare',      at: 'the Adventurer rank', desc: 'Yours for the crossing of the southern gulf.' },
    { key: 'dragon', name: 'Dragon',        hud: 'By Dragon',  icon: MOUNT_ICON_DRAGON, unlock: 3, rarity: 'legendary', at: 'the Hero rank',       desc: 'The sky itself becomes a shortcut.' }
  ];
  var HRW_MOUNT_KEY = 'hrw-mount-' + (root.getAttribute('data-customer-id') || 'anon');
  var MOUNT_KEY_RANK = { foot: 0, horse: 1, ship: 2, dragon: 3 };
  // A hand-pick holds only until the member unlocks a mount ABOVE it — then it's
  // stale and we drop back to auto (so, e.g., un-equipping to "On foot" as a
  // Scout persists, but reaching Adventurer auto-swaps you to the ship).
  function hrwMountPickStale(saved) {
    var mr = MOUNT_KEY_RANK[saved];
    if (mr == null) return false;
    var at = 0;
    try { at = +localStorage.getItem(HRW_MOUNT_KEY + '-at') || 0; } catch (e) {}
    return invCurTierIndex() > Math.max(at, mr);
  }
  function hrwLoadMount() {
    try {
      var v = localStorage.getItem(HRW_MOUNT_KEY) || '';
      if (v && hrwMountPickStale(v)) { hrwSaveMount(''); return ''; }
      return v;
    } catch (e) { return ''; }
  }
  function hrwSaveMount(k) {
    try {
      if (k) {
        localStorage.setItem(HRW_MOUNT_KEY, k);
        localStorage.setItem(HRW_MOUNT_KEY + '-at', String(invCurTierIndex()));
      } else {
        localStorage.removeItem(HRW_MOUNT_KEY);
        localStorage.removeItem(HRW_MOUNT_KEY + '-at');
      }
    } catch (e) {}
  }
  function mountMaxUnlocked(cur) { return Math.max(0, Math.min(cur, 3)); }   // how far up MOUNTS the member has unlocked
  // The equipped mount: the member's saved choice if it's unlocked, else the
  // best one they've unlocked (so a fresh Hero rides a Dragon without picking).
  function equippedMount(cur) {
    var maxU = mountMaxUnlocked(cur);
    var saved = hrwLoadMount();
    for (var i = 0; i < MOUNTS.length; i++) {
      if (MOUNTS[i].key === saved && MOUNTS[i].unlock <= maxU) return MOUNTS[i];
    }
    return MOUNTS[maxU];
  }
  // small hex badge for a tier, flanking the HUD's XP track (and reused under
  // the tree — see renderSkillTreeH's own miniBadge for the fuller version)
  function hudTierBadge(rank, tiersN) {
    var col = TIER_COL[rank] || TIER_COL[TIER_COL.length - 1];
    var ch = rank === (tiersN - 1);
    return '<svg class="hrw-rp__advhud-tb" viewBox="0 0 26 26" style="--st-col: var(' + col + ');" aria-hidden="true">'
      + '<polygon class="hrw-rp__advhud-tb-hex" points="' + sthHex(13, 13, 11) + '"/>'
      + (ch ? '<path transform="translate(7.2 7.2) scale(0.48)" d="' + STH_STAR_D + '" fill="var(--tc-star-chosen, #ffd23d)"/>' : '')
      + '</svg>';
  }
  function hrwRenderAdvHud() {
    var xpEl = root.querySelector('[data-tb-xp]');
    var skpEl = root.querySelector('[data-tb-skp]');
    var rankEl = root.querySelector('[data-tb-rank]');
    var tiers = levelUpState.tiers, spend = levelUpState.lifetimeSpend;
    if ((xpEl || rankEl) && tiers && tiers.length && spend != null) {
      var comp = computeCurrentTier(tiers, spend);
      var ci = comp.currentIndex;
      var pct = 100, cap = 'Top rank';
      if (comp.next) {
        var span = comp.next.minLifetimeSpend - comp.current.minLifetimeSpend;
        var prog = spend - comp.current.minLifetimeSpend;
        pct = span > 0 ? Math.max(0, Math.min(100, prog / span * 100)) : 100;
        cap = xp(Math.max(0, comp.next.minLifetimeSpend - spend)).toLocaleString() + ' XP → ' + comp.next.name;
      }
      if (xpEl) {
        xpEl.hidden = false;
        var f = xpEl.querySelector('[data-tb-xp-fill]'); if (f) f.style.width = pct.toFixed(1) + '%';
        var c = xpEl.querySelector('[data-tb-xp-cap]'); if (c) c.textContent = cap;
        var b0 = xpEl.querySelector('[data-tb-xp-badge-lo]'); if (b0) b0.innerHTML = hudTierBadge(ci, tiers.length);
        var b1 = xpEl.querySelector('[data-tb-xp-badge-hi]'); if (b1) b1.innerHTML = comp.next ? hudTierBadge(ci + 1, tiers.length) : hudTierBadge(ci, tiers.length);
      }
      if (rankEl) rankEl.textContent = 'Rank: ' + comp.current.name;
    }
    if (skpEl) {
      var n = (sthState && typeof sthState.availPts === 'number') ? sthState.availPts : 0;
      skpEl.hidden = false;
      skpEl.innerHTML = '<span class="hrw-rp__advhud-skp-ico">' + sthIconHtml('sparkle') + '</span><span>SP: ' + n + '</span>';
    }
    syncCapFit();
  }
  // Desktop (>=1181px) Start Menu: the XP-cap text's own length changes with
  // the live tier name ("Scout" vs "Adventurer Supreme") and the XP digit
  // count — reduce ITS font-size to fit, rather than truncating with an
  // ellipsis or letting the fixed-width bar/badges/SP move or the level-up
  // slider's width change. Measures the real gap to the SP block directly
  // (rather than trying to compute "available space" from every sibling's
  // width) so it's correct regardless of what's actually causing the squeeze.
  // both static, always-present HUD elements — never rebuilt via innerHTML
  // (hrwRenderAdvHud mutates their contents/styles in place, see above) — so
  // it's safe to look them up once instead of on every call. This runs on
  // every resize tick, matchMedia change, theme mutation, and HUD refresh.
  var HRW_CAP_EL = null, HRW_SKP_EL = null;
  function syncCapFit() {
    if (!HRW_CAP_EL) HRW_CAP_EL = root.querySelector('[data-tb-xp-cap]');
    if (!HRW_SKP_EL) HRW_SKP_EL = root.querySelector('.hrw-rp__advhud-skp');
    var cap = HRW_CAP_EL, skp = HRW_SKP_EL;
    var mq = window.matchMedia && window.matchMedia('(min-width: 1181px)');
    if (!cap || !skp || !mq) return;
    if (!mq.matches || root.getAttribute('data-hrw-theme') !== 'start-menu') {
      cap.style.removeProperty('font-size');
      return;
    }
    // measure at full size every time — recovers cleanly if a later
    // (shorter) tier name or a wider viewport opens the room back up.
    cap.style.removeProperty('font-size');
    var capRect = cap.getBoundingClientRect();
    var skpRect = skp.getBoundingClientRect();
    if (!capRect.width || !skpRect.width) return;
    var margin = 10;
    var overflow = capRect.right - (skpRect.left - margin);
    if (overflow <= 0) return;   // fits already at full size
    var baseSize = 18;   // .hrw-rp__advhud-xp-cap's font-size at this breakpoint
    var ratio = Math.max(0.55, (capRect.width - overflow) / capRect.width);   // floor so it never gets illegible
    cap.style.fontSize = (baseSize * ratio).toFixed(1) + 'px';
  }
  (function () {
    var mq = window.matchMedia && window.matchMedia('(min-width: 1181px)');
    if (!mq) return;
    (mq.addEventListener ? mq.addEventListener('change', syncCapFit) : mq.addListener(syncCapFit));
    window.addEventListener('resize', syncCapFit, { passive: true });
    new MutationObserver(syncCapFit).observe(root, { attributes: true, attributeFilter: ['data-hrw-theme'] });
  })();

  function renderSkillTreeH(tiers, lifetimeSpend) {
    var host = root.querySelector('[data-skilltree-h]');
    if (!host || !tiers || !tiers.length) return;
    var spend = typeof lifetimeSpend === 'number' ? lifetimeSpend : 0;
    sthState.tiers = tiers; sthState.spend = spend;
    var comp = computeCurrentTier(tiers, spend);
    var sorted = comp.sorted, cur = comp.currentIndex, N = sorted.length;

    // segment progress toward the next rank (0..1)
    var segPct = 1;
    if (comp.next) {
      var seg = comp.next.minLifetimeSpend - comp.current.minLifetimeSpend;
      segPct = seg > 0 ? Math.max(0, Math.min(1, (spend - comp.current.minLifetimeSpend) / seg)) : 1;
    }

    // ---- geometry — perks branch off the MIDPOINTS of the six hex edges, in
    //      the order NE · SE · up · down · NW · SW, chained outward. The vertical
    //      arms run long (the tree is deliberately tall); node sizes are fixed —
    //      only the connecting lines are stretched. ----
    // node sizes bumped ~1.6x (Nick, round 8); the tree fills the panel, so the
    // arms are only long enough to clear neighbouring nodes.
    var coreR = 66, HEXH = coreR * STH_ROOT3_2, R3 = STH_ROOT3_2;  // core hex 0.85x of 78 (Nick)
    var coreIco = 40;
    var perkD = 52;                               // perk diamond — fixed, NOT tied to the core
    var perkIco = Math.round(perkD * 0.92);
    var armStep = 2 * perkD + 26;
    var dStep = armStep * 1.15;
    var vStep = dStep;                            // vertical arms match the diagonals (Nick)
    var DIAG = 0.70710678;
    var colGap = 460;
    // Drop redundant nodes: a perk that's word-for-word identical to one already
    // granted at a lower tier isn't a new unlock, so it doesn't get its own node.
    // (An UPGRADE — a different string in the same family, e.g. 24h → 48h early
    // access — is not identical, so it stays.)
    var _seenPerk = {};
    var lay = sorted.map(function (t) {
      var ps = perksForTier(t).filter(function (p) {
        var k = p.trim().toLowerCase();
        if (_seenPerk[k]) return false;
        _seenPerk[k] = 1;
        return true;
      });
      return { perks: ps };
    });
    var EDGE_ORDER = ['NE', 'SE', 'UP', 'DOWN', 'NW', 'SW'];
    // Diagonals leave the hex at a true 45° (Nick), off the upper/lower side
    // edges; Up/Down leave from the flat top/bottom edge midpoints. EDGE_RAD is
    // the distance from the core centre to that anchor point on the perimeter.
    var EDGE_ANCHOR = { NE: [DIAG, -DIAG], SE: [DIAG, DIAG], UP: [0, -1], DOWN: [0, 1], NW: [-DIAG, -DIAG], SW: [-DIAG, DIAG] };
    var EDGE_RAD = { NE: HEXH * 1.04, SE: HEXH * 1.04, UP: HEXH, DOWN: HEXH, NW: HEXH * 1.04, SW: HEXH * 1.04 };
    var ARM_DIR = { NE: [DIAG, -DIAG], SE: [DIAG, DIAG], UP: [0, -1], DOWN: [0, 1], NW: [-DIAG, -DIAG], SW: [-DIAG, DIAG] };
    var ARM_STEP = { NE: dStep, SE: dStep, UP: vStep, DOWN: vStep, NW: dStep, SW: dStep };
    // reach is measured from ACTUAL edge usage, not a worst-case for every core —
    // so a column with no upward arms doesn't reserve a column-height of blank sky.
    function edgeArms(perks, edge) {
      var idx = EDGE_ORDER.indexOf(edge), c = 0;
      for (var k = idx; k < perks.length; k += 6) c++;
      return c;
    }
    var upArms = 1, downArms = 1, diagUp = 0, diagDown = 0;
    lay.forEach(function (m) {
      upArms = Math.max(upArms, edgeArms(m.perks, 'UP'));
      downArms = Math.max(downArms, edgeArms(m.perks, 'DOWN'));
      diagUp = Math.max(diagUp, edgeArms(m.perks, 'NE'), edgeArms(m.perks, 'NW'));
      diagDown = Math.max(diagDown, edgeArms(m.perks, 'SE'), edgeArms(m.perks, 'SW'));
    });
    // reach = the taller of the vertical arm stack and the diagonal (45°) arm stack
    var reachUp = Math.max(HEXH + upArms * vStep, HEXH + diagUp * dStep * DIAG + perkD) + perkD + 8;
    var reachDown = Math.max(HEXH + downArms * vStep, HEXH + diagDown * dStep * DIAG + perkD) + perkD + 24;
    // left/right padding — the FIRST core's leftward reach and the LAST core's
    // rightward reach (a 45° diagonal spends dStep*DIAG horizontally per arm).
    function sideReach(perks, edges) {
      var s = 0;
      edges.forEach(function (e) { s = Math.max(s, edgeArms(perks, e)); });
      return HEXH * 1.04 * DIAG + (s ? s * dStep * DIAG + perkD + 18 : coreR * 0.4);
    }
    var padL = Math.ceil(sideReach(lay[0].perks, ['NW', 'SW']) + 14);   // + a little breathing room so nothing clips the left edge
    var padR = Math.ceil(sideReach(lay[N - 1].perks, ['NE', 'SE']) + 14);
    var W = padL + (N - 1) * colGap + padR;
    var padTop = Math.max(reachUp, HEXH + 24);
    var lblBlock = 132;   // room for the 3-line core label (name / XP / "you are here"), 1.8× type
    var cy = padTop + 12;
    var H = cy + Math.max(reachDown, HEXH + 48) + lblBlock;
    function coreX(i) { return padL + i * colGap; }

    // ---- fill: only the visible span between cores counts ----
    var railStart = coreX(0), railEnd = coreX(N - 1), railLen = railEnd - railStart;
    var targetX;
    if (!comp.next) targetX = railEnd;
    else {
      var sStart = coreX(cur) + coreR, sEnd = coreX(cur + 1) - coreR;
      targetX = sStart + segPct * (sEnd - sStart);
    }
    var fillFrac = railLen > 0 ? Math.max(0, Math.min(1, (targetX - railStart) / railLen)) : 0;

    // ---- skill points: earned as XP climbs, spent to unlock a rank's benefits.
    //   Award interval per leg = (next threshold − this threshold) / #nodes at the
    //   NEXT rank — so by the time you reach a rank you've banked one point per
    //   node there. Entry-rank benefits are free; benefits below your current
    //   rank auto-fill (those points are spent for you). ----
    // Skill points are NOT saved — they're re-derived from spend every render.
    // Claimed NODES are saved (localStorage) so a spent point survives a reload.
    // BUT a claim is FORFEIT if your lifetime spend later drops below that
    // rank's threshold: prune any claim above the current rank and persist the
    // trimmed set, so falling out of a rank truly resets its nodes.
    var claimed = hrwLoadSkp();
    (function () {
      var kept = claimed.filter(function (pid) {
        var m = /^p-(\d+)-/.exec(pid);
        return !m || parseInt(m[1], 10) <= cur;
      });
      if (kept.length !== claimed.length) { hrwSaveSkp(kept); claimed = kept; }
    })();
    function sthLegEarned(i) {
      var nodes = lay[i + 1] ? lay[i + 1].perks.length : 0;
      if (!nodes) return 0;
      var lo = sorted[i].minLifetimeSpend, hi = sorted[i + 1].minLifetimeSpend, span = hi - lo;
      if (span <= 0) return nodes;
      var prog = Math.max(0, Math.min(spend, hi) - lo);
      return Math.min(nodes, Math.floor(prog / (span / nodes)));
    }
    var ptsEarned = 0;
    for (var li = 0; li < N - 1; li++) ptsEarned += sthLegEarned(li);
    // EVERY perk (bar the free rank-0 ones) is now claimed by the member
    // themselves — nothing auto-fills on reaching a rank (Nick). So available
    // points = points earned minus points already spent on claims.
    var availPts = Math.max(0, ptsEarned - claimed.length);
    // interval toward the NEXT award on the current leg (for the card copy)
    var nextNodes = comp.next && lay[cur + 1] ? lay[cur + 1].perks.length : 0;
    var awardEvery = (comp.next && nextNodes) ? Math.round((comp.next.minLifetimeSpend - comp.current.minLifetimeSpend) / nextNodes) : 0;

    var spine = '', twigs = '', nodes = '', clips = '';
    var payload = {};
    spine += '<line class="hrw-rp__sth-rail" x1="' + railStart + '" y1="' + cy + '" x2="' + railEnd + '" y2="' + cy + '"/>';
    spine += '<line class="hrw-rp__sth-fill" x1="' + railStart + '" y1="' + cy + '" x2="' + railEnd + '" y2="' + cy + '" pathLength="100" style="stroke-dashoffset:100" data-off="' + (100 - fillFrac * 100).toFixed(1) + '"/>';

    var canSpendHere = cur > 0 && availPts > 0;

    sorted.forEach(function (t, i) {
      var rank = i, reached = rank <= cur, isCur = rank === cur;
      var below = rank < cur;
      var colVar = TIER_COL[rank] || TIER_COL[TIER_COL.length - 1];
      var isChosen = rank === TIER_COL.length - 1;
      var starVar = isChosen ? 'var(--tc-star-chosen)' : 'var(--tc-star)';
      var cx = coreX(i);
      var m = lay[i], n = m.perks.length;

      m.perks.forEach(function (p, k) {
        var edge = EDGE_ORDER[k % 6];
        var armIdx = Math.floor(k / 6);             // 0 = nearest the core
        var av = EDGE_ANCHOR[edge], dir = ARM_DIR[edge];
        var arad = EDGE_RAD[edge];
        var corner = [cx + av[0] * arad, cy + av[1] * arad];   // twig leaves the hex here (a vertex for diagonals)
        var dist = (armIdx + 1) * ARM_STEP[edge];
        var px = corner[0] + dir[0] * dist;
        var py = corner[1] + dir[1] * dist;
        // twig ends just inside the perk: the diamond's outline is perkD out at
        // the N/S/E/W vertices but only perkD/√2 along a 45° edge, so scale by
        // |dir|₁ and pull 4px past it — the opaque node hides the overlap, and
        // every edge (vertical OR diagonal) now meets its node with no gap.
        var perkEdge = perkD / (Math.abs(dir[0]) + Math.abs(dir[1]));
        var nearVx = px - dir[0] * (perkEdge - 4), nearVy = py - dir[1] * (perkEdge - 4);
        var pid = 'p-' + i + '-' + k;
        // a claim only counts while you're still AT or ABOVE that rank — drop
        // your lifetime spend (a return, a testing toggle) below a rank and its
        // benefits re-lock, though the claim is remembered for when you climb back.
        var isClaimed = claimed.indexOf(pid) >= 0 && rank <= cur;
        // rank 0 free · any reached rank costs a banked skill point (hold to
        // spend), whether it's your current rank or one you've passed · above
        // current rank locked. Nothing auto-fills any more (Nick).
        var unlocked = rank === 0 || isClaimed;
        var canClaim = reached && !unlocked && availPts > 0;
        var pending = reached && !unlocked && availPts === 0;   // reached, no point banked yet
        var state = unlocked ? 'is-unlocked' : (canClaim ? 'is-claimable' : (pending ? 'is-pending' : 'is-locked'));
        var showCost = !unlocked;
        var lit = unlocked ? ' is-lit' : '';
        // start a touch inside the core hex (also opaque) so the seam is covered
        var tsx = cx + av[0] * arad * 0.9, tsy = cy + av[1] * arad * 0.9;
        twigs += '<path class="hrw-rp__sth-twig' + lit + '" d="M' + tsx.toFixed(1) + ' ' + tsy.toFixed(1) + ' L ' + nearVx.toFixed(1) + ' ' + nearVy.toFixed(1) + '"/>';
        var rn = perkTierNum(p, sorted);
        var pAria = 'Benefit: ' + p + (rn ? ' (level ' + romanNum(rn.num) + ' of ' + rn.of + ')' : '') + '. '
          + (unlocked ? 'Unlocked'
              : canClaim ? 'Ready to unlock - costs 1 skill point, press and hold to spend it'
              : pending ? 'Reached - earn a skill point to unlock it'
              : 'Locked until ' + t.name + ' - costs 1 skill point') + '.';
        var dia = sthDia(px, py, perkD);
        if (canClaim) {
          clips += '<clipPath id="hrwshc-rp-' + pid + '"><polygon points="' + dia + '"/></clipPath>';
        }
        nodes += '<g class="hrw-rp__sth-node hrw-rp__sth-perk ' + state + '" style="--st-col: var(' + colVar + ');" data-sth-node="' + pid + '"'
          + (canClaim ? ' data-sth-hold="' + pid + '" role="button"' : ' role="img"')
          + ' tabindex="0" aria-label="' + esc(pAria) + '">'
          + '<polygon class="hrw-rp__sth-shape" points="' + dia + '"/>'
          + (canClaim
              // the clip is on the GROUP (fixed diamond); the rect inside slides
              // up behind it, so the accent reveals bottom→top with no distortion
              ? '<g clip-path="url(#hrwshc-rp-' + pid + ')"><rect class="hrw-rp__sth-holdfill" x="' + (px - perkD).toFixed(1) + '" y="' + (py - perkD).toFixed(1) + '" width="' + (perkD * 2).toFixed(1) + '" height="' + (perkD * 2).toFixed(1) + '"/></g>'
              : '')
          + sthIcon(perkIconKey(p), px, py, perkIco)
          + (rn ? '<text class="hrw-rp__sth-num" x="' + px.toFixed(1) + '" y="' + (py < cy ? (py - perkD - 6) : (py + perkD + 13)).toFixed(1) + '" text-anchor="middle">' + romanNum(rn.num) + '</text>' : '')
          + '</g>';
        var pBlurb = perkBlurb(p) || (unlocked ? 'Active at your rank.' : 'Unlocks when you reach ' + t.name + '.');
        var pCost = unlocked ? ''
          : canClaim ? '1 skill point - press and hold the node to spend it.'
          : pending ? '1 skill point (none banked yet).'
          : '1 skill point.';
        payload[pid] = {
          icon: perkIconKey(p),
          name: esc(p) + (rn ? ' <span class="hrw-rp__sth-rn">' + romanNum(rn.num) + '</span>' : ''),
          tag: unlocked ? 'Unlocked' : canClaim ? 'Ready - 1 skill point' : pending ? 'Needs a skill point' : 'Locked · ' + t.name,
          body: pBlurb,
          cost: pCost
        };
      });

      var ccls = 'hrw-rp__sth-node hrw-rp__sth-core' + (reached ? ' is-reached' : '') + (isCur ? ' is-current' : '') + (isChosen ? ' is-chosen' : '');
      var xpLabel = xpLabelFor(t.minLifetimeSpend);
      var cAria = t.name + ' rank. ' + (t.minLifetimeSpend > 0 ? 'Reached at ' + xp(t.minLifetimeSpend).toLocaleString() + ' XP. ' : 'Starting rank. ') + (reached ? (isCur ? 'You are here.' : 'Reached.') : 'Locked.');
      var lblY = H - lblBlock + 20;
      nodes += '<g class="' + ccls + '" style="--st-col: var(' + colVar + '); --st-star: ' + starVar + ';" data-sth-node="c-' + i + '" tabindex="0" role="img" aria-label="' + esc(cAria) + '">'
        + '<polygon class="hrw-rp__sth-shape" points="' + sthHex(cx, cy, coreR) + '"/>'
        + sthIcon(TIER_ICON[rank] || 'crown', cx, cy, coreIco)
        + '<text class="hrw-rp__sth-corename" x="' + cx + '" y="' + lblY.toFixed(1) + '" text-anchor="middle">' + esc(t.name.toUpperCase()) + '</text>'
        + '<text class="hrw-rp__sth-coremeta" x="' + cx + '" y="' + (lblY + 30).toFixed(1) + '" text-anchor="middle">' + esc(xpLabel) + '</text>'
        + (isCur ? '<text class="hrw-rp__sth-here" x="' + cx + '" y="' + (lblY + 55).toFixed(1) + '" text-anchor="middle">YOU ARE HERE</text>' : '')
        + '</g>';
      payload['c-' + i] = {
        icon: TIER_ICON[rank] || 'crown',
        name: esc(t.name),
        tag: reached ? (isCur ? 'You are here' : 'Reached') : 'Locked',
        body: (t.minLifetimeSpend > 0 ? 'Reached at ' + xp(t.minLifetimeSpend).toLocaleString() + ' XP. ' : 'Your starting rank. ') + 'Earn ' + t.creditsPerDollar + ' Credits per $1 spent.'
      };
    });

    // ---- the fixed info card (right third) ----
    var curColVar = TIER_COL[cur] || TIER_COL[TIER_COL.length - 1];
    function cardPerkList(rank, isNext) {
      var rows = [];
      (lay[rank] ? lay[rank].perks : []).forEach(function (p, k) {
        rows.push({ p: p, filled: rank === 0 || claimed.indexOf('p-' + rank + '-' + k) >= 0, next: isNext });
      });
      // non-tiered benefits (raffle, free garment, birthday …) granted at an
      // EARLIER rank carry forward onto every later tier's card — tiered ones
      // (discount I/II/III …) are superseded by this rank's own version, so
      // they don't stack. Only for the "at this rank" list, not the preview.
      if (!isNext) {
        for (var j = 0; j < rank; j++) {
          (lay[j] ? lay[j].perks : []).forEach(function (p, k) {
            if (perkTierNum(p, sorted)) return;
            rows.push({ p: p, filled: j === 0 || claimed.indexOf('p-' + j + '-' + k) >= 0, next: false, carried: true });
          });
        }
      }
      if (!rows.length) return '<li class="is-none">No new benefits at this rank.</li>';
      return rows.map(function (r) {
        var st = r.next ? 'is-soon' : (r.filled ? 'is-filled' : 'is-open');
        var rn = perkTierNum(r.p, sorted);
        return '<li class="' + st + (r.carried ? ' is-carried' : '') + '"><span class="hrw-rp__sth-card-pi">' + sthIconHtml(perkIconKey(r.p)) + '</span>'
          + '<span>' + esc(r.p) + (rn ? ' <em class="hrw-rp__sth-rn">' + romanNum(rn.num) + '</em>' : '') + '</span></li>';
      }).join('');
    }
    function tierColVar(rank) { return TIER_COL[rank] || TIER_COL[TIER_COL.length - 1]; }
    // the info card, for ANY tier — click a core node to swap it (Nick). The
    // <aside> carries --st-col, which drives the border + the rank title colour.
    function buildCard(rank) {
      var t = sorted[rank], reached = rank <= cur, isCur = rank === cur;
      var nxt = rank + 1 < N ? sorted[rank + 1] : null;
      var toNext = nxt ? Math.max(0, Math.round(nxt.minLifetimeSpend - spend)) : 0;
      return '<div class="hrw-rp__sth-card-top">'
          + '<span class="hrw-rp__sth-card-mark" style="--st-col: var(' + tierColVar(rank) + ');">' + sthIconHtml(TIER_ICON[rank] || 'crown') + '</span>'
          + '<div><p class="hrw-rp__sth-card-kicker">' + (isCur ? 'Your rank' : reached ? 'Reached' : 'Locked') + '</p>'
          + '<p class="hrw-rp__sth-card-name">' + esc(t.name) + '</p></div>'
        + '</div>'
        + '<p class="hrw-rp__sth-card-meta">' + (t.minLifetimeSpend > 0 ? 'Reached at ' + xp(t.minLifetimeSpend).toLocaleString() + ' XP' : 'Starting rank') + ' &middot; ' + t.creditsPerDollar + ' Credits per $1</p>'
        + '<p class="hrw-rp__sth-card-lbl">Benefits at this rank</p>'
        + '<ul class="hrw-rp__sth-card-perks">' + cardPerkList(rank, false) + '</ul>'
        + (nxt
            ? '<p class="hrw-rp__sth-card-lbl">Next - <span class="hrw-rp__sth-card-nextname" style="color: var(' + tierColVar(rank + 1) + ');">' + esc(nxt.name) + '</span>'
                + (rank + 1 <= cur ? '' : ' <span>' + xp(toNext).toLocaleString() + ' XP</span>') + '</p>'
              + '<ul class="hrw-rp__sth-card-perks hrw-rp__sth-card-perks--next">' + cardPerkList(rank + 1, true) + '</ul>'
            : '<p class="hrw-rp__sth-card-lbl">Top rank - every benefit is yours.</p>');
    }
    sthState.buildCard = buildCard;
    sthState.tierColVar = tierColVar;
    sthState.cur = cur;
    var cardHtml = buildCard(cur);
    var remain = comp.next ? Math.max(0, Math.round(comp.next.minLifetimeSpend - spend)) : 0;

    // The HUD (top bar) is the "quick glance"; here's the fuller version under
    // the tree — the same XP bar + skill-points, with a caption.
    sthState.availPts = availPts;
    if (typeof hrwRenderAdvHud === 'function') hrwRenderAdvHud();

    function miniBadge(rank) {
      var col = TIER_COL[rank] || TIER_COL[TIER_COL.length - 1];
      var ch = rank === TIER_COL.length - 1;
      return '<svg class="hrw-rp__sth-xp-badge" viewBox="0 0 30 30" style="--st-col: var(' + col + ');" aria-hidden="true">'
        + '<polygon class="hrw-rp__sth-xp-badge-hex" points="' + sthHex(15, 15, 13) + '"/>'
        + (ch ? '<path transform="translate(8.4 8.4) scale(0.55)" d="' + STH_STAR_D + '" fill="var(--tc-star-chosen, #ffd23d)"/>' : '')
        + '</svg>';
    }
    // real progress — no artificial minimum (an empty bar means 0 XP into the segment)
    var xpPctU = comp.next ? Math.max(0, Math.min(100, segPct * 100)) : 100;
    var inSegment = comp.next && spend > comp.current.minLifetimeSpend;   // show the "you are here" marker only once there's progress
    // skill points — the last item on the level-up bar's row (Nick)
    var skpHtml = '<div class="hrw-rp__sth-skp' + (availPts > 0 ? ' is-live' : '') + '">'
      + '<p class="hrw-rp__sth-skp-n"><span class="hrw-rp__sth-skp-ico">' + sthIconHtml('sparkle') + '</span><span>SP: ' + availPts + '</span></p>'
    + '</div>';
    // the level bar: track + the "you need … XP" line, held to 3/4 of the width;
    // the skill-point count sits on the same row to the right (Nick)
    var fromXP = comp.current.minLifetimeSpend > 0 ? xp(comp.current.minLifetimeSpend) : 0;
    var toXP = comp.next ? xp(comp.next.minLifetimeSpend) : 0;
    var nowXP = xp(spend);
    function xpTag(n) { return '<b class="hrw-rp__sth-xp-tag">' + n.toLocaleString() + '<span>XP</span></b>'; }
    function xpEnd(rank, tag) {
      return '<span class="hrw-rp__sth-xp-end">' + miniBadge(rank)
        + '<b class="hrw-rp__sth-xp-name">' + esc(sorted[rank].name) + '</b>'
        + (tag != null ? xpTag(tag) : '') + '</span>';
    }
    var xpHtml = '<div class="hrw-rp__sth-xp">'
      + '<div class="hrw-rp__sth-xp-row">'
        + '<div class="hrw-rp__sth-xp-main">'
          + '<div class="hrw-rp__sth-xp-bartrack">'
            + xpEnd(cur, fromXP)
            + '<div class="hrw-rp__sth-xp-track">'
              + '<i class="hrw-rp__sth-xp-fill" style="width:' + xpPctU.toFixed(1) + '%"></i>'
              + (inSegment ? '<b class="hrw-rp__sth-xp-now" style="left:' + xpPctU.toFixed(1) + '%">' + nowXP.toLocaleString() + '<span>XP</span></b>' : '')
            + '</div>'
            + xpEnd(comp.next ? cur + 1 : cur, comp.next ? toXP : null)
          + '</div>'
          + '<p class="hrw-rp__sth-xp-cap">' + (comp.next
              ? '<b>' + xp(remain).toLocaleString() + ' XP</b> to reach <b>' + esc(comp.next.name) + '</b>'
              : '<b>' + esc(comp.current.name) + '</b> - the top rank') + '</p>'
          + skpHtml
        + '</div>'
      + '</div>'
      + '</div>';

    host.innerHTML =
      '<div class="hrw-rp__sth-layout">'
        + '<div class="hrw-rp__sth-notice" data-sth-notice hidden></div>'
        + '<div class="hrw-rp__sth-toprow">'
          + '<div class="hrw-rp__sth-scroll" data-sth-scroll>'
            + '<svg class="hrw-rp__sth-svg" viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="Your rank progress as a skill tree">'
              + (clips ? '<defs>' + clips + '</defs>' : '')
              + spine + '<g>' + twigs + '</g>' + nodes
            + '</svg>'
          + '</div>'
          + '<div class="hrw-rp__sth-rightcol">'
            + '<aside class="hrw-rp__sth-card" data-sth-card style="--st-col: var(' + curColVar + ');">' + cardHtml + '</aside>'
          + '</div>'
        + '</div>'
        + xpHtml
      + '</div>'
      + '<div class="hrw-rp__sth-pop" data-sth-pop hidden>'
        + '<button type="button" class="hrw-rp__sth-pop-close" data-sth-pop-close aria-label="Close">&times;</button>'
        + '<div class="hrw-rp__sth-pop-hd"><span class="hrw-rp__sth-pop-ico" data-sth-pop-ico></span><span class="hrw-rp__sth-pop-name" data-sth-pop-name></span></div>'
        + '<span class="hrw-rp__sth-pop-tag" data-sth-pop-tag></span>'
        + '<p class="hrw-rp__sth-pop-body" data-sth-pop-body></p>'
        + '<p class="hrw-rp__sth-pop-cost" data-sth-pop-cost hidden><span class="hrw-rp__sth-pop-cost-ico">' + sthIconHtml('sparkle') + '</span><span data-sth-pop-cost-t></span></p>'
      + '</div>'
      // logged-out: a SIBLING of .sth-layout (not nested inside the tree),
      // so the dimming filter on .sth-layout never touches it — nesting it
      // inside .sth-scroll last round fixed the "too low" placement but
      // accidentally dimmed the pop-up itself too. Position is set below via
      // JS to match the tree's own box exactly (immune to the tree's
      // internal horizontal scroll offset, which is also why it wasn't
      // centred on desktop before). (Nick)
      + (loggedIn ? '' : '<div class="hrw-rp__sth-gate">' + hrwAuthGate('rank &amp; unlock perks') + '</div>');

    host.classList.toggle('is-gated', !loggedIn);

    // Size/position the gate to sit exactly over the tree's own rendered box.
    // host.innerHTML gets rebuilt on every theme switch / spend update, so
    // drop the previous run's resize listener first — otherwise each render
    // piles on another one pointing at now-detached elements.
    if (host.__gateResize) { window.removeEventListener('resize', host.__gateResize); host.__gateResize = null; }
    if (!loggedIn) {
      (function () {
        var gateEl = host.querySelector('.hrw-rp__sth-gate');
        // Cover the whole top row (tree + the "Your Rank" info card), not
        // just the tree's own scroll box — the gate was only ever as wide as
        // the tree, so on desktop it sat centred over that ~70% on the left
        // instead of the full row, with the info card exposed to its right
        // (Nick). Only above the ~900px breakpoint where .sth-toprow is
        // actually a ROW, though — below that it stacks (tree, then the
        // card, one above the other), so using the same combined box made
        // the gate cover that whole tall stacked area and centre itself way
        // down the page, past what's actually visible on a phone. Below
        // 900px, cover the tree's own box only, same as before that change.
        var toprowMQ = window.matchMedia && window.matchMedia('(min-width: 901px)');
        var scrollEl = ((toprowMQ && toprowMQ.matches) && host.querySelector('.hrw-rp__sth-toprow'))
          || host.querySelector('[data-sth-scroll]');
        if (!gateEl || !scrollEl) return;
        function positionGate() {
          scrollEl = ((toprowMQ && toprowMQ.matches) && host.querySelector('.hrw-rp__sth-toprow'))
            || host.querySelector('[data-sth-scroll]');
          if (!scrollEl) return;
          var hr = host.getBoundingClientRect(), sr = scrollEl.getBoundingClientRect();
          if (!sr.width || !sr.height) return;   // not laid out yet
          gateEl.style.top = (sr.top - hr.top) + 'px';
          gateEl.style.left = (sr.left - hr.left) + 'px';
          gateEl.style.width = sr.width + 'px';
          gateEl.style.height = sr.height + 'px';
        }
        positionGate();
        requestAnimationFrame(positionGate);
        setTimeout(positionGate, 260);   // rAF can stall in a background tab
        host.__gateResize = positionGate;
        window.addEventListener('resize', positionGate, { passive: true });
      })();
    }

    var fill = host.querySelector('.hrw-rp__sth-fill');
    if (fill) requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.strokeDashoffset = fill.getAttribute('data-off'); }); });

    wireSkillTreeH(host, payload);
    sthProgressNotices(host, cur, availPts, sorted);
  }

  // ---- Progress-panel notices: a tier-up celebration + an unused-skill-points
  //      nudge. Both only make sense for a signed-in member with real spend.
  var HRW_LAST_TIER_KEY = 'hrw-last-tier-' + (root.getAttribute('data-customer-id') || 'anon');
  function sthProgressNotices(host, cur, availPts, sorted) {
    // 1) moved up a tier since last visit → congratulate, once.
    //    Normally this is real signed-in spend, tracked in localStorage. In
    //    ?spend= test mode we still want to see it fire — tracked separately in
    //    sessionStorage so it can't clobber the member's real "last tier".
    var testMode = HRW_SPEND_OVERRIDE != null;
    if (sorted && sorted.length && (testMode || loggedIn)) {
      var store, key;
      try { store = testMode ? window.sessionStorage : window.localStorage; } catch (e) { store = null; }
      key = HRW_LAST_TIER_KEY + (testMode ? '-test' : '');
      var prev = null;
      try { prev = store && store.getItem(key); } catch (e) {}
      var prevN = prev == null ? null : parseInt(prev, 10);
      if (prevN != null && !isNaN(prevN) && cur > prevN) {
        // hrwCheckNewItems() (an "items received" popup, same [data-hrw-tierup]
        // marker) can run first in the same page load and leave its modal open
        // when we get here. hrwShowTierUp() now retries like that popup already
        // does — and, critically, "last tier seen" is only persisted once the
        // celebration actually shows, not unconditionally like before. The old
        // unconditional persist + no-retry bail meant a rank-up that lost this
        // race was gone for good: hrwShowTierUp gave up silently, but the tier
        // was already marked seen, so it never got a second chance (Nick).
        hrwShowTierUp(sorted[cur].name, cur, function () {
          try { if (store) store.setItem(key, String(cur)); } catch (e) {}
        });
      } else {
        try { if (store) store.setItem(key, String(cur)); } catch (e) {}
      }
    }
    // 2) unused skill points → a subtle pulsing pill above the tree
    var noticeEl = host.querySelector('[data-sth-notice]');
    if (!noticeEl) return;
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('hrw-skp-nudge-x') === '1'; } catch (e) {}
    if (availPts > 0 && !dismissed) {
      noticeEl.hidden = false;
      noticeEl.innerHTML =
        '<span class="hrw-rp__sth-notice-ico">' + sthIconHtml('sparkle') + '</span>'
        + '<span>You have <b>' + availPts + '</b> unused skill point' + (availPts === 1 ? '' : 's') + ' - press &amp; hold a ready node to spend.</span>'
        + '<button type="button" class="hrw-rp__sth-notice-x" aria-label="Dismiss">&times;</button>';
      noticeEl.querySelector('.hrw-rp__sth-notice-x').addEventListener('click', function () {
        noticeEl.hidden = true;
        try { sessionStorage.setItem('hrw-skp-nudge-x', '1'); } catch (e) {}
      });
    } else {
      noticeEl.hidden = true;
      noticeEl.innerHTML = '';
    }
  }

  function hrwShowTierUp(tierName, rank, onShown) {
    // don't stack over an "items received" modal firing in the same tick —
    // wait for it, same retry pattern as hrwShowItemsReceived below (which
    // already waits for THIS modal the same way).
    if (document.querySelector('[data-hrw-tierup]')) { setTimeout(function () { hrwShowTierUp(tierName, rank, onShown); }, 400); return; }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ov = document.createElement('div');
    ov.className = 'hrw-rp__tierup';
    hrwStampTheme(ov);
    ov.setAttribute('data-hrw-tierup', '');
    ov.innerHTML =
      '<div class="hrw-rp__tierup-box" role="dialog" aria-modal="true" aria-label="Rank up">'
      + '<button type="button" class="hrw-rp__tierup-x" aria-label="Close">&times;</button>'
      + '<p class="hrw-rp__tierup-eyebrow">Rank up</p>'
      + '<p class="hrw-rp__tierup-name">' + esc(tierName) + '</p>'
      + '<p class="hrw-rp__tierup-sub">You’ve climbed to a new rank since your last visit.</p>'
      + '<button type="button" class="hrw-rp__tierup-cta" data-hrw-tierup-see>See what you’ve unlocked</button>'
      + '</div>';
    document.body.appendChild(ov);
    if (onShown) onShown();
    function close() { ov.classList.remove('is-open'); window.setTimeout(function () { ov.remove(); }, 240); }
    ov.querySelector('.hrw-rp__tierup-x').addEventListener('click', close);
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });
    ov.querySelector('[data-hrw-tierup-see]').addEventListener('click', function () {
      close();
      if (root.getAttribute('data-hrw-theme') === 'start-menu' && typeof window.__hrwAdvNav === 'function') window.__hrwAdvNav('progress', false);
      if (sthState && typeof sthState.showTier === 'function') sthState.showTier(rank);
      // Outside Start Menu the tiers are <details> drawers, and below 750px they
      // render CLOSED — so "See what you've unlocked" used to dismiss the modal
      // and leave the member looking at a shut drawer with no indication of
      // which one to open (Nick). Open the new rank's drawer, bring it into
      // view, and put focus on it so a screen reader lands there too.
      // Matched on the tier NAME, not the rank index: the cards render in
      // catalog order while `rank` counts up the spend-sorted list, and those
      // two orders are not guaranteed to agree.
      var want = String(tierName || '').trim().toLowerCase();
      var card = [].slice.call(root.querySelectorAll('.hrw-rp__tier-card')).filter(function (c) {
        var nm = c.querySelector('.hrw-rp__tier-name');
        return nm && nm.textContent.trim().toLowerCase() === want;
      })[0];
      if (!card) return;
      card.open = true;
      var sum = card.querySelector('.hrw-rp__tier-summary');
      if (sum) {
        // -1 so it can take focus without joining the tab order, which a
        // <summary> is already in.
        if (!sum.hasAttribute('tabindex')) sum.setAttribute('tabindex', '-1');
        try { sum.focus({ preventScroll: true }); } catch (e) {}
      }
      try {
        card.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      } catch (e) { card.scrollIntoView(); }
    });
    if (reduce) { ov.classList.add('is-open'); return; }
    void ov.offsetWidth;
    ov.classList.add('is-open');
  }

  // hover / tap detail tooltip + skill-point claiming for the skill-tree nodes
  function wireSkillTreeH(host, payload) {
    var pop = host.querySelector('[data-sth-pop]');
    var scroll = host.querySelector('[data-sth-scroll]');
    var svg = host.querySelector('.hrw-rp__sth-svg');
    if (!pop || !svg) return;
    var elIco = pop.querySelector('[data-sth-pop-ico]');
    var elName = pop.querySelector('[data-sth-pop-name]');
    var elTag = pop.querySelector('[data-sth-pop-tag]');
    var elBody = pop.querySelector('[data-sth-pop-body]');
    var elCost = pop.querySelector('[data-sth-pop-cost]');
    var elCostT = pop.querySelector('[data-sth-pop-cost-t]');
    var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
    var selected = null, pinned = false, closeT = null;

    function close() {
      clearTimeout(closeT);
      pop.hidden = true;
      pop.classList.remove('is-open');
      pop.style.top = ''; pop.style.bottom = '';
      if (selected) selected.classList.remove('is-selected');
      selected = null; pinned = false;
    }
    function scheduleClose() { clearTimeout(closeT); closeT = setTimeout(close, 130); }
    function cancelClose() { clearTimeout(closeT); }

    function openFor(g, pin) {
      // core nodes drive the info card (see below), not the hover pop-up
      if ((g.getAttribute('data-sth-node') || '').charAt(0) === 'c') return;
      var d = payload[g.getAttribute('data-sth-node')];
      if (!d) return;
      clearTimeout(closeT);
      if (selected && selected !== g) selected.classList.remove('is-selected');
      selected = g;
      g.classList.add('is-selected');
      pinned = pinned || !!pin;
      elName.innerHTML = d.name;   // d.name is pre-escaped; may carry a <span> numeral
      elTag.textContent = d.tag;
      elBody.textContent = d.body;
      if (elCost) {
        elCost.hidden = !d.cost;
        if (elCostT) elCostT.textContent = d.cost || '';
      }
      elIco.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">' + (STH_ICONS[d.icon] || STH_ICONS.sparkle) + '</svg>';
      pop.hidden = false;
      pop.classList.toggle('is-pinned', pinned);
      var gr = g.getBoundingClientRect();
      var hr = host.getBoundingClientRect();
      // core <g>s also contain their label text near the bottom of the SVG, so
      // their box is tall — always float the core pop-up just above the hex,
      // never below (which landed it way down by the labels).
      var isCore = (g.getAttribute('data-sth-node') || '').charAt(0) === 'c';
      var below = !isCore && (gr.top - hr.top) < host.clientHeight * 0.5;
      pop.style.left = (gr.left + gr.width / 2 - hr.left) + 'px';
      if (below) { pop.style.top = (gr.bottom - hr.top + 10) + 'px'; pop.style.bottom = ''; }
      else { pop.style.bottom = (hr.bottom - gr.top + 10) + 'px'; pop.style.top = ''; }
      // clamp to the VIEWPORT (not just the host) so a right-edge node's pop-up
      // can't run its title off the screen (Nick). Run it now (rAF can stall in
      // a background tab), again on rAF, and once more after a beat.
      function clampPop() {
        var pr = pop.getBoundingClientRect();
        var vw = document.documentElement.clientWidth || window.innerWidth;
        var m = 10;
        var overR = pr.right - (vw - m);
        if (overR > 0) { pop.style.left = ((parseFloat(pop.style.left) || 0) - overR) + 'px'; pr = pop.getBoundingClientRect(); }
        var overL = m - pr.left;
        if (overL > 0) pop.style.left = ((parseFloat(pop.style.left) || 0) + overL) + 'px';
      }
      clampPop();
      pop.classList.add('is-open');
      requestAnimationFrame(clampPop);
      setTimeout(clampPop, 60);
    }

    function claim(pid) {
      var arr = hrwLoadSkp();
      if (arr.indexOf(pid) < 0) { arr.push(pid); hrwSaveSkp(arr); }
      if (sthState.tiers) renderSkillTreeH(sthState.tiers, sthState.spend);
    }
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var HOLD_MS = 720;
    // press-and-hold a claimable node: the diamond fills from the bottom, then unlocks
    function bindHold(g) {
      var pid = g.getAttribute('data-sth-hold');
      var timer = null, fired = false;
      function begin(e) {
        if (fired) return;
        if (e && e.cancelable) e.preventDefault();
        g.classList.add('is-holding');
        clearTimeout(timer);
        timer = setTimeout(function () { fired = true; g.classList.remove('is-holding'); claim(pid); }, reduceMotion ? 340 : HOLD_MS);
      }
      function end() { clearTimeout(timer); if (!fired) g.classList.remove('is-holding'); }
      g.addEventListener('pointerdown', begin);
      g.addEventListener('pointerup', end);
      g.addEventListener('pointerleave', end);
      g.addEventListener('pointercancel', end);
      g.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') && !e.repeat) begin(e);
      });
      g.addEventListener('keyup', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') end();
      });
    }

    // Desktop: hover (or keyboard focus) peeks the info card. Touch / no-hover
    // devices can't hover, so there a TAP on a node pins its description open
    // (tap the same node again, or anywhere off it, to close). Press-and-hold on
    // a claimable node still spends a skill point regardless of input type.
    svg.querySelectorAll('[data-sth-node]').forEach(function (g) {
      if (g.hasAttribute('data-sth-hold')) bindHold(g);
      if (canHover) {
        g.addEventListener('mouseenter', function () { openFor(g, false); });
        g.addEventListener('mouseleave', scheduleClose);
        g.addEventListener('focus', function () { openFor(g, false); });   // keyboard peek
        g.addEventListener('blur', scheduleClose);
      } else {
        g.addEventListener('click', function () {
          if (selected === g && !pop.hidden) { close(); }
          else { pinned = false; openFor(g, true); }
        });
      }
    });
    // clicking a CORE node swaps the info card to that tier's view (Nick).
    // The <aside>'s --st-col + .is-locked-tier drive the border (solid tier
    // colour when reached, dashed + faded when still locked) and the title hue.
    var cardEl = host.querySelector('[data-sth-card]');
    var coreSel = null;
    function showTierCard(rank) {
      if (!cardEl || typeof sthState.buildCard !== 'function') return;
      cardEl.innerHTML = sthState.buildCard(rank);
      cardEl.classList.toggle('is-locked-tier', rank > sthState.cur);
      cardEl.style.setProperty('--st-col', 'var(' + sthState.tierColVar(rank) + ')');
      try { cardEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
    }
    sthState.showTier = showTierCard;
    svg.querySelectorAll('[data-sth-node^="c-"]').forEach(function (g) {
      var rank = parseInt(g.getAttribute('data-sth-node').slice(2), 10);
      function pick(e) {
        if (e) e.preventDefault();
        if (coreSel && coreSel !== g) coreSel.classList.remove('is-selected');
        coreSel = g; g.classList.add('is-selected');
        close();               // never also show the pop-up
        showTierCard(rank);
      }
      g.addEventListener('click', pick);
      g.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') pick(e);
      });
    });

    pop.addEventListener('mouseenter', cancelClose);
    pop.addEventListener('mouseleave', scheduleClose);
    pop.querySelector('[data-sth-pop-close]').addEventListener('click', close);
    if (scroll) scroll.addEventListener('scroll', close, { passive: true });

    if (host.__sthDoc) document.removeEventListener('click', host.__sthDoc);
    if (host.__sthKey) document.removeEventListener('keydown', host.__sthKey);
    host.__sthDoc = function (e) {
      if (pop.hidden) return;
      if (pop.contains(e.target)) return;
      if (e.target.closest && e.target.closest('[data-sth-node]')) return;
      close();
    };
    host.__sthKey = function (e) { if (e.key === 'Escape') close(); };
    document.addEventListener('click', host.__sthDoc);
    document.addEventListener('keydown', host.__sthKey);
  }

  // ---- catalog: tiers / earn rules / rewards (direct CORS, no App Proxy needed) ----
  fetch(catalogUrl)
    .then(function (r) { if (!r.ok) throw new Error('catalog ' + r.status); return r.json(); })
    .then(function (data) {
      hrwCatalog = { tiers: data.tiers || [], earnRules: data.earnRules || [], rewards: data.rewards || [] };
      renderTiers(data.tiers || [], null); // rank unknown until the balance fetch also resolves
      // rewards kept too, so the list can be RE-RENDERED once the balance
      // lands — see the balance handler. Without them the only render of the
      // rewards list happens before we know who the member is.
      hrwLastCatalog = { rules: data.earnRules || [], tiers: data.tiers || [], rewards: data.rewards || [] };
      renderEarn(hrwLastCatalog.rules, hrwLastCatalog.tiers);
      renderRewards(data.rewards || []);
      // The bank is its own fetch — it is per-member, not part of the shared
      // catalog, and must not delay the catalog render if the proxy is slow.
      loadBank();
      loadWardrobe();
      levelUpState.tiers = data.tiers || [];
      window.__hrwTierMapTiers = data.tiers || [];   // feed the map the live catalog
      // ?spend= override doesn't wait on the balance fetch
      if (HRW_SPEND_OVERRIDE != null && levelUpState.lifetimeSpend == null) levelUpState.lifetimeSpend = HRW_SPEND_OVERRIDE;
      maybeRenderLevelUp();
      // maybeRenderLevelUp bails when the logged-out section has no [data-levelup]
      // — the Start Menu skill tree still needs drawing once spend is known
      // (0 for logged-out visitors, or the ?spend= override).
      if (levelUpState.tiers && levelUpState.lifetimeSpend != null) {
        renderSkillTreeH(levelUpState.tiers, levelUpState.lifetimeSpend);
      }
      hrwRefreshAdvPanels();   // (re)build the Start Menu Quests / Item Shop lists
    })
    .catch(function () {
      var msg = 'Couldn’t load right now - try refreshing.';
      [['data-tiers-loading'], ['data-earn-loading'], ['data-rewards-loading']].forEach(function (sel) {
        var el = root.querySelector('[' + sel[0] + ']');
        if (el) el.textContent = msg;
      });
      var levelupLoading = root.querySelector('[data-levelup-loading]');
      if (levelupLoading) levelupLoading.textContent = 'Couldn’t load right now - try refreshing.';
    });

  // Circular badge per tier — CSS gradient, not an image, so it needs no
  // asset and can't be mistaken for anyone else's mark. Tier name is
  // trusted here (it's operator-entered copy from PLM's admin, same trust
  // level as every other catalog field already rendered elsewhere on this
  // page without escaping concern for CSS class lookups) but still matched
  // case-insensitively with a plain default rather than assumed.
  // Badge color is assigned by RANK (ascending minLifetimeSpend), not by
  // matching the tier's own name — names are operator-editable free text
  // (2026-08-27: renamed off the literal metal names to house terms, e.g.
  // "Bum"/"Hustler"/"Breadman"/"Big Chedda"/"C-suite"), so a name-keyed
  // lookup would silently fall back to the same color for every tier the
  // moment the wording changed. Ranking instead means the five colors
  // always read low-to-high regardless of what the tiers are called.
  var TIER_BADGE_CLASSES_BY_RANK = ['is-bronze', 'is-silver', 'is-gold', 'is-diamond', 'is-onyx'];
  function badgeClassForRank(rank) {
    return TIER_BADGE_CLASSES_BY_RANK[rank] || TIER_BADGE_CLASSES_BY_RANK[TIER_BADGE_CLASSES_BY_RANK.length - 1];
  }
  // Classic (Light/Dark) tier badges use the same rank marks as the Start Menu
  // skill tree — sword / binoculars / compass / cape / crown (Nick).
  function tierBadgeIcon(rank) { return sthIconHtml(TIER_ICON[rank] != null ? TIER_ICON[rank] : 'crown'); }

  /**
   * Current tier is the HIGHEST tier whose minLifetimeSpend the customer
   * has cleared — mirrors lib/loyalty/award.ts's currentTier on the PLM
   * side exactly (last qualifying tier wins, tiers sorted ascending),
   * shared by renderTiers (which tier to highlight) and renderLevelUp
   * (which two badges to show) so the two sections can never disagree
   * about which tier a shopper is actually in.
   */
  function computeCurrentTier(tiers, lifetimeSpend) {
    var sorted = tiers.slice().sort(function (a, b) { return a.minLifetimeSpend - b.minLifetimeSpend; });
    var currentIndex = 0;
    for (var i = 0; i < sorted.length; i++) {
      if (lifetimeSpend >= sorted[i].minLifetimeSpend) currentIndex = i;
    }
    return { sorted: sorted, currentIndex: currentIndex, current: sorted[currentIndex], next: sorted[currentIndex + 1] };
  }

  // Cached so a resize crossing the 750px breakpoint can re-render tiers
  // with the right `open` state (see renderTiers) without re-fetching.
  var lastTiersRender = { tiers: null, currentRank: null };
  (function () {
    var resizeTimer = null;
    var wasDesktop = window.innerWidth >= 750;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var isDesktop = window.innerWidth >= 750;
        if (isDesktop === wasDesktop) return; // only re-render on an actual breakpoint crossing
        wasDesktop = isDesktop;
        if (lastTiersRender.tiers) renderTiers(lastTiersRender.tiers, lastTiersRender.currentRank);
      }, 150);
    }, { passive: true });
  })();

  function renderTiers(tiers, currentRank) {
    var list = root.querySelector('[data-tiers-list]');
    if (!list) return;
    lastTiersRender.tiers = tiers;
    lastTiersRender.currentRank = currentRank;
    if (!tiers.length) { list.innerHTML = '<p class="hrw-rp__loading">Tiers are on their way.</p>'; return; }
    // Desktop (≥750px) cards are meant to always read as open — genuinely
    // setting `open` here, rather than only overriding `display` in CSS, is
    // deliberate: Chromium/WebKit internally mark a closed <details>'s
    // content content-visibility:hidden, which a plain `display` override
    // does NOT undo — the content sits in the DOM at the right size but
    // never paints until something forces the browser to redo the <details>
    // layout (e.g. a native open/close toggle). That produced exactly this:
    // tier bodies invisible on first paint, appearing only after a click.
    // Setting the real attribute sidesteps the quirk instead of fighting it.
    // Start Menu mode always wants the collapsed drawer stack (it sits UNDER the
    // map, where a row of always-open desktop cards would be a wall of text).
    var forceOpen = window.innerWidth >= 750 && root.getAttribute('data-hrw-theme') !== 'start-menu';
    // Rank (ascending by minLifetimeSpend), not the tier's own array
    // position — renderLevelUp's computeCurrentTier sorts the same way, so
    // a rank computed here always lines up with the currentRank it passes in.
    var sortedForRank = tiers.slice().sort(function (a, b) { return a.minLifetimeSpend - b.minLifetimeSpend; });
    list.innerHTML = tiers.map(function (t) {
      var perks = [];
      if (t.discountPercent) perks.push(t.discountPercent + '% ' + (t.discountScope === 'first_order' ? 'discount on your first order' : 'permanent discount'));
      if (t.freeShippingAllowance) perks.push(hrwShipPerk(t.freeShippingAllowance));
      if (t.earlyAccessHours) perks.push('Early access (' + t.earlyAccessHours + 'h before)');
      if (t.extendedReturns) perks.push('Extended returns');
      (t.otherPerks || []).forEach(function (p) { perks.push(p); });
      var req = t.minLifetimeSpend > 0 ? ('Spend $' + t.minLifetimeSpend) : 'Start here';
      var rank = sortedForRank.indexOf(t);
      var badgeClass = badgeClassForRank(rank);
      // "Collecting" progression (2026-08-27, replacing a single
      // current-tier-only highlight, per the operator: leveling up should
      // read as accumulating badges, not the highlight jumping from one
      // card to the next): every tier at or below the customer's current
      // rank stays permanently highlighted, each in its own color — only
      // applies once lifetimeSpend is known (see maybeRenderLevelUp); a
      // logged-out visitor or one whose balance hasn't loaded yet just sees
      // plain cards, never a wrongly-highlighted one.
      var isAchieved = currentRank !== null && currentRank !== undefined && rank <= currentRank;
      var isCurrent = currentRank !== null && currentRank !== undefined && rank === currentRank;
      // Collapsed by default below 750px — no `open` attribute, matching
      // the operator's reference — and genuinely open at 750px+ (see
      // forceOpen above). Native <details>, same zero-JS-required pattern
      // as the FAQ below; the chevron is pure CSS off [open].
      // name= groups them as a native exclusive accordion (Chrome 120+ /
      // Safari 17.4+ / Firefox 122+, harmlessly ignored as a plain <details>
      // on anything older) — opening one closes whichever else was open, no
      // JS needed. ONLY on mobile though (forceOpen false): a same-named
      // group can only have ONE member open at a time — the browser
      // enforces that the instant multiple get `open` at once, not just on
      // a user click — so adding it unconditionally silently closed every
      // desktop card except one the moment they all rendered force-open
      // together, making their info disappear with no interaction at all
      // (Nick).
      // is-current is a HOOK, not a look: the "You are here" tag used to be the
      // only marker of the current tier, so a theme that wanted to show it any
      // other way had nothing to hang that on. Classic hides the tag and draws a
      // ring instead (Nick); the other views still use the tag.
      return '<details' + (forceOpen ? ' open' : ' name="hrw-tiers-accordion"') + ' class="hrw-rp__tier-card' + (isAchieved ? ' is-achieved ' + badgeClass : '') + (isCurrent ? ' is-current' : '') + '">' +
        '<summary class="hrw-rp__tier-summary">' +
          '<span class="hrw-rp__tier-badge ' + badgeClass + '" aria-hidden="true">' + tierBadgeIcon(rank) + '</span>' +
          '<span class="hrw-rp__tier-name">' + escapeHtml(t.name) + '</span>' +
          (isCurrent ? '<span class="hrw-rp__tier-here">You are here</span>' : '') +
          '<svg class="hrw-rp__tier-chevron" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</summary>' +
        '<div class="hrw-rp__tier-body">' +
          '<p class="hrw-rp__tier-req">' + escapeHtml(req) + '</p>' +
          // NBSP between "per" and "$1" (Nick, 2026-09-09: "the $1 is below
          // sometimes yk? hate that"). It never breaks there, so the only place
          // this line can wrap is after "CREDITS" — two balanced halves instead
          // of a stranded unit. The CSS below shrinks it to fit first; this is
          // what governs the wrap when a card is too narrow even for that.
          '<div class="hrw-rp__tier-rate">' + t.creditsPerDollar + ' credits per\u00a0$1</div>' +
          '<ul class="hrw-rp__tier-perks">' + perks.map(function (p) {
            return '<li><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="11" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M7.5 12.5l3 3 6-6.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + escapeHtml(p) + '</span></li>';
          }).join('') + '</ul>' +
        '</div>' +
        '</details>';
    }).join('');
  }

  function renderLevelUp(tiers, lifetimeSpend) {
    // there can be TWO mounts: the standalone Level Up section (Light/Dark) and
    // the copy inside Start Menu's Progress panel — fill whichever exist.
    var els = root.querySelectorAll('[data-levelup]');
    if (!els.length) return;
    var el = { set innerHTML(h) { for (var i = 0; i < els.length; i++) els[i].innerHTML = h; } };
    if (!tiers.length) { el.innerHTML = '<p class="hrw-rp__loading">Tiers are on their way.</p>'; return; }

    var computed = computeCurrentTier(tiers, lifetimeSpend);
    var current = computed.current;
    var next = computed.next;
    var currentBadgeClass = badgeClassForRank(computed.currentIndex);

    if (!next) {
      // Top tier already reached — no bar to show, nothing further to
      // level up toward.
      el.innerHTML =
        '<div class="hrw-rp__levelup-track">' +
          '<div class="hrw-rp__levelup-badge-wrap">' +
            '<span class="hrw-rp__tier-badge ' + currentBadgeClass + '">' + tierBadgeIcon(computed.currentIndex) + '</span>' +
            '<span class="hrw-rp__levelup-tier-label">' + escapeHtml(current.name) + '</span>' +
          '</div>' +
        '</div>' +
        '<p class="hrw-rp__levelup-caption">You&rsquo;ve reached our top tier - welcome to <strong>' + escapeHtml(current.name) + '</strong>.</p>';
      return;
    }

    var nextBadgeClass = badgeClassForRank(computed.currentIndex + 1);
    var span = next.minLifetimeSpend - current.minLifetimeSpend;
    var progressed = lifetimeSpend - current.minLifetimeSpend;
    var pct = span > 0 ? Math.max(0, Math.min(100, (progressed / span) * 100)) : 0;
    var remaining = Math.max(0, next.minLifetimeSpend - lifetimeSpend);
    // Start Menu reframes lifetime spend as "XP" and drops the dollar signs.
    var adv = root.getAttribute('data-hrw-theme') === 'start-menu';
    var lvNow = adv ? ((Math.round(lifetimeSpend) * 100).toLocaleString() + ' XP') : ('$' + Math.round(lifetimeSpend));
    var lvNext = adv ? ((next.minLifetimeSpend * 100).toLocaleString() + ' XP') : ('$' + next.minLifetimeSpend);
    var caption = adv
      ? 'You need <strong>' + (remaining * 100).toLocaleString() + ' XP</strong> to advance to <strong>' + escapeHtml(next.name) + '</strong>.'
      : 'Spend <strong>$' + remaining + '</strong> to advance to <strong>' + escapeHtml(next.name) + '</strong>.';

    el.innerHTML =
      '<div class="hrw-rp__levelup-track">' +
        '<div class="hrw-rp__levelup-badge-wrap">' +
          '<span class="hrw-rp__tier-badge ' + currentBadgeClass + '">' + tierBadgeIcon(computed.currentIndex) + '</span>' +
          '<span class="hrw-rp__levelup-tier-label">' + escapeHtml(current.name) + '</span>' +
          '<span class="hrw-rp__levelup-spend-label">' + lvNow + '</span>' +
        '</div>' +
        '<div class="hrw-rp__levelup-bar"><div class="hrw-rp__levelup-bar-fill" style="width:' + pct + '%"></div></div>' +
        '<div class="hrw-rp__levelup-badge-wrap">' +
          '<span class="hrw-rp__tier-badge ' + nextBadgeClass + '">' + tierBadgeIcon(computed.currentIndex + 1) + '</span>' +
          '<span class="hrw-rp__levelup-tier-label">' + escapeHtml(next.name) + '</span>' +
          '<span class="hrw-rp__levelup-spend-label">' + lvNext + '</span>' +
        '</div>' +
      '</div>' +
      '<p class="hrw-rp__levelup-caption">' + caption + '</p>';
  }

  // Small generic line-art icons, drawn here rather than pulled from any
  // third party — an "Instagram-ish" or "Facebook-ish" icon in particular
  // is deliberately generic (a plain camera outline, a plain thumbs-up),
  // never a reproduction of either platform's actual registered logo.
  /**
   * WHAT A REWARD CARD OFFERS — decided once, rendered twice.
   *
   * The Light/Dark list and the Start Menu quest panel are separate renderers
   * with different markup, and each used to decide this for itself. They have
   * now drifted three times: Start Menu was still showing Follow+Claim after the
   * self-claiming Follow shipped, still had no Shop now on Make a purchase, no
   * newsletter form, and its own inconsistent login labels (Nick spotted all
   * three). Sharing the DECISION and leaving each renderer only its markup is
   * the fix — a fourth divergence should not be possible.
   *
   * Returns descriptors, not HTML, because the two renderers cannot share
   * markup: one builds an HTML string, the other pushes objects with callbacks.
   *   { type: 'state',  label }                     → disabled chip
   *   { type: 'link',   label, href, blank, claims } → anchor; claims = self-claiming follow
   *   { type: 'form',   form: 'subscribe' }          → the inline newsletter form
   *   { type: 'action', label, action, ruleKey }     → button that runs JS
   */
  /**
   * Sit the shade toggle ON THE SAME LINE as the view switch, to its left.
   *
   * Measured rather than guessed, and deliberately WITHOUT touching the
   * switch's own CSS or markup — Nick asked for the toggle to line up and for
   * that switch to be left alone. Its offset is not the plain right:28px its
   * rule declares (measured live: the switch's right edge sits 50px inside the
   * toggle's), so any hard-coded offset here would be wrong at some width.
   *
   * Both are absolutely positioned in .hrw-rp, so offsetTop/offsetLeft share an
   * origin — as long as the switch has not docked to <body> under 640px, where
   * the CSS takes over and inline positioning would fight it.
   */
  var HRW_SHADE_GAP = 10;

  function placeShade(btn) {
    var sw = document.querySelector('[data-themeswitch]');
    var op = btn.offsetParent;
    if (!sw || !op || sw.classList.contains('is-docked') || sw.offsetParent !== op) {
      btn.style.top = ''; btn.style.left = ''; btn.style.right = '';
      return;
    }
    // The room to the switch's right is reserved in CSS (a permanent
    // margin-right on .hrw-rp__themeswitch), NOT set here. It used to be set
    // here and cleared when the toggle hid, which meant the switch itself slid
    // sideways every time you moved to or from Start Menu — the toggle
    // appearing should not move the menu (Nick). Reserved always, the switch
    // never moves and only the toggle comes and goes inside the gap.
    // MEASURE WITH RECTS, NOT offsetTop/offsetLeft. Above 1181px the switch
    // carries `transform: translateY(-50%)`, and offsetTop reports the
    // PRE-transform box — so centring on it put the toggle exactly half a
    // switch-height (16px) too low, which is the misalignment Nick saw.
    // getBoundingClientRect sees where the switch actually ended up.
    var o = op.getBoundingClientRect();
    var s = sw.getBoundingClientRect();
    var b = btn.getBoundingClientRect();
    // Rects are border-box and viewport-relative; `top`/`left` resolve against
    // the offsetParent's PADDING box, so its border has to come off.
    var ocs = getComputedStyle(op);
    var oTop = o.top + (parseFloat(ocs.borderTopWidth) || 0);
    var oLeft = o.left + (parseFloat(ocs.borderLeftWidth) || 0);
    // Vertically centred on the switch, and one gap to its LEFT (Nick,
    // 2026-09-09 — it sat to the RIGHT until now). Only this branch changes:
    // the docked/mobile toggle returns early above and keeps its own corner.
    btn.style.top = Math.round(s.top - oTop + (s.height - b.height) / 2) + 'px';
    btn.style.left = Math.round(s.left - oLeft - HRW_SHADE_GAP - b.width) + 'px';
    btn.style.right = 'auto';
  }

  /* The consent line under the email field (sign-up fix plan, 2026-10-14). The
     text is the section's "Consent line" setting (rich text, so it carries the
     Privacy Policy link); blank falls back to the standard line, so the box can
     never collect an email with no notice. Same line as the footer and the other
     website boxes (snippets/haki-signup-consent.liquid). */
  var HRW_CONSENT_DEFAULT = 'News, drops, behind the scenes, and offers from Haki Studios. Unsubscribe anytime. <a href="/policies/privacy-policy">Privacy Policy</a>';
  var hrwConsentLine = (root.getAttribute('data-consent-line') || '').trim() || HRW_CONSENT_DEFAULT;
  var hrwConsentSeq = 0;

  /** The newsletter form — one builder, both views. */
  function hrwSubscribeFormHtml() {
    // The form can be on the page twice (card + phone modal), so each copy gets
    // its own id for aria-describedby.
    var consentId = 'hrw-sub-consent-' + (++hrwConsentSeq);
    return '<form class="hrw-rp__sub" method="post" action="/contact" accept-charset="UTF-8">'
      + '<input type="hidden" name="form_type" value="customer" />'
      + '<input type="hidden" name="utf8" value="&#10003;" />'
      + '<input type="hidden" name="contact[tags]" value="newsletter" />'
      + '<input type="hidden" name="return_to" value="/pages/rewards" />'
      // Locked to the account address when signed in: the credit follows the
      // record the ADDRESS belongs to, not whoever is signed in.
      + (customerEmail
          ? '<input type="email" name="contact[email]" required readonly aria-label="Your email address" aria-describedby="' + consentId + '" value="' + escapeHtml(customerEmail) + '" />'
          : '<input type="email" name="contact[email]" required autocomplete="email" spellcheck="false" placeholder="Email address" aria-label="Email address" aria-describedby="' + consentId + '" />')
      + '<button type="submit" class="hrw-rp__reward-btn">Subscribe</button>'
      + '<p class="hrw-rp__sub-consent" id="' + consentId + '">' + hrwConsentLine + '</p>'
      + '</form>';
  }

  /** Phones only (see the CSS): opens the signup form in a small modal. */
  function hrwSubscribeOpenBtnHtml() {
    return '<button type="button" class="hrw-rp__reward-btn hrw-rp__sub-open" data-sub-open>Subscribe</button>';
  }

  function hrwSubModal() {
    var el = root.querySelector('[data-sub-modal]');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'hrw-rp__submodal';
    el.setAttribute('data-sub-modal', '');
    el.hidden = true;
    el.innerHTML =
      '<div class="hrw-rp__submodal-scrim" data-sub-close></div>' +
      '<div class="hrw-rp__submodal-box" role="dialog" aria-modal="true" aria-label="Sign up to our newsletter">' +
        '<button type="button" class="hrw-rp__submodal-x" data-sub-close aria-label="Close">&times;</button>' +
        '<p class="hrw-rp__submodal-t">Sign up to our newsletter</p>' +
        '<div data-sub-slot></div>' +
      '</div>';
    root.appendChild(el);
    el.addEventListener('click', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-sub-close')) hrwCloseSubModal();
    });
    return el;
  }

  function hrwCloseSubModal() {
    var el = root.querySelector('[data-sub-modal]');
    if (!el || el.hidden) return;
    // Emptied rather than left in place: a closed modal holding a half-typed
    // address would hand it back on the next open, which reads as the page
    // remembering something it was never told to keep.
    el.querySelector('[data-sub-slot]').innerHTML = '';
    el.hidden = true;
  }

  function hrwOpenSubModal() {
    var el = hrwSubModal();
    el.querySelector('[data-sub-slot]').innerHTML = hrwSubscribeFormHtml();
    el.hidden = false;
    var input = el.querySelector('input[type="email"]');
    if (input && !input.readOnly) { try { input.focus(); } catch (e) {} }
  }

  function hrwCardActions(n, ctx) {
    var key = n.key;
    var earnState = ctx.earnState;
    var canEarn = ctx.loggedIn || EARNS_LOGGED_OUT[key];

    // The friend code, whether or not they have earned from it yet. Handled
    // before the earnState branch for the UNEARNED case and inside it for the
    // earned one, because referral is the only quest that stays live forever.
    if (key === 'refer_friend' && canEarn && !earnState) {
      return [{ type: 'action', label: hrwReferralCode ? 'Copy your code' : 'Get your code', action: 'referral' }];
    }

    if (earnState) {
      // THE QUIZ STAYS USEFUL AFTER IT IS DONE (Nick, 2026-09-09). Its answers
      // are a profile, not a score, and somebody whose taste has moved on
      // should be able to correct what we hold — so a finished quiz offers
      // "Retake quiz" instead of an inert past-tense chip. The tile still reads
      // as complete: the greyed styling comes from earnState, not from this
      // button, so only the label changes.
      //
      // No new endpoint and nothing to guard against: PLM's saveQuiz already
      // OVERWRITES on a retake, awardEarnRuleCredits is idempotent per member
      // so a retake pays nothing, and the dialog already pre-fills from
      // GET /quiz — so the member opens it on their previous answers rather
      // than a blank form. This is the button that was missing, not a feature.
      if (key === 'anime_quiz' && canEarn) {
        return [{ type: 'action', label: 'Retake quiz', action: 'quiz' }];
      }
      // REFERRAL NEVER FINISHES (§3.4). Every other earned quest is done, but a
      // member who has brought one friend can bring another — so an earned
      // refer_friend still offers the code rather than going inert. Falls
      // through to the same branch as an unearned one below.
      if (key === 'refer_friend' && canEarn) {
        return [{ type: 'action', label: hrwReferralCode ? 'Copy your code' : 'Get your code', action: 'referral' }];
      }
      // A quest that comes back says WHEN, not what (Nick, 2026-09-09) — the
      // countdown is the only thing on a finished tile a member cannot work out
      // by looking at it, and it now lives on the button rather than floating
      // over the card. A quest that never comes back has no countdown to show,
      // so it keeps its past-tense verb.
      var days = earnState.resetAt ? hrwDaysUntil(earnState.resetAt) : null;
      if (days) {
        var dtxt = days + (days === 1 ? ' day' : ' days');
        return [{ type: 'state', label: dtxt, html: HRW_HOURGLASS_SVG + escapeHtml(dtxt) }];
      }
      return [{ type: 'state', label: earnState.verb }];
    }

    if (key === 'purchase') {
      return [{ type: 'link', label: EARN_LINKS.purchase.label, href: EARN_LINKS.purchase.href }];
    }
    if (EARN_PASSIVE[key]) {
      var pv = EARN_PASSIVE[key];
      return pv.inline === 'subscribe'
        ? [{ type: 'form', form: 'subscribe' }]
        : [{ type: 'link', label: pv.label, href: pv.href }];
    }
    // Nothing below here can pay a logged-out visitor — /api/loyalty/earn and
    // every App Proxy route answer 401 without a signed customer id.
    if (!canEarn) return [{ type: 'state', label: 'Log in to earn' }];

    if (key === 'tag_us') return [{ type: 'action', label: 'Submit', action: 'tagus' }];
    if (key === 'anime_quiz') return [{ type: 'action', label: 'Take the quiz', action: 'quiz' }];
    if (key === 'discord_join') {
      // A SAME-TAB navigation, not a small window (Nick, 2026-09-09: "revert
      // the pop up ... it's okay as long as it directs back to the rewards page
      // after authenticating"). The OAuth round trip ends back on this page
      // anyway, so a window buys nothing and costs a close-and-report dance the
      // other link-outs do not need.
      return [{ type: 'link', label: 'Join now', href: proxyBase + '/discord/start' }];
    }

    var link = n.linkUrl || (EARN_LINKS[key] || {}).href || (ctx.questHref || null);
    if (n.selfReportable) {
      // ONE button. Pressing Follow is the claim — see followClaim().
      return link
        ? [{ type: 'link', label: goLabel(key), href: link, blank: /^https?:\/\//.test(link), claims: true, ruleKey: key }]
        : [{ type: 'action', label: 'Claim', action: 'claim', ruleKey: key }];
    }
    return link
      ? [{ type: 'link', label: (EARN_LINKS[key] || {}).label || (ctx.questLabel || 'Open'), href: link, blank: /^https?:\/\//.test(link) }]
      : [];
  }

  var EARN_ICONS = {
    purchase: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
    create_account: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="3.5"/><path d="M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7"/></svg>',
    newsletter_signup: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3.5" y="5.5" width="17" height="13" rx="1.5"/><path d="M4 7l8 6 8-6"/></svg>',
    instagram_follow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3.5" y="3.5" width="17" height="17" rx="4"/><circle cx="12" cy="12" r="4"/><circle cx="17" cy="7" r="0.6" fill="currentColor" stroke="none"/></svg>',
    facebook_like: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M7 11v9H4v-9h3zm0 0a3 3 0 0 1 3-3h1V5a3 3 0 0 1 3-3l1 4h3l-1 3h-3v10h-3v-9a3 3 0 0 0-3-3z"/></svg>',
    // Same rule as instagram_follow/facebook_like above — a plain
    // smartphone outline, a generic chat bubble, and a megaphone, never any
    // platform's actual mark (2026-08-27, plm 0324).
    sms_signup: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="6.5" y="2.5" width="11" height="19" rx="2"/><path d="M10.5 18h3"/></svg>',
    discord_join: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5.5h16v10H9l-4 3.5v-3.5H4v-10z"/><circle cx="9" cy="10.5" r="0.6" fill="currentColor" stroke="none"/><circle cx="12" cy="10.5" r="0.6" fill="currentColor" stroke="none"/><circle cx="15" cy="10.5" r="0.6" fill="currentColor" stroke="none"/></svg>',
    ig_channel_join: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10v4h3l6 4V6l-6 4H3z"/><path d="M17 9a4 4 0 0 1 0 6"/></svg>',
    // anime_quiz/song_suggestion (0324) self-report ahead of the real quiz
    // and playlist-suggestion features existing — a question mark and a
    // musical note, same generic-icon rule as everything else here.
    anime_quiz: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 0 1 4.6 1.4c0 1.6-2.1 1.8-2.1 3.3"/><circle cx="12" cy="16.8" r="0.4" fill="currentColor" stroke="none"/></svg>',
    song_suggestion: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 17V5l10-2v12"/><circle cx="7" cy="18" r="2.2"/><circle cx="17" cy="16" r="2.2"/></svg>',
    // Link-out rules (0324) — an open book, a map pin (matches the
    // community globe's own pin motif), and a star.
    manga_of_the_week: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 6.5c-1.8-1.3-4-2-6.5-2v12c2.5 0 4.7.7 6.5 2 1.8-1.3 4-2 6.5-2v-12c-2.5 0-4.7.7-6.5 2z"/><path d="M12 6.5v12"/></svg>',
    community_note: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-6.5-5.7-6.5-11A6.5 6.5 0 0 1 18.5 10c0 5.3-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.2"/></svg>',
    leave_review: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3.5l2.6 5.6 6 .7-4.4 4.2 1.1 6-5.3-3-5.3 3 1.1-6-4.4-4.2 6-.7 2.6-5.6z"/></svg>',
  };
  // Where a NOT-self-reportable earn rule sends the customer to actually do
  // the thing (2026-08-27, plm 0324) — deliberately hardcoded here rather
  // than added to PLM's catalog response: this is storefront routing
  // knowledge (which page a feature lives at on THIS theme), same category
  // as EARN_ICONS above, not loyalty-program configuration.
  // ---------------------------------------------------------------------
  // WHAT THIS MEMBER HAS ALREADY DONE.
  //
  // Filled from /balance's `earned` map (plm, 2026-09-08). Until that existed
  // the page tracked completion in localStorage, which meant progress was
  // per-BROWSER: a new phone, a cleared cache or a private window showed every
  // reward as never done. Now it is read from the ledger — the same rows that
  // decide whether the credits were actually paid.
  //
  // Nick: "Even if they're greyed out and say 'Claimed' or 'Complete' it'd be
  // nice to have a visual cue on what's done."
  // ---------------------------------------------------------------------
  var hrwEarned = {};
  // The member's OWN earn rate, from /balance's tier. The "Make a purchase"
  // card was built from tiers[0] — the ENTRY tier — so a Hero earning 10/$1 was
  // told 5/$1 on the one card whose whole content is that number (Nick). null
  // until the balance lands, or for a logged-out visitor, where the entry rate
  // is the honest answer.
  var hrwMemberRate = null;
  // The member's qualifying spend, for the C13 "$97 to go" line. Null until the
  // balance lands, which is what keeps the card on the plain entry rate for a
  // logged-out visitor and on the first paint rather than inventing a tier.
  var hrwSpend = null;
  // The catalog fetch and the balance fetch race, and either can land first.
  // Keeping the last catalog payload means whichever arrives second can repaint
  // with both halves, instead of the earned state being dropped when it wins.
  var hrwLastCatalog = null;

  /**
   * Rules with no claim button — the credit follows from doing the thing
   * itself, not from telling us you did.
   *
   * These showed a greyed "Automatic" chip, which was a mistake: it describes
   * an IMPLEMENTATION detail (this page cannot POST a claim for them) dressed
   * up as member-facing copy. To somebody not on the list it reads as "this
   * will happen to you anyway" — the exact opposite of the truth, which is that
   * they get nothing until they subscribe (Nick). Each now points at the real
   * action instead.
   */
  /**
   * Rules that can earn WITHOUT being logged in.
   *
   * Verified against the backend rather than assumed: /api/loyalty/earn returns
   * 401 without a signed logged_in_customer_id, and so does every App Proxy
   * route, so no claim, quiz, tag or Discord link can pay a logged-out visitor.
   * These three are the exceptions, and each earns through a WEBHOOK rather
   * than the proxy:
   *   purchase        — the order webhook carries customer.id; a guest checkout
   *                     still creates a Shopify customer.
   *   create_account  — is the account.
   *   newsletter_signup — subscribing creates/updates a customer and the
   *                     consent webhook awards off that.
   *
   * Everything else shows "Log in to earn" instead of a live button. The action
   * behind some of them does work signed out — you can read the community page
   * or play the puzzle — but this page's promise is CREDITS, and a live button
   * that silently pays nothing is the worse of the two failures (Nick).
   */
  var EARNS_LOGGED_OUT = { purchase: 1, create_account: 1, newsletter_signup: 1 };

  // Shopify sends the member back with ?customer_posted=true after the customer
  // form succeeds. Without reading it the card would just re-render an empty
  // box and the reload would look like the form had silently cleared itself —
  // the footer form gets this for free from Liquid's form.posted_successfully?,
  // which a card built in JS cannot use.
  var hrwJustSubscribed = /[?&]customer_posted=true/.test(window.location.search);

  var EARN_PASSIVE = {
    // Subscribing happens IN the card. It was a button that scrolled to the
    // footer form, which is still asking the member to go somewhere else to do
    // a one-field thing (Nick). The form posts to /contact with
    // form_type=customer — the same endpoint the footer form submits to — so
    // this is the theme's existing signup, inlined, not a second one.
    newsletter_signup: { inline: 'subscribe' },
    create_account: { label: 'Create account', href: HRW_JOIN_URL }
  };

  /**
   * Has this member already earned it for the CURRENT period?
   *
   * A once-ever rule is done forever. A repeatable one is only done until its
   * period rolls over — showing a permanently dead button on a monthly reward
   * would quietly cost the member every future run of it, which is worse than
   * showing no state at all.
   */
  /* What a finished quest says, per rule (Nick, 2026-09-09): "the past tense of
     whatever the action was (i.e. subscribed, played, suggested)".
     
     "Claimed" was the same word on every card, so a member scanning the grid
     could see that a tile was done but not what they had done — the one thing
     the finished state is actually there to tell them. Keyed by rule, because
     the verb belongs to the action and cannot be derived from the label
     ("Sign up to our newsletter" -> "Subscribed" is not a string transform).

     Drives BOTH the centred badge and the disabled button beneath it, from the
     single label on hrwEarnState's return, so the two cannot drift apart.
     Anything missing here falls back to "Claimed", which is wrong but never
     misleading. */
  var EARN_DONE_LABELS = {
    create_account: 'Created',
    newsletter_signup: 'Subscribed',
    sms_signup: 'Subscribed',
    instagram_follow: 'Followed',
    magazine_follow: 'Followed',
    follow_tiktok: 'Followed',
    facebook_like: 'Liked',
    discord_join: 'Joined',
    ig_channel_join: 'Joined',
    manga_of_the_week: 'Played',
    community_note: 'Posted',
    leave_review: 'Reviewed',
    anime_quiz: 'Completed',
    song_suggestion: 'Suggested',
    tag_us: 'Tagged'
  };

  /**
   * When the member's current earning period for a rule ends, in UTC.
   *
   * MUST MATCH THE SERVER'S BUCKET. PLM stamps the period into the ledger key
   * (earnRuleSourceId) and the ledger's unique constraint is what actually
   * enforces the cap, so any disagreement here shows the member the wrong
   * thing: a live button that will be refused, or a greyed tile they could
   * have earned from. Those buckets are the ISO week and the CALENDAR month,
   * both UTC — not a rolling window.
   */
  function hrwPeriodEnd(last, period) {
    if (period === 'month') {
      return new Date(Date.UTC(last.getUTCFullYear(), last.getUTCMonth() + 1, 1));
    }
    if (period === 'week') {
      // Start of last's ISO week (Monday), plus seven days. getUTCDay() calls
      // Sunday 0, hence the `|| 7` — without it a Sunday earn is pushed into
      // the following week and the tile stays grey a week too long.
      var d = new Date(Date.UTC(last.getUTCFullYear(), last.getUTCMonth(), last.getUTCDate()));
      var day = d.getUTCDay() || 7;
      d.setUTCDate(d.getUTCDate() - (day - 1) + 7);
      return d;
    }
    if (period === 'day') {
      return new Date(Date.UTC(last.getUTCFullYear(), last.getUTCMonth(), last.getUTCDate() + 1));
    }
    return null;
  }

  /**
   * What a finished quest says, and where.
   *
   *   verb    — the button ON the card: "Subscribed", "Played", "Suggested".
   *   resetAt — when it can be earned again, or null if it never can. Drives
   *             the floating countdown; null means no floating layer at all.
   *
   * There is deliberately no third "Claimed" string here any more. It existed
   * briefly as a floating badge and was removed: the tile is already dimmed and
   * the button already names the action, so it was a third statement of the
   * same fact laid over the artwork.
   */
  function hrwEarnState(node) {
    var hit = hrwEarned[node.key];
    if (!hit || !hit.count) return null;
    var verb = EARN_DONE_LABELS[node.key] || 'Claimed';
    if (!node.period) return { done: true, verb: verb, resetAt: null };

    var last = hit.lastAt ? new Date(hit.lastAt) : null;
    if (!last || isNaN(last.getTime())) return { done: true, verb: verb, resetAt: null };
    var now = new Date();
    var end = hrwPeriodEnd(last, node.period);
    // An unrecognised period is treated as still-in-period rather than
    // available: telling a member they can earn again when the server will
    // refuse them is the worse of the two wrong answers.
    if (!end) return { done: true, verb: verb, resetAt: null };
    if (now.getTime() >= end.getTime()) return null;   // rolled over — earn it again

    return { done: true, verb: verb, resetAt: end };
  }

  /** Whole days until `resetAt`, never less than 1 — a tile that says "0" reads
   *  as available when it is not. Ceil, so 3 hours left shows as 1. */
  function hrwDaysUntil(resetAt) {
    if (!resetAt) return null;
    var ms = resetAt.getTime() - Date.now();
    if (ms <= 0) return null;
    return Math.max(1, Math.ceil(ms / 86400000));
  }

  /* A drawn hourglass, not the ⌛ emoji (Nick, 2026-09-09). The emoji renders
     in the OS's own colours — yellow-and-blue on Apple, different again on
     Android — and was the one thing on this page that never matched the theme.
     This is monochrome, inherits currentColor and scales with the badge.
     Stroke-drawn to sit with the hairline outlines the Classic skin uses
     everywhere else; the lower bulb is filled so it still reads as an hourglass
     rather than a bow tie at small sizes. */
  var HRW_HOURGLASS_SVG =
    '<svg class="hrw-rp__node-reset-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">'
    + '<path d="M6.5 2.75h11M6.5 21.25h11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>'
    + '<path d="M8.25 2.75v3.4L12 12l-3.75 5.85v3.4M15.75 2.75v3.4L12 12l3.75 5.85v3.4"'
    + ' stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>'
    + '<path d="M12 13.5l3.05 4.75a0.35 0.35 0 0 1-0.3 0.55h-5.5a0.35 0.35 0 0 1-0.3-0.55z" fill="currentColor"/>'
    + '</svg>';


  /** The greyed-out state chip. A <button disabled> rather than a <span> so it
   *  lines up with the real buttons on the other cards — a card whose action
   *  area is a different height reads as broken next to its neighbours. */
  function hrwStateBtn(a) {
    // `html` carries the hourglass mark; `label` is the plain-text equivalent
    // and stays the accessible name, so the button reads as "5 days" and not as
    // an unnamed image plus a number.
    var isWait = !!(a && a.html);
    return '<button type="button" class="hrw-rp__reward-btn' + (isWait ? ' hrw-rp__reward-btn--wait' : '') + '"'
      + ' disabled aria-label="' + escapeHtml(isWait ? 'Available again in ' + a.label : a.label) + '">'
      + (isWait ? a.html : escapeHtml(a.label))
      + '</button>';
  }

  var HRW_FOLLOW_CLAIM_MS = 4000;

  /**
   * Award a follow rule after the member has been sent to the profile.
   *
   * Replaces the link with a greyed "Claimed" chip on success — the same chip
   * an already-earned rule renders on load, so a claim made now and a claim
   * made last week look identical rather than the fresh one looking special.
   *
   * A FAILURE PUTS THE LINK BACK. Leaving a dead half-state would tell the
   * member they had earned credits they do not hold, and the next page load
   * would silently contradict it.
   */
  /**
   * Bring the page back in step after a credit is earned mid-session
   * (Nick, 2026-09-09): "I had to reload the page to see the credits pop-up,
   * and the follow button changed to 'Followed' but the hexagon didn't grey out
   * until I reloaded."
   *
   * Both symptoms are one gap. Claiming updated the BUTTON it was given and the
   * in-memory `hrwEarned` record, and stopped there — nothing repainted the
   * tile, so it kept the classes it was rendered with, and nothing re-read the
   * balance, so the pop-up (which only runs inside loadBalance) had no chance to
   * fire until the next page load.
   *
   * Repaint first, refresh second, deliberately: the repaint is instant and
   * local, so the tile greys the moment the claim succeeds instead of waiting on
   * a round trip. loadBalance then corrects the optimistic numbers from the
   * server and fires the "You've earned N credits" pop-up.
   */
  /**
   * Copy the page's theme onto an overlay that mounts on <body>.
   *
   * These dialogs live outside .hrw-rp, so no rule scoped to the page element
   * can reach them — which is why they arrived wearing the Start Menu's green
   * (`var(--adv-accent, #14a477)`) on every theme, Classic included, and why a
   * green "YOU'VE EARNED / NICE" turned up over a black-and-white page. The Tag
   * Us dialog had the identical bug and the identical fix; this is that fix made
   * shared, so the next overlay cannot repeat it a third time.
   */
  function hrwStampTheme(ov) {
    var t = root.getAttribute('data-hrw-theme');
    if (t) ov.setAttribute('data-hrw-theme', t);
    var skin = root.getAttribute('data-hrw-skin');
    if (skin) ov.setAttribute('data-hrw-skin', skin);
    return ov;
  }

  /**
   * Handle the Discord OAuth return.
   *
   * plm's callback cannot redirect to a bare confirmation — it is a top-level
   * bounce from discord.com — so it sends the member back to THIS PAGE with
   * ?discord=ok&msg=...
   *
   * NOTHING READ THOSE PARAMETERS. The round trip has been ending with the
   * member on a rewards page that says nothing about what just happened,
   * wearing two stray query strings, and the credit only surfacing on some
   * later reload. That is why this exists. The small-window experiment that
   * briefly wrapped it is reverted, and its report-and-close branch went with
   * it — a same-tab return is now the only case that can occur.
   */
  function hrwDiscordReturn() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var result = params.get('discord');
    if (!result) return;
    var msg = params.get('msg') || (result === 'ok' ? 'Discord connected.' : 'Discord could not be verified.');

    hrwSayDiscord(result === 'ok', msg);
    if (result === 'ok') hrwAfterEarn('discord_join');
    // Strip the parameters so a refresh does not replay the message.
    try {
      params.delete('discord'); params.delete('msg');
      var q = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
    } catch (e) {}
  }

  function hrwSayDiscord(ok, msg) {
    var el = root.querySelector('[data-earn-status]');
    if (!el) return;
    el.hidden = false;
    el.textContent = msg;
    el.classList.toggle('is-error', !ok);
  }

  function hrwAfterEarn(ruleKey) {
    if (ruleKey && !hrwEarned[ruleKey]) {
      // Optimistic, so the repaint below has something to grey. loadBalance
      // overwrites it with the server's own record a moment later.
      hrwEarned[ruleKey] = { count: 1, lastAt: new Date().toISOString() };
    }
    try {
      if (hrwLastCatalog) renderEarn(hrwLastCatalog.rules, hrwLastCatalog.tiers);
      if (typeof hrwRefreshAdvPanels === 'function') hrwRefreshAdvPanels();
    } catch (e) {}
    try { loadBalance(); } catch (e) {}
  }

  /**
   * Send a social link-out to a small window instead of a new tab (Nick,
   * 2026-09-09). Desktop only.
   *
   * The point is that the rewards page is a checklist. A new tab buries it
   * behind Instagram; a 520x720 window sits beside it, and closing the profile
   * puts the member back on the list they were working through — which is also
   * when the credit they just earned appears.
   *
   * DESKTOP ONLY, and the gate is a real one. Mobile browsers ignore window
   * features and open a tab regardless, so intercepting there would add a code
   * path that changes nothing; worse, a popup on a phone can land as a
   * chromeless view with no obvious way back. `(hover: hover) and
   * (pointer: fine)` is the same guard this file already uses to keep :hover
   * styles off touch screens.
   *
   * RETURNS THE WINDOW, OR NULL — and the caller must only preventDefault on a
   * truthy one. If a popup blocker refuses, the anchor's own target="_blank"
   * has to be left to run, or pressing Follow does nothing at all. That
   * invariant predates this function; see the click handler's comment.
   */
  function hrwOpenSocialWindow(url) {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return null;
    if (window.innerWidth < 900) return null;   // small laptop windows: a tab is roomier
    var w = 520, h = 720;
    var sw = (window.screen && window.screen.availWidth) || window.innerWidth;
    var sh = (window.screen && window.screen.availHeight) || window.innerHeight;
    // Centred on THIS window rather than the screen, so on a multi-monitor desk
    // it opens over the monitor the member is actually looking at.
    var left = Math.max(0, Math.round((window.screenX || 0) + (((window.outerWidth || sw) - w) / 2)));
    var top = Math.max(0, Math.round((window.screenY || 0) + (((window.outerHeight || sh) - h) / 2.4)));
    var win = null;
    try {
      win = window.open(url, 'hakiSocial',
        'popup=yes,width=' + w + ',height=' + h + ',left=' + left + ',top=' + top + ',scrollbars=yes,resizable=yes');
    } catch (e) { return null; }
    if (win) {
      // The anchor carries rel="noopener"; window.open does not, and passing
      // `noopener` in the features string makes it return null — which would
      // destroy the blocked-or-not signal above. Severing by hand instead: the
      // new window is still about:blank at this instant, so it is same-origin
      // and writable. Wrapped anyway, because that timing is not guaranteed.
      try { win.opener = null; } catch (e) {}
      try { win.focus(); } catch (e) {}
    }
    return win;
  }

  function followClaim(a) {
    var key = a.getAttribute('data-rule-key');
    if (!key) return;
    fetch(proxyBase + '/earn', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ruleKey: key })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        // The endpoint reports `awarded` for a fresh award; a repeat visit is
        // still a success from the member's side, so both end the same way.
        if (!res.ok || !res.data || !res.data.awarded) throw new Error('not awarded');
        // Keep the local record in step, so a repaint before /balance refreshes
        // does not flip it back to unclaimed.
        hrwCoinBalance += (+res.data.credits || 0);
        // Repaint the whole tile rather than swapping the anchor for a chip.
        // The hand-built chip changed the button and nothing else, so the
        // hexagon stayed ungreyed until a reload — and it could not know
        // whether this rule wants the verb or a countdown.
        hrwAfterEarn(key);
      })
      .catch(function () {
        a.removeAttribute('data-claiming');
      });
  }

  /** The verb on a self-report rule's "go do it" button. Named per rule rather
   *  than a generic "Open" — "Follow" tells a member what they are about to be
   *  asked to have done, which is the whole point of showing it before Claim. */
  function goLabel(key) {
    if (key === 'instagram_follow' || key === 'magazine_follow' || key === 'follow_tiktok') return 'Follow';
    if (key === 'facebook_like') return 'Like';
    if (key === 'sms_signup') return 'Sign up';
    if (key === 'ig_channel_join') return 'Join';
    return 'Open';
  }


  var EARN_LINKS = {
    // Not an earn rule — the synthesized base-tier card. It is the one thing on
    // this page a member can act on that actually spends money, and it had no
    // button at all (Nick).
    purchase: { href: '/collections/all', label: 'Shop now' },
    // follow_tiktok is NOT self-reportable, so it takes the plain link path at
    // the bottom of hrwCardActions rather than goLabel's — and with no entry
    // here that path falls back to the generic 'Open' (Nick). No href: the
    // operator sets the destination as link_url in PLM, and n.linkUrl already
    // wins over anything in this map. The label is all that was missing.
    follow_tiktok: { label: 'Follow' },
    manga_of_the_week: { href: '/pages/manga-of-the-week', label: 'Play now' },
    // song_suggestion came off the self-report list in plm 0328 when the real
    // feature shipped, and nothing ever gave it a destination — so its card had
    // no button at all, which is what Nick spotted.
    // #haki-suggest is the id of the Suggest-a-song section, and the radio
    // page's own in-page button already targets it — landing on /pages/radio
    // alone put the member at the top of a long playlist grid with the form
    // off-screen, which is a page, not a destination (Nick).
    song_suggestion: { href: '/pages/radio#haki-suggest', label: 'Suggest song' },
    community_note: { href: '/pages/community', label: 'Leave a note' },
    // /pages/reviews is the read-only SEO page — server-rendered published
    // reviews with no write-review widget on it at all, so "Leave a review"
    // landed on a wall of other people's reviews with no way to add one
    // (Nick). Judge.me's form lives on a PRODUCT, so the shortest real path is
    // the member's own orders.
    // Our account page, not Shopify's portal (operator, 2026-10-01): it lists
    // their orders, and each order links to the product to review.
    leave_review: { href: '/pages/account', label: 'Review' },
  };
  var DEFAULT_EARN_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8"/><path d="M12 8v4l3 2"/></svg>';

  // The icon for an earn action or a reward: the operator's uploaded image
  // (from PLM, an http(s) URL) if there is one, else the built-in SVG.
  function nodeIcon(imageUrl, fallbackSvg, label) {
    if (typeof imageUrl === 'string' && /^https?:\/\//i.test(imageUrl)) {
      return '<img class="hrw-rp__node-icon-img" src="' + escapeHtml(imageUrl) + '" alt="" loading="lazy">';
    }
    return fallbackSvg;
  }

  // Swap {credits} (case-insensitive) for the live create_account amount in
  // any operator-authored text — the hero subheading and the How It Works
  // step bodies. data-tpl-html preserves the original template so a re-render
  // never compounds; no token means the text is untouched.
  function substituteCredits(credits) {
    root.querySelectorAll('[data-signup-credits-sentence], [data-step-body]').forEach(function (el) {
      var tpl = el.getAttribute('data-tpl-html');
      if (tpl == null) { tpl = el.innerHTML; el.setAttribute('data-tpl-html', tpl); }
      if (tpl.indexOf('{credits}') === -1 && tpl.indexOf('{CREDITS}') === -1 && !/\{credits\}/i.test(tpl)) return;
      el.innerHTML = tpl.replace(/\{credits\}/gi, credits);
    });
  }

  /**
   * C11 — four groups instead of thirteen tiles in a row.
   *
   * Thirteen quests read as a chore list, and a member scanning it cannot tell
   * which ones are for THEM. Four labelled groups let a reader, a poster and a
   * buyer each find their own path in about three seconds.
   *
   * ONE-TIME EARNS COLLAPSE once they are all done. "Start here · 8 of 8" as a
   * single row is the honest end state — eight greyed hexagons a member can
   * never act on again is eight tiles of dead weight above the quests they can.
   *
   * ORDER IS BY WHEN, not by value: what to do first, then what comes back
   * weekly, then what rides on an order, then the one that needs somebody else.
   */
  var HRW_EARN_GROUPS = [
    { id: 'start', label: 'Start here', collapsible: true,
      keys: ['create_account', 'newsletter_signup', 'instagram_follow', 'discord_join',
             'follow_tiktok', 'magazine_follow', 'community_note', 'anime_quiz'] },
    // ONE RECURRING GROUP, not three (Nick, 2026-09-11). The first cut split
    // this by CADENCE — weekly, per-order, referral — which is how the
    // programme is built rather than how it is read. To a member there are only
    // two kinds of quest: the ones you do once, and the ones that come back.
    //
    // It also fixes the shape. Three groups of 2, 3 and 1 are three headings
    // over almost nothing, and a one-tile group with its own title reads as a
    // mistake. Six tiles is a section.
    { id: 'recurring', label: 'Keep earning', collapsible: false,
      keys: ['purchase', 'manga_of_the_week', 'song_suggestion', 'leave_review',
             'tag_us', 'refer_friend'] }
  ];

  /** Which group a node belongs to. Anything unlisted lands in the recurring
   *  group, because a new earn rule is far more likely to be repeatable than a
   *  start-here step — and a rule filed slightly wrong beats a rule that
   *  disappears from the page entirely. */
  function hrwGroupFor(key) {
    for (var i = 0; i < HRW_EARN_GROUPS.length; i++) {
      if (HRW_EARN_GROUPS[i].keys.indexOf(key) !== -1) return HRW_EARN_GROUPS[i].id;
    }
    return 'recurring';
  }

  function renderEarn(rules, tiers) {
    var list = root.querySelector('[data-earn-list]');
    var createRule = rules.filter(function (r) { return r.key === 'create_account'; })[0];
    if (createRule) substituteCredits(createRule.credits);
    if (!list) return;

    // "Make a purchase" isn't an earn_rule row — it's the base tier's own
    // earn rate — but Vicinity's reference shows it as the first card in
    // this section, so it's synthesized here from tiers[0] (sorted
    // ascending by threshold, so [0] is the entry tier) rather than added
    // as a fake catalog row on the PLM side.
    var nodes = [];
    if (tiers && tiers.length) {
      // The member's rate when the balance has told us, the entry rate before
      // that (and for a logged-out visitor, where it IS their rate).
      var perDollar = hrwMemberRate != null ? hrwMemberRate : tiers[0].creditsPerDollar;

      // C13 — THE MEMBER'S OWN RATE, AND THE NEXT ONE. "5 credits per $1" is
      // the same sentence for everybody; "8 at Hero, $97 to go" is about them.
      // Drèze & Nunes (2009): status motivates most when the next rank and its
      // advantage are both visible — a rate with no next rung is a fact, not a
      // reason to do anything.
      //
      // Only when we actually KNOW. hrwMemberRate and hrwSpend arrive with the
      // balance, so a logged-out visitor and the first paint before it lands
      // both fall back to the plain entry rate rather than inventing a tier.
      var nextTier = null;
      if (hrwMemberRate != null && hrwSpend != null) {
        for (var ti = 0; ti < tiers.length; ti++) {
          if (Number(tiers[ti].minLifetimeSpend) > hrwSpend) { nextTier = tiers[ti]; break; }
        }
      }
      // Same NBSP: this label sits in a hexagon, which is even less forgiving.
      var rateLabel = perDollar + ' credits per\u00a0$1';
      if (nextTier && nextTier.creditsPerDollar > perDollar) {
        var toGo = Math.max(0, Math.ceil(Number(nextTier.minLifetimeSpend) - hrwSpend));
        rateLabel += ' \u00b7 ' + nextTier.creditsPerDollar + ' at ' + nextTier.name + ', $' + toGo.toLocaleString() + ' to go';
      }
      nodes.push({ key: 'purchase', label: 'Make a purchase', creditsLabel: rateLabel });
    }
    // selfReportable comes straight from the catalog API (plm 0324's
    // isSelfReportableEarnRule, mirrored server-side) — the storefront never
    // maintains its own copy of that allowlist, so a rule can't show a
    // "claim" button here that the backend would then reject.
    rules.forEach(function (r) { nodes.push({ key: r.key, label: r.label, creditsLabel: r.credits + ' ' + coinWord(), selfReportable: !!r.selfReportable, imageUrl: r.imageUrl, linkUrl: r.linkUrl, period: r.period || null }); });

    // The modal is independent of this list now, but a re-render under an open
    // modal still means the member's context changed beneath them.
    hrwCloseSubModal();
    if (!nodes.length) { list.innerHTML = '<p class="hrw-rp__loading">More ways to earn are on their way.</p>'; return; }

    function hrwEarnTile(n) {
      // Three states per node: a real "Claim" button (self-reportable,
      // posts to the App Proxy earn path), a plain link-out to the actual
      // feature (EARN_LINKS — the rule exists but nothing awards credit for
      // it yet, see plm 0324's migration header), or no action at all
      // (purchase, create_account, newsletter_signup — earned automatically,
      // nothing to click).
      // an operator-set link_url from PLM (plm 0361) wins over the built-in map
      var earnLink = n.linkUrl ? { href: n.linkUrl, label: (EARN_LINKS[n.key] || {}).label || 'Open', blank: /^https?:\/\//.test(n.linkUrl) } : EARN_LINKS[n.key];
      var actionHtml = '';
      // Every card gets an action area, so none is left with blank space where
      // its neighbours have a button (Nick). Order matters: an earned rule is
      // reported as earned even if it is also self-reportable, or the member
      // gets a live Claim button for credits they already hold.
      var earnState = hrwEarnState(n);
      var actionHtml = hrwCardActions(n, { earnState: earnState, loggedIn: loggedIn })
        .map(function (a) {
          if (a.type === 'state') return hrwStateBtn(a);
          // ONLY the button. The form is built inside the modal when it opens
          // (Nick) — the card carries no hidden copy, so there is nothing to
          // keep in sync, nothing for a stray submit to reach, and nothing
          // measuring into the tile's height that a member never sees.
          if (a.type === 'form') return hrwSubscribeOpenBtnHtml();
          if (a.type === 'link') {
            return '<a class="hrw-rp__reward-btn" href="' + escapeHtml(a.href) + '"'
              + (a.blank ? ' target="_blank" rel="noopener"' : '')
              + (a.claims ? ' data-follow-claim data-rule-key="' + escapeHtml(a.ruleKey) + '"' : '')
              + '>' + escapeHtml(a.label) + '</a>';
          }
          var attr = a.action === 'tagus' ? 'data-tagus-btn'
            : a.action === 'quiz' ? 'data-quiz-btn'
            : a.action === 'referral' ? 'data-referral-btn'
            : 'data-claim-btn data-rule-key="' + escapeHtml(a.ruleKey || '') + '"';
          return '<button type="button" class="hrw-rp__reward-btn" ' + attr + '>' + escapeHtml(a.label) + '</button>';
        }).join('');
      // is-done greys the WHOLE tile, not just the state chip (Nick,
      // 2026-09-09). A finished quest that looks identical to a live one apart
      // from its button makes the member read every tile to find what is left.
      // is-cooldown sits between live and done (Nick): a repeatable quest that
      // is merely waiting out its period is not finished the way "Create an
      // account" is finished, and fading both to the same grey said it was.
      var doneCls = !earnState || !earnState.done ? ''
        : (earnState.resetAt ? ' is-cooldown' : ' is-done');
      return '<div class="hrw-rp__node' + (actionHtml ? ' hrw-rp__node--reward' : '') + doneCls + '">' +
        '<span class="hrw-rp__node-icon">' + nodeIcon(n.imageUrl, EARN_ICONS[n.key] || DEFAULT_EARN_ICON, n.label) + '</span>' +
        '<span class="hrw-rp__node-label">' + escapeHtml(n.label) + '</span>' +
        '<span class="hrw-rp__node-credits">' + escapeHtml(n.creditsLabel) + '</span>' +
        actionHtml +
        '</div>';
    }

    // ---- C11: render the tiles, grouped or flat -------------------------
    //
    // GATED ON A SETTING, default off, so merging this changes nothing until
    // somebody turns it on in the theme editor. That is what makes it
    // previewable on a test theme without a second branch, and what makes
    // backing it out a click rather than a revert.
    //
    // EACH GROUP CARRIES THE SAME CLASS as the flat list, which is the whole
    // trick: every honeycomb rule is written against
    // `.hrw-rp__earn-list > .hrw-rp__node`, so a group is its own independent
    // honeycomb for free — its own 5/4/5 cycle, its own row overlap, its own
    // centred orphan — with no second copy of that CSS to keep in step.
    if (!hrwEarnGroupedNow()) {
      list.classList.remove('is-grouped');
      list.innerHTML = nodes.map(hrwEarnTile).join('');
    } else {
      list.classList.add('is-grouped');
      var byGroup = {};
      nodes.forEach(function (n) {
        var g = hrwGroupFor(n.key);
        (byGroup[g] = byGroup[g] || []).push(n);
      });
      list.innerHTML = HRW_EARN_GROUPS.map(function (grp) {
        var items = byGroup[grp.id] || [];
        if (!items.length) return '';

        // COLLAPSE ONLY WHEN EVERY ONE IS DONE. A part-finished Start here is
        // exactly the list a new member still needs; collapsing it early would
        // hide the thing the group exists to point at.
        var done = items.filter(function (n) { return !!hrwEarnState(n); }).length;
        if (grp.collapsible && done === items.length && items.length > 0) {
          return '<div class="hrw-rp__earn-group-done">'
            + '<span class="hrw-rp__earn-group-tick">' + HRW_TICK_SVG + '</span>'
            + escapeHtml(grp.label) + ' &middot; ' + done + ' of ' + items.length + ' done'
            + '</div>';
        }

        return '<div class="hrw-rp__earn-group">'
          + '<h3 class="hrw-rp__earn-group-label">' + escapeHtml(grp.label)
          + (grp.collapsible && done > 0
              ? '<span class="hrw-rp__earn-group-count">' + done + ' of ' + items.length + '</span>'
              : '')
          + '</h3>'
          // A GROUP THAT FITS ONE ROW GETS CENTRED. Four tiles hard against the
          // left edge of a ten-column grid reads as a row that failed to
          // finish; centred it reads as the size it is. Only up to four,
          // because five already fills the row and needs no help — and the
          // count is knowable here in a way it never was for the flat list,
          // which is why this could not be done before grouping.
          + '<div class="hrw-rp__earn-list'
          + (items.length <= 4 ? ' hrw-rp__earn-list--n' + items.length : '')
          + '">' + items.map(hrwEarnTile).join('') + '</div>'
          + '</div>';
      }).join('');
    }

    // The whole tile is a click target, not just the pill (Nick). Wired on the
    // tile rather than made a <button>: the tile already contains real
    // controls, and nesting interactive elements is invalid and breaks
    // keyboard use. Those controls still work on their own — this only
    // forwards clicks that landed on dead space.
    list.querySelectorAll('.hrw-rp__node').forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (root.getAttribute('data-hrw-skin') !== 'classic') return;
        // a real control was hit: leave it alone, or we fire it twice
        if (e.target.closest && e.target.closest('a, button, input, textarea, select, label, form')) return;
        // VISIBLE and enabled only. The newsletter card still carries its
        // inline form, hidden, and that form's submit button is the first
        // .hrw-rp__reward-btn in the DOM — forwarding to it would post an
        // empty signup. offsetParent is null for a display:none subtree.
        var act = [].slice.call(card.querySelectorAll('.hrw-rp__reward-btn'))
          .filter(function (b) { return b.offsetParent !== null && !b.disabled; })[0];
        if (act) act.click();
      });
    });
    list.querySelectorAll('[data-sub-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { hrwOpenSubModal(); });
    });
    list.querySelectorAll('[data-claim-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () { claimEarnRule(btn); });
    });
    // Follow-and-claim. The credit follows a few seconds after the member is
    // sent to the profile. NEVER preventDefault in this handler — a popup
    // blocker would silently eat the one thing the member pressed. (The
    // small-window handler below does preventDefault, but only once it holds a
    // real window; if it does not, this anchor's target="_blank" still runs.)
    list.querySelectorAll('[data-follow-claim]').forEach(function (a) {
      a.addEventListener('click', function () {
        if (a.getAttribute('data-claiming')) return;   // double-click, one award
        a.setAttribute('data-claiming', '1');
        window.setTimeout(function () { followClaim(a); }, HRW_FOLLOW_CLAIM_MS);
      });
    });

    // Social link-outs open in a small window on desktop rather than a new tab.
    // Bound to every external link in the quest grid, NOT to [data-follow-claim]:
    // follow_tiktok is not self-reportable, so it has no claim hook at all and
    // that selector would have missed the one Nick named first.
    list.querySelectorAll('a[target="_blank"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        // Let the browser handle anything that is not a plain left click —
        // cmd/ctrl-click, middle click and shift-click all mean "I want a tab",
        // and hijacking those is exactly the kind of thing that makes a page
        // feel broken.
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var href = a.getAttribute('href') || '';
        if (!/^https?:\/\//i.test(href)) return;
        if (hrwOpenSocialWindow(href)) e.preventDefault();
      });
    });
    list.querySelectorAll('[data-tagus-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () { openTagUsForm(); });
    });
    list.querySelectorAll('[data-quiz-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () { openQuizForm(); });
    });
    list.querySelectorAll('[data-referral-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // The status goes onto the button itself: this is a copy action with
        // nothing to open, so a toast somewhere else would leave the member
        // looking at an unchanged button wondering whether it worked.
        var original = btn.textContent;
        hrwReferral(btn, function (msg, ok) {
          btn.textContent = msg;
          btn.disabled = ok === null;
          if (ok !== null) setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2600);
        });
      });
    });
  }

  /**
   * Self-report an earn rule (2026-08-27, plm 0324) — POSTs straight to
   * the App Proxy earn path, no idempotency key to mint: awardEarnRuleCredits is
   * already deterministically idempotent per (rule, customer) on the
   * backend, unlike redeemReward's per-CLICK idempotency key below (a
   * redemption can legitimately repeat; an earn rule here can't).
   *
   * Known gap, not fixed here: awardEarnRuleCredits reports {awarded: true}
   * on a repeat claim too (its upsert silently no-ops on conflict rather
   * than distinguishing "new credit" from "already had this") — same as
   * this page never pre-checks whether a rule was already claimed before
   * showing its button (ledger history's labels aren't granular enough per
   * rule key to tell, see plm's EVENT_TYPE_LABELS). A customer who clicks
   * Claim twice sees a "you earned credits" message twice; their balance
   * only actually moves once. Button stays disabled after a successful
   * claim for the rest of this page view, which covers the common case.
   */
  function claimEarnRule(btn, opts) {
    opts = opts || {};
    var status = opts.statusEl || root.querySelector('[data-earn-status]');
    function say(msg) { if (opts.onStatus) opts.onStatus(msg); else if (status) { status.hidden = false; status.textContent = msg; } }
    var ruleKey = opts.ruleKey || btn.getAttribute('data-rule-key');
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Claiming…';
    fetch(proxyBase + '/earn', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ruleKey: ruleKey }),
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (res.ok && res.data.awarded) {
          btn.textContent = EARN_DONE_LABELS[ruleKey] || 'Claimed';
          hrwCoinBalance += (+res.data.credits || 0);
          hrwAfterEarn(ruleKey);
          say('You earned ' + res.data.credits + ' ' + coinWord() + '!');
          if (opts.onDone) { try { opts.onDone(res.data); } catch (e) {} }
          return; // stays disabled — nothing left to claim for this rule
        }
        btn.disabled = false;
        btn.textContent = originalText;
        say(res.data && res.data.error === 'rule_inactive'
          ? 'That isn’t available right now.'
          : 'Something went wrong - try again in a moment.');
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = originalText;
        say('Couldn’t reach the rewards service - try again shortly.');
      });
  }

  var REWARD_ICONS = {
    discount_amount: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="6.5" width="19" height="11" rx="2"/><circle cx="12" cy="12" r="2.5"/></svg>',
    discount_percent: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 19L19 5"/><circle cx="7" cy="7" r="2.2"/><circle cx="17" cy="17" r="2.2"/></svg>',
    product: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 8l-8-4-8 4 8 4 8-4z"/><path d="M4 8v8l8 4 8-4V8"/><path d="M12 12v8"/></svg>',
  };
  var DEFAULT_REWARD_ICON = REWARD_ICONS.discount_amount;

  function renderRewards(rewards) {
    var list = root.querySelector('[data-rewards-list]');
    if (!list) return;
    if (!rewards.length) { list.innerHTML = '<p class="hrw-rp__loading">Rewards are on their way.</p>'; return; }
    list.innerHTML = rewards.map(function (r) {
      // guard against a null discountAmount (the Start Menu Item Shop's
      // equivalent line already does this) — otherwise a reward with no
      // amount set renders the literal label "$undefined off" (Nick).
      var valueLabel = r.rewardType === 'discount_percent' ? (r.discountPercent + '% off') : ('$' + (r.discountAmount || 0) + ' off');
      // physical products: a direct "View product" link instead of the
      // generic redemption-help tooltip — same rule as the Start Menu Item
      // Shop card (Nick).
      var productUrl = r.rewardType === 'product'
        ? (r.productUrl || (r.productHandle ? '/products/' + r.productHandle : null) || shopUrlFor(r.label) || '/collections/all')
        : null;
      var infoHtml = productUrl
        ? '<a class="hrw-rp__node-info" href="' + escapeHtml(productUrl) + '" target="_blank" rel="noopener">View product</a>'
        : '<span class="hrw-rp__node-info" data-node-info tabindex="0" role="button" aria-label="How to redeem or use this reward">More info'
          + '<span class="hrw-rp__node-tip" role="tooltip">' + redeemHelp(r) + '</span></span>';
      return '<div class="hrw-rp__node hrw-rp__node--reward">' +
        '<span class="hrw-rp__node-icon">' + nodeIcon(r.imageUrl, shopIconFor(r.label, r.rewardType), r.label) + '</span>' +
        '<span class="hrw-rp__node-label">' + escapeHtml(r.label || valueLabel) + '</span>' +
        // C10: once the member has a balance, the cost line becomes progress
        // toward it rather than a bare price. Logged out it stays the price,
        // because "0 / 1,000" tells a visitor nothing and reads as a wall.
        '<span class="hrw-rp__node-credits">'
          + (loggedIn && hrwCoinBalance > 0 && hrwCoinBalance < r.costCredits
              ? hrwCoinBalance.toLocaleString() + ' / ' + Number(r.costCredits).toLocaleString()
              : r.costCredits + ' ' + coinWord())
          + '</span>' +
        infoHtml +
        '<button type="button" class="hrw-rp__reward-btn" data-redeem-btn data-reward-id="' + r.id + '" data-reward-cost="' + r.costCredits + '"' + (loggedIn && !hrwNeedsFirstOrder(r) ? '' : ' disabled') + '>' +
        (!loggedIn ? 'Log in to buy' : hrwNeedsFirstOrder(r) ? 'Unlocks after your first order' : 'Buy Now') + '</button>' +
        hrwRewardFootnote(r) +
        '</div>';
    }).join('');
    list.querySelectorAll('[data-redeem-btn]').forEach(function (btn) {
      // cost must travel with the button — redeemReward only decrements
      // hrwCoinBalance when opts.cost is passed, and this call site used to
      // omit it entirely, so a Light/Dark redemption never updated the
      // in-page balance (stale "afford" checks if the member switched to
      // Start Menu without reloading) (Nick).
      btn.addEventListener('click', function () { redeemReward(btn, { cost: +btn.getAttribute('data-reward-cost') || 0 }); });
    });
    list.querySelectorAll('[data-node-info]').forEach(wireInfoToggle);
  }

  // ---- YOUR REWARDS (Light/Dark) ---------------------------------------
  //
  // The member's reward BANK, read from the server rather than localStorage.
  // The Start Menu theme's Inventory shows the same thing; the difference is
  // that a redeemed code used to live only in THIS browser (the /balance
  // response never carries codes), so clearing it or switching device lost a
  // reward the member had paid credits for.
  //
  // A member banks as many rewards as they earn and activates ONE at a time.
  // Activating mints the code; returning it to the bank deletes it. That limit
  // is what stops two reward codes landing on one order — Shopify cannot
  // prevent it without losing the magic cart gift.

  var hrwBankBusy = false;
  // The server bank, shared by BOTH themes. Light/Dark renders it as "Your
  // Rewards"; the Start Menu theme's Inventory reads the same array for its
  // Consumables, so the two can never disagree about what a member owns.
  var hrwBank = [];
  var hrwBankData = null;
  // Products the member actually owns, from /apps/rewards/wardrobe. Empty until
  // it loads, and empty (not an error) if Shopify is unreachable.
  var hrwWardrobe = [];

  function bankStatus(msg, isError) {
    var el = root.querySelector('[data-bank-status]');
    if (!el) return;
    if (!msg) { el.hidden = true; el.textContent = ''; return; }
    el.hidden = false;
    el.textContent = msg;
    el.classList.toggle('is-error', !!isError);
  }

  /**
   * Free-shipping tokens, shaped like bank rewards.
   *
   * Nick: the token belongs in "Your Rewards" on Classic and in Consumables on
   * Start Menu — not in a banner of its own. Both of those already render from
   * ONE list (invConsumables' own comment: "reading the same array the
   * Light/Dark 'Your Rewards' section renders also means the two themes cannot
   * disagree about what a member owns"). So the fix is to join that list rather
   * than to add a third place tokens can live.
   *
   * `id` is the token id, and `isShipToken` is what routes the button to the
   * shipping flow instead of the bank's activate — the two mint through
   * different endpoints.
   */
  /**
   * The date a reward or token unlocks, or null when nothing is holding it.
   *
   * Compared against NOW rather than trusted as a flag: the server writes a
   * date, never a status, so a row whose hold has quietly passed reads as
   * available here without waiting for anything to sweep it.
   */
  // "Held until this ships" — the server writes this when the order has not
  // been fulfilled yet, because an order can be cancelled right up to
  // fulfilment and there is no honest end date before then. Must match
  // HELD_UNTIL_SHIPPED in plm's lib/loyalty/hold-window.ts.
  var HRW_HELD_UNTIL_SHIPPED = '9999-12-31T23:59:59.999Z';

  function hrwPendingUntil(r) {
    if (!r || !r.availableAt) return null;
    // A date in the year 9999 is not a date to show anybody. It means the order
    // has not shipped, so say THAT — a member who reads "available 31 Dec 9999"
    // assumes the page is broken, which is worse than the wait itself.
    if (r.availableAt === HRW_HELD_UNTIL_SHIPPED) return 'when your order ships';
    var t = Date.parse(r.availableAt);
    if (!isFinite(t) || t <= Date.now()) return null;
    return formatLedgerDate(r.availableAt);
  }

  function hrwShipAsBankEntries() {
    return (hrwShipTokens || [])
      .filter(function (t) { return t.status === 'available' || t.status === 'active'; })
      .map(function (t) {
        return {
          id: t.id,
          label: 'Free shipping',
          // The bank's vocabulary: 'banked' is "yours, not yet live".
          status: t.status === 'active' ? 'active' : 'banked',
          code: t.code || null,
          availableAt: t.availableAt || null,
          rewardType: 'free_shipping',
          isShipToken: true,
        };
      });
  }

  function renderBank(data) {
    var list = root.querySelector('[data-bank-list]');
    if (!list) return;

    if (!loggedIn || (data && data.loggedIn === false)) {
      list.innerHTML = hrwAuthGate('rewards');
      return;
    }
    var rewards = ((data && data.rewards) || []).concat(hrwShipAsBankEntries());
    if (!rewards.length) {
      list.innerHTML = '<p class="hrw-rp__loading">Nothing here yet - redeem a reward above and it will appear in your bank.</p>';
      return;
    }

    // Blocking is PER REWARD now. Only the plain $-off codes are exclusive —
    // a voucher or a product reward can go live alongside anything. The server
    // sends `activatable` (the ids that can go live right now) so this page
    // never has to re-derive that rule and drift from it.
    var activatable = (data && data.activatable) || null;
    var blockingId = data && data.blockingEntryId;
    function canUse(id, r) {
      // A shipping token is not a money-off code and the bank's one-at-a-time
      // rule does not apply to it — the server never lists it in `activatable`
      // because the server's bank does not know about it at all.
      if (r && r.isShipToken) return true;
      return activatable ? activatable.indexOf(id) !== -1 : !blockingId;
    }
    var anyBlocked = false;

    list.innerHTML = rewards.map(function (r) {
      var isActive = r.status === 'active';
      var isUsed = r.status === 'used';
      // Store credit is delivered at redemption and never becomes a code, so
      // "Used" would read as if the member had spent something. It went
      // straight to their balance.
      var isCredit = r.rewardType === 'store_credit';
      // PENDING beats every other line. A reward waiting out the return window
      // is not "in your bank" — the member paid for it and cannot touch it yet,
      // and the only useful thing to say is when that changes (Nick).
      var pendingUntil = hrwPendingUntil(r);
      var meta = pendingUntil
        ? ('Available ' + pendingUntil)
        : isCredit
          ? (isUsed ? 'Added to your store credit' : 'Being added to your account…')
          : r.isShipToken
            ? (isActive ? 'Ready to use' : 'Free shipping on one order')
            : (isUsed ? 'Used' : (isActive ? 'Ready to use' : 'In your bank'));

      // C8 — "exp: 42 days" ON BANKED REWARDS ONLY. Credit expiry is not shown
      // anywhere on this page (Nick): it is an 18-month activity clock that the
      // 60- and 30-day emails handle, and putting a countdown on a balance
      // would make a member who shops twice a year feel chased. A banked reward
      // is different — it has a hard 12-month deadline from the day they spent
      // credits on it, and that IS useful to see.
      //
      // Suppressed once used: a spent reward has no deadline left, and "exp: 3
      // days" beside "Used" reads as a threat about something already done.
      var expHtml = '';
      if (!isUsed && !pendingUntil && r.expiresAt) {
        var days = hrwDaysUntil(r.expiresAt);
        if (days != null && days >= 0) {
          expHtml = '<span class="hrw-rp__bank-exp">exp: ' + days + (days === 1 ? ' day' : ' days') + '</span>';
        }
      }

      var codeHtml = '';
      if (isActive && r.code) {
        // The auto-apply link is the primary path — typing a code by hand is
        // where members mistype and give up.
        // ?redirect= so applying a code LANDS somewhere useful. Without it
        // Shopify applies the discount and drops the member on whatever its
        // default is, which is not the shopping they were sent to do.
        var applyUrl = '/discount/' + encodeURIComponent(r.code) + '?redirect=/collections/all';
        codeHtml = '<div class="hrw-rp__bank-code">'
          + '<code>' + esc(r.code) + '</code>'
          // A shipping token's row already ends in a "Use" button that
          // goes to this exact URL, so the link here would be a second control
          // doing one job (Nick: "what's the difference between these two?" —
          // there wasn't one). The CODE stays either way: it is selectable on
          // purpose, as the copy-by-hand fallback when an extension blocks the
          // link.
          + (r.isShipToken ? '' : '<a class="hrw-rp__bank-apply" href="' + applyUrl + '">Apply &amp; shop</a>')
          + '</div>';
      }

      var btn;
      if (pendingUntil) {
        // No control at all rather than a disabled one. The server refuses a
        // held reward outright, so a greyed button would be a promise the page
        // cannot keep — the date IS the answer.
        btn = '';
      } else if (isUsed) {
        btn = '';
      } else if (isCredit) {
        // Still banked means the credit did not land. The only useful button is
        // one that tries again — the server's retry is idempotent, so pressing
        // it repeatedly cannot double-credit.
        btn = '<button type="button" class="hrw-rp__reward-btn" data-bank-activate="' + esc(r.id) + '">Add it to my account</button>';
      } else if (isActive && r.isShipToken) {
        // No "Return to bank": a shipping token was never in the bank, and its
        // code is already minted — the only useful action is to go spend it.
        btn = '<button type="button" class="hrw-rp__reward-btn" data-ship-use="' + esc(r.id) + '">Use</button>';
      } else if (isActive) {
        btn = '<button type="button" class="hrw-rp__reward-btn" data-bank-return="' + esc(r.id) + '">Return to bank</button>';
      } else if (r.isShipToken) {
        btn = '<button type="button" class="hrw-rp__reward-btn" data-ship-use="' + esc(r.id) + '">Redeem</button>';
      } else {
        var usable = canUse(r.id, r);
        if (!usable) anyBlocked = true;
        btn = '<button type="button" class="hrw-rp__reward-btn" data-bank-activate="' + esc(r.id) + '"'
          + (usable ? '' : ' disabled') + '>Redeem</button>';
      }

      return '<div class="hrw-rp__node hrw-rp__node--reward' + (isUsed ? ' is-used' : '') + '">'
        + '<span class="hrw-rp__node-icon">' + nodeIcon(r.image, shopIconFor(r.label, ''), r.label) + '</span>'
        + '<span class="hrw-rp__node-label">' + esc(r.label || 'Reward') + '</span>'
        + '<span class="hrw-rp__node-credits">' + esc(meta) + expHtml + '</span>'
        + codeHtml
        + btn
        + '</div>';
    }).join('');

    if (anyBlocked) {
      bankStatus('You can have one money-off reward ready at a time. Return the active one to your bank to use a different one - vouchers and product rewards are not affected.', false);
    } else {
      bankStatus('');
    }

    list.querySelectorAll('[data-bank-activate]').forEach(function (b) {
      b.addEventListener('click', function () { bankAction('activate', b.getAttribute('data-bank-activate'), b); });
    });
    list.querySelectorAll('[data-bank-return]').forEach(function (b) {
      b.addEventListener('click', function () { bankAction('return', b.getAttribute('data-bank-return'), b); });
    });
  }

  function bankAction(action, entryId, btn) {
    // Guarded because activate MINTS a discount code: a double-clicked button
    // firing twice is exactly the race the server's slot-claim exists to lose
    // safely, and there is no reason to make it defend against this page.
    if (hrwBankBusy || !entryId) return;
    hrwBankBusy = true;
    if (btn) btn.disabled = true;
    bankStatus(action === 'activate' ? 'Getting your reward ready…' : 'Returning it to your bank…');

    fetch(proxyBase + '/bank', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: action, entryId: entryId }),
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (res.ok) {
          bankStatus('');
          return loadBank();
        }
        // Named reasons, not a generic failure — "another is active" is a thing
        // the member can act on, and 409 is the expected answer to a race.
        var msg = res.data && res.data.error === 'another_is_active'
          ? 'You already have a money-off reward ready to use. Return it to your bank first.'
          : res.data && res.data.error === 'already_used'
            ? 'That reward has already been used.'
            : res.data && res.data.error === 'shopify_unavailable'
              ? 'Could not reach the store just now - try again in a moment.'
              : res.data && res.data.error === 'store_credit_failed'
                ? 'We could not add your store credit just now. Your credits are safe - try again in a moment, or contact us and we will add it by hand.'
                : 'Something went wrong. Please try again.';
        bankStatus(msg, true);
        return loadBank();
      })
      .catch(function () { bankStatus('Something went wrong. Please try again.', true); })
      .then(function () { hrwBankBusy = false; });
  }

  var hrwBankFreshSeen = false;
  function loadBank() {
    var list = root.querySelector('[data-bank-list]');
    if (!list) return Promise.resolve();
    if (!loggedIn) { renderBank({ loggedIn: false }); return Promise.resolve(); }
    // Saved copy first, on the first load only — same rule as loadBalance. The
    // bank render has no pop-ups or one-shots, so painting it twice is safe.
    if (!hrwBankFreshSeen && window.HakiMemberCache) {
      var savedBank = window.HakiMemberCache.read('/bank');
      if (savedBank) {
        try {
          hrwBank = savedBank.rewards || [];
          hrwBankData = savedBank;
          renderBank(savedBank);
          if (root.getAttribute('data-hrw-theme') === 'start-menu' && typeof renderInventory === 'function') renderInventory();
        } catch (e) {}
      }
    }
    return fetch(proxyBase + '/bank', { headers: { Accept: 'application/json' } })
      // .ok checked HERE now: this call never looked, so a failed response was
      // rendered as the bank — and would now also be SAVED as it.
      .then(function (r) { if (!r.ok) throw new Error('bank ' + r.status); return r.json(); })
      .then(function (data) {
        hrwBankFreshSeen = true;
        if (window.HakiMemberCache && data && Array.isArray(data.rewards)) window.HakiMemberCache.write('/bank', data);
        hrwBank = (data && data.rewards) || [];
        hrwBankData = data || null;
        renderBank(data);
        // Inventory shows the same rewards; keep it in step without a reload.
        if (root.getAttribute('data-hrw-theme') === 'start-menu' && typeof renderInventory === 'function') renderInventory();
      })
      .catch(function () {
        // Never leave the raw "Loading your rewards…" placeholder up forever —
        // that is the bug the Start Menu inventory hit when a panel was
        // remembered but never rendered.
        list.innerHTML = '<p class="hrw-rp__loading">Could not load your rewards just now.</p>';
      });
  }

  function redeemReward(btn, opts) {
    opts = opts || {};
    var status = opts.statusEl || root.querySelector('[data-redeem-status]');
    function say(msg) { if (opts.onStatus) opts.onStatus(msg); else if (status) { status.hidden = false; status.textContent = msg; } }
    var rewardId = opts.rewardId || btn.getAttribute('data-reward-id');
    var card = btn.closest('.hrw-rp__node--reward');
    var rewardLabel = opts.label || (card && card.querySelector('.hrw-rp__node-label') || {}).textContent || 'Reward';
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Redeeming…';
    // Minted once per click and never regenerated on retry within this
    // click's own lifecycle, matching the backend's own idempotency
    // contract (see app/api/loyalty/redeem's header, plm repo).
    var idempotencyKey = 'web-' + Date.now() + '-' + Math.random().toString(36).slice(2);
    fetch(proxyBase + '/redeem', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ rewardId: rewardId, idempotencyKey: idempotencyKey }),
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        // No local write any more (0374). Redemption BANKS the reward
        // server-side and loadBank() below pulls it in — for both themes at
        // once. The old code cached the discount code here because it came
        // back exactly once and /balance never carried it, which is precisely
        // why a member who cleared their browser lost it.
        if (res.ok && res.data.redeemed) {
          if (opts.cost) hrwCoinBalance = Math.max(0, hrwCoinBalance - opts.cost);
          // No code comes back any more (0374): redeeming BANKS the reward and
          // the code is minted when the member activates it. That is what makes
          // a reward survive clearing this browser or switching device — the
          // old flow returned the code once and the page kept it in
          // localStorage, so it existed nowhere else.
          if (res.data.banked === 'failed') {
            say('Redeemed, but we could not add it to your rewards - our team has been alerted.');
          } else if (res.data.storeCredit === 'settled' || res.data.storeCredit === 'already_settled') {
            // Store credit is delivered at redemption, so "open it when you are
            // ready" would be wrong — there is nothing to open. It is already
            // spendable.
            say('Added to your store credit - it applies automatically at checkout.');
          } else if (res.data.storeCredit === 'failed') {
            say('Redeemed! Your store credit is taking a moment to land - your credits are safe, and it will appear shortly.');
          } else {
            say('Redeemed! It is in Your Rewards below - open it when you are ready to use it.');
          }
          renderInventory();
          // The redemption banked a reward server-side; pull it in so the
          // Light/Dark "Your Rewards" list shows it without a page reload.
          loadBank();
          // hrwRefreshAdvPanels() rebuilds the Shop scroller's whole
          // innerHTML, including the card `say()` just wrote this message
          // into — calling it in the same tick wiped the confirmation
          // (and any one-time discount code) before it was ever painted.
          // A short delay lets the member actually read it first (Nick).
          setTimeout(hrwRefreshAdvPanels, 1800);
        } else {
          say(res.data.error === 'insufficient_balance'
            ? 'You don’t have enough ' + coinWord() + ' for that reward yet.'
            : 'Something went wrong - try again in a moment.');
        }
      })
      .catch(function () {
        say('Couldn’t reach the rewards service - try again shortly.');
      })
      .finally(function () { btn.disabled = false; btn.textContent = originalText; });
  }

  // ================= Start Menu: Quests / The Item Shop / Hero's Journal =========
  // Shared "scroll a looping list on the left, a detail card on the right" view.
  // Only rendered in Start Menu; Light/Dark keep their own layouts.
  var hrwCatalog = { tiers: [], earnRules: [], rewards: [] };
  var hrwCoinBalance = 0;
  // B1 (2026-09-10). Cash rewards are locked until the member has one approved
  // purchase — 550 credits are free at signup and the $5 code costs 500, so
  // without this an account could hold a live code the same afternoon having
  // bought nothing. The server refuses these too (409 needs_first_order); this
  // is only so the page says WHY before the member spends a click on it.
  //
  // DEFAULTS TRUE, i.e. unlocked. A PLM that has not deployed B1 yet sends no
  // hasPurchased at all, and reading that absence as "locked" would grey out
  // every cash reward on the live site for everyone. The server is the gate;
  // the page is the explanation, and an explanation must fail open.
  var hrwHasPurchased = true;
  // §3.4 — the member's personal friend code, once they have one. Read for free
  // from /balance; minted by a button press against /referral, because creating
  // one for every member who merely loads this page would put ~15,700 live
  // discounts on the shop, most of them never shared.
  var hrwReferralCode = null;
  // C11 — grouped earn cards. Read from the section setting, default OFF, so
  // this ships inert and is turned on per theme in the editor.
  //
  // PHONES ONLY (Nick, 2026-09-24: "I like the look on mobile, but don't love
  // it on desktop"). The setting still switches it on and off; when it is on,
  // it applies at the theme's phone width (749px and below — the same cut
  // Dawn's own mobile layout uses) and desktop/tablet keep the one flat
  // honeycomb. Checked at render time, and the earn section re-renders when
  // the width crosses the line (rotating a tablet, resizing a window), so a
  // page never sits in the wrong layout until reload.
  var hrwEarnGroupSetting = root.getAttribute('data-earn-groups') === '1';
  var hrwEarnGroupMQ = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  function hrwEarnGroupedNow() {
    return hrwEarnGroupSetting && (!hrwEarnGroupMQ || hrwEarnGroupMQ.matches);
  }
  if (hrwEarnGroupSetting && hrwEarnGroupMQ) {
    // Re-render only when the answer FLIPS, never on every resize tick: the
    // earn tiles carry live state (quiz, tag-us form) that a needless
    // re-render would reset. Listens on the media query's change event AND on
    // plain resize, for the same reason syncDock() does — some embedded
    // WebViews (the Instagram in-app browser is a large share of our traffic)
    // fire one but not the other.
    var hrwEarnWasGrouped = hrwEarnGroupedNow();
    var hrwEarnRegroup = function () {
      var now = hrwEarnGroupedNow();
      if (now === hrwEarnWasGrouped) return;
      hrwEarnWasGrouped = now;
      if (hrwLastCatalog) renderEarn(hrwLastCatalog.rules, hrwLastCatalog.tiers);
    };
    if (hrwEarnGroupMQ.addEventListener) hrwEarnGroupMQ.addEventListener('change', hrwEarnRegroup);
    else if (hrwEarnGroupMQ.addListener) hrwEarnGroupMQ.addListener(hrwEarnRegroup);
    window.addEventListener('resize', hrwEarnRegroup);
  }
  var HRW_TICK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>';

  /**
   * Get the member's friend code (minting it on first ask) and copy it.
   *
   * COPIES THE SHARE LINK, NOT THE BARE CODE. /discount/CODE applies itself, so
   * the friend never has to remember to type anything at checkout — which is
   * where a referral is actually lost. The code itself is shown beside it for
   * anyone who wants to say it out loud.
   */
  function hrwReferral(btn, onStatus) {
    var say = onStatus || function () {};
    if (!loggedIn) { say('Log in to get your code.', false); return; }

    function finish(code, shareUrl) {
      hrwReferralCode = code;
      var text = shareUrl || (location.origin + '/discount/' + code);
      var done = function () { say('Link copied - ' + code, true); };
      // The clipboard can refuse (permissions, an insecure context, an older
      // browser). Showing the code is the fallback that always works, and is
      // better than a silent no-op on a button the member just pressed.
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function () { say('Your code: ' + code, true); });
      } else {
        say('Your code: ' + code, true);
      }
      if (hrwLastCatalog) renderEarn(hrwLastCatalog.rules, hrwLastCatalog.tiers);
    }

    if (hrwReferralCode) { finish(hrwReferralCode, null); return; }

    say('Making your code…', null);
    fetch(proxyBase + '/referral', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: '{}'
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (d) {
        if (d && d.code) finish(d.code, d.shareUrl);
        else say((d && d.message) || 'Could not make your code just now.', false);
      })
      .catch(function () { say('Could not make your code just now.', false); });
  }
  var hrwTierName = '';
  function coinWord() { return root.getAttribute('data-hrw-theme') === 'start-menu' ? 'Credits' : 'credits'; }

  var ADVSC_ICO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8"/><path d="M12 8v4l3 2"/></svg>';
  // completed-quest badge on the list row — mission-log style checkmark (Nick)
  var ADVSC_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>';
  // little spinning Haki coin for inline cost labels (still frame swaps in under
  // prefers-reduced-motion, same as the hero coin)
  var HRW_COIN_MINI = '<img class="hrw-rp__coin hrw-rp__coin--spin hrw-rp__coin--mini" src="' + HRW_RP_COIN_SPIN + '" width="16" height="16" alt="" aria-hidden="true" decoding="async">'
    + '<img class="hrw-rp__coin hrw-rp__coin--still hrw-rp__coin--mini" src="' + HRW_RP_COIN_STILL + '" width="16" height="16" alt="" aria-hidden="true" decoding="async">';

  function shopBlurb(r) {
    // store_credit is the REAL type in the catalogue (plm 0376); 'voucher' is
    // the older name kept as an alias. Neither was matching the $20 voucher's
    // actual reward_type, so it fell through to the discount-code line below
    // and told members it redeemed for "a $20 off code, applied at checkout"
    // (Nick). It does not — it lands as store credit on their account, which
    // is real money rather than a discount, needs no code, and is why it was
    // moved off discount codes in the first place.
    // "Redeem" deliberately does NOT appear in these lines any more
    // (2026-09-10). The shop's button is now Buy Now and Redeem belongs to the
    // bank, so a blurb that says "redeem for a code" here would name the wrong
    // button — and the two sit on the same page.
    if (r.rewardType === 'store_credit' || r.rewardType === 'voucher') {
      return 'Get $' + (r.voucherAmount || r.discountAmount || 0)
        + ' of store credit, added straight to your account - no code to enter, and it spends like money at checkout.';
    }
    if (r.rewardType === 'discount_percent' && r.discountPercent) return 'Get a ' + r.discountPercent + '% off code, applied at checkout.';
    if (r.rewardType === 'product' || r.fulfillment === 'manual') return 'Buy it and our team will email you to arrange it.';
    if (r.discountAmount) return 'Get a $' + r.discountAmount + ' off code, applied at checkout.';
    return 'Get a discount code, applied at checkout.';
  }

  // ---- the shared scroller --------------------------------------------------
  // items: [{ title, meta, icon, body(html), kicker?, actions? }] plus optional
  // { type: 'header', title, meta } divider rows. Desktop: a vertical list on the
  // left, detail card on the right; a long list loops (5 stacked copies). Mobile
  // (<=780px): a horizontal cover-flow carousel with the card ABOVE it — the
  // centred tile grows, the ends shrink; headers are dropped (the card's kicker
  // carries the group).
  function renderAdvScroller(host, items, opts) {
    opts = opts || {};
    if (!host) return;
    if (!items || !items.length) {
      host.innerHTML = '<p class="hrw-rp__advsc-empty">' + esc(opts.empty || 'Nothing here yet.') + '</p>';
      return;
    }
    var REPS = 5;
    var horiz = !!(window.matchMedia && window.matchMedia(HRW_ADVSC_MOBILE_MQ).matches);
    // headers stay in horiz mode too — they render as slim group dividers in the
    // carousel (Main / Side / Completed).
    var n = items.length;
    var realN = items.filter(function (it) { return it.type !== 'header'; }).length;
    var firstReal = 0;
    for (var fi = 0; fi < n; fi++) { if (items[fi].type !== 'header') { firstReal = fi; break; } }
    // loop both axes once there's enough to loop without a visible seam
    var loopH = horiz && realN >= 3;
    // this whole function re-runs from scratch on every hrwRefreshAdvPanels()
    // call (theme switch, redemption, resize-breakpoint-cross) — it used to
    // always start back on firstReal, so scrolling deep into e.g. the mobile
    // Quests carousel and then rotating the device snapped straight back to
    // the top. `host` (unlike this function's own local vars) survives across
    // those re-renders, so it's used to remember which item was showing and
    // restore the same one if it's still in the new list (Nick).
    var startAt = firstReal;
    if (host.__hrwActiveTitle) {
      for (var si = 0; si < n; si++) {
        if (items[si].type !== 'header' && items[si].title === host.__hrwActiveTitle) { startAt = si; break; }
      }
    }

    function itemRow(it, i) {
      if (it.type === 'header') {
        if (horiz) {
          return '<li class="hrw-rp__advsc-div" data-advsc-i="' + i + '" data-advsc-head aria-hidden="true">' +
            '<span class="hrw-rp__advsc-div-t">' + esc(it.title) + '</span></li>';
        }
        return '<li class="hrw-rp__advsc-head" data-advsc-i="' + i + '" data-advsc-head aria-hidden="true">' +
          '<span class="hrw-rp__advsc-head-t">' + esc(it.title) + '</span>' +
          (it.meta ? '<span class="hrw-rp__advsc-head-n">' + esc(it.meta) + '</span>' : '') +
        '</li>';
      }
      return '<li class="hrw-rp__advsc-item' + (it.rarityColor ? ' has-rar' : '') + (it.done ? ' is-done' : '') + '" data-advsc-i="' + i + '"' + (it.rarityColor ? ' style="--rar:' + it.rarityColor + '"' : '') + ' role="button" tabindex="0" aria-label="' + esc(it.title + (it.meta ? '. ' + it.meta : '') + (it.rarity ? '. ' + it.rarity : '') + (it.done ? '. Completed' : '')) + '">' +
        '<span class="hrw-rp__advsc-item-ico">' + (it.icon || ADVSC_ICO)
          + (it.done ? '<span class="hrw-rp__advsc-item-check" aria-hidden="true">' + ADVSC_CHECK + '</span>' : '') + '</span>' +
        '<span class="hrw-rp__advsc-item-txt">' +
          '<span class="hrw-rp__advsc-item-title"><span class="hrw-rp__advsc-item-title-t">' + esc(it.title) + '</span>' + (it.rarityColor ? '<i class="hrw-rp__advsc-item-rar" style="background:' + it.rarityColor + '"></i>' : '') + '</span>' +
          (it.meta ? '<span class="hrw-rp__advsc-item-meta">' + esc(it.meta) + '</span>' : '') +
        '</span>' +
      '</li>';
    }
    // a short list (Lore) just renders as a plain static list — no fixed-height
    // scroll box, no edge feathering, no loop (opts.static, desktop only)
    var isStatic = !!opts.static && !horiz;
    // Item Shop (desktop): the left column is a set of small rarity grids that
    // sit apart, each tinted its rarity colour (opts.grouped) (Nick).
    var grouped = !!opts.grouped && !horiz;
    var setHtml = '<ul class="hrw-rp__advsc-set">' + items.map(itemRow).join('') + '</ul>';
    // horiz, not enough to loop: blank spacers so the first / last tile can still
    // reach the centre. When looping there are always full sets on both sides.
    var pad = (horiz && !loopH) ? '<li class="hrw-rp__advsc-pad" aria-hidden="true"></li>' : '';
    var listInner = loopH ? new Array(REPS + 1).join(setHtml) : (pad + setHtml + pad);

    function groupCell(it, i) {
      return '<button type="button" class="hrw-rp__advsc-cell" data-advsc-i="' + i + '"'
        + (it.rarityColor ? ' style="--rar:' + it.rarityColor + '"' : '')
        + ' aria-label="' + esc(it.title + (it.meta ? '. ' + it.meta : '') + (it.rarity ? '. ' + it.rarity : '')) + '">'
        + '<span class="hrw-rp__advsc-cell-ico">' + (it.icon || ADVSC_ICO) + '</span>'
        + '<span class="hrw-rp__advsc-cell-t">' + esc(it.title) + '</span>'
        + (it.metaHtml ? '<span class="hrw-rp__advsc-cell-c">' + it.metaHtml + '</span>'
            : it.meta ? '<span class="hrw-rp__advsc-cell-c">' + esc(it.meta) + '</span>' : '')
        + '</button>';
    }
    var groupsHtml = '';
    if (grouped) {
      var gs = [];
      items.forEach(function (it, i) {
        if (it.type === 'header') return;
        var key = (it.rarity || '~') + '|' + (it.rarityColor || '');
        var g = gs[gs.length - 1];
        if (!g || g.key !== key) { g = { key: key, label: it.rarity || '', color: it.rarityColor || 'var(--adv-accent, #b0682f)', rows: [] }; gs.push(g); }
        g.rows.push({ it: it, i: i });
      });
      groupsHtml = gs.map(function (g) {
        return '<section class="hrw-rp__advsc-group" style="--rar:' + g.color + '">'
          + (g.label ? '<h4 class="hrw-rp__advsc-group-h"><i></i>' + esc(g.label) + '</h4>' : '')
          + '<div class="hrw-rp__advsc-group-cells">'
          + g.rows.map(function (o) { return groupCell(o.it, o.i); }).join('')
          + '</div></section>';
      }).join('');
    }

    host.innerHTML =
      '<div class="hrw-rp__advsc-wrap' + (horiz ? ' is-horiz' : '') + (isStatic ? ' is-static' : '') + (grouped ? ' is-grouped' : '') + '">' +
        '<aside class="hrw-rp__advsc-card" data-advsc-card></aside>' +
        (grouped
          ? '<div class="hrw-rp__advsc-groups" data-advsc-scroll>' + groupsHtml + '</div>'
          : '<div class="hrw-rp__advsc-list" data-advsc-scroll tabindex="0">' + listInner + '</div>') +
      '</div>';

    var scroll = host.querySelector('[data-advsc-scroll]');
    var card = host.querySelector('[data-advsc-card]');
    var active = -1, itemH = 84, setH = 0, setW = 0, loop = false, rows = scroll.querySelectorAll('[data-advsc-i]');
    // hover still live-previews the card (unchanged) until an actual click
    // "locks" it onto that item — hovering elsewhere then no longer steals the
    // card back until the next click (Nick).
    var hoverLocked = false;

    function isHeader(i) { return items[((i % n) + n) % n].type === 'header'; }
    function nextReal(i) { i = ((i % n) + n) % n; var guard = 0; while (isHeader(i) && guard++ < n) i = (i + 1) % n; return i; }

    function markActive(i) {
      rows.forEach(function (el) { el.classList.toggle('is-active', +el.getAttribute('data-advsc-i') === i); });
    }
    function renderCard(it) {
      card.style.setProperty('--rar', it.rarityColor || 'var(--adv-accent, #b0682f)');
      card.classList.toggle('has-rar', !!it.rarityColor);
      card.innerHTML =
        '<span class="hrw-rp__advsc-card-ico">' + (it.icon || ADVSC_ICO) + '</span>' +
        ((it.kicker || opts.kicker) ? '<p class="hrw-rp__advsc-card-kicker">' + esc(it.kicker || opts.kicker) + '</p>' : '') +
        '<h3 class="hrw-rp__advsc-card-title">' + esc(it.title) + '</h3>' +
        (it.rarity ? '<p class="hrw-rp__advsc-card-rar"><i></i>' + esc(it.rarity) + '</p>' : '') +
        ((it.metaHtml || it.meta) ? '<p class="hrw-rp__advsc-card-meta">'
          + (it.metaHtml || esc(it.meta))
          + (it.productUrl
              ? '<a class="hrw-rp__advsc-card-moreinfo" href="' + esc(it.productUrl) + '" target="_blank" rel="noopener" aria-label="View this reward’s product page">'
                  + '<span class="hrw-rp__advsc-card-moreinfo-t">View product</span>'
                + '</a>'
              : (it.info ? '<span class="hrw-rp__advsc-card-moreinfo" data-advsc-moreinfo tabindex="0" role="button" aria-label="How to redeem or use this reward">'
                  + '<span class="hrw-rp__advsc-card-moreinfo-t">More info</span>'
                  + '<span class="hrw-rp__advsc-card-tip" role="tooltip">' + it.info + '</span>'
                  + '</span>' : ''))
          + '</p>' : '') +
        (it.body ? '<div class="hrw-rp__advsc-card-body">' + it.body + '</div>' : '') +
        '<div class="hrw-rp__advsc-card-act" data-advsc-act></div>' +
        '<p class="hrw-rp__advsc-card-msg" data-advsc-msg hidden></p>';
      var actMount = card.querySelector('[data-advsc-act]');
      // The newsletter quest carries a real form rather than a button.
      if (it.formHtml && actMount) actMount.insertAdjacentHTML('beforebegin', it.formHtml);
      var msgEl = card.querySelector('[data-advsc-msg]');
      function onStatus(m) { if (msgEl) { msgEl.hidden = false; msgEl.textContent = m; } }
      (it.actions || []).forEach(function (a) {
        var b = document.createElement(a.href ? 'a' : 'button');
        b.className = 'hrw-rp__advsc-card-btn' + (a.subtle ? ' is-subtle' : '') + (a.ghost ? ' is-ghost' : '');
        if (a.href) { b.href = a.href; if (a.blank) { b.target = '_blank'; b.rel = 'noopener'; } }
        else { b.type = 'button'; }
        b.textContent = a.label;
        if (a.disabled) b.disabled = true;
        if (a.fn) b.addEventListener('click', function () { a.fn(b, onStatus); });
        // Self-claiming Follow, same as the Light/Dark list: the link opens the
        // profile and the credit follows a few seconds later. Never
        // preventDefault — a popup blocker would eat the one thing they pressed.
        if (a.claims) {
          b.setAttribute('data-rule-key', a.claims);
          b.addEventListener('click', function () {
            if (b.getAttribute('data-claiming')) return;
            b.setAttribute('data-claiming', '1');
            window.setTimeout(function () {
              followClaim(b);
              onStatus('Credits added - thanks for following.');
              setTimeout(hrwRefreshAdvPanels, 1800);
            }, HRW_FOLLOW_CLAIM_MS);
          });
        }
        actMount.appendChild(b);
      });
      // "More info" — a hover tooltip (touch / keyboard toggles it).
      wireInfoToggle(card.querySelector('[data-advsc-moreinfo]'));
    }
    function setActive(i, force) {
      i = nextReal(i);
      if (i === active && !force) return;
      active = i;
      markActive(i);
      renderCard(items[i]);
      host.__hrwActiveTitle = items[i] && items[i].title;
    }
    // Mobile carousel: the card swaps content as you cycle, so lock it to the
    // tallest card in the set — no jump between cards, no dead space under the
    // short ones beyond what the tallest needs.
    function fitCardHeight() {
      if (!horiz || !card) return;
      // bail while the layout is still collapsing in (0-width card ⇒ text wraps
      // to a nonsense height); a later call (rAF / timeout below) catches up.
      if (card.offsetWidth < 200) return;
      var prev = card.style.minHeight;
      card.style.minHeight = '';
      var maxH = 0, keep = active;
      for (var ci = 0; ci < n; ci++) {
        if (items[ci].type === 'header') continue;
        renderCard(items[ci]);
        if (card.offsetHeight > maxH) maxH = card.offsetHeight;
      }
      if (keep >= 0) renderCard(items[keep]);
      card.style.minHeight = maxH ? maxH + 'px' : prev;
    }
    function centerEl(el, smooth) {
      if (!el) return;
      scroll.scrollTo({ left: el.offsetLeft - (scroll.clientWidth - el.offsetWidth) / 2, behavior: smooth ? 'smooth' : 'auto' });
    }
    // vertical loop: scroll to THIS exact row (not the middle-set copy of its
    // index) so clicking a neighbour moves one step, not a whole set.
    function centerRow(el, smooth) {
      if (!el) return;
      var er = el.getBoundingClientRect(), sr = scroll.getBoundingClientRect();
      var delta = (er.top + er.height / 2) - (sr.top + sr.height / 2);
      scroll.scrollTo({ top: scroll.scrollTop + delta, behavior: smooth ? 'smooth' : 'auto' });
    }
    function centerItem(i, smooth) {
      if (horiz) {
        var list = scroll.querySelectorAll('[data-advsc-i]');
        centerEl(list[loopH && list.length > n ? Math.floor(REPS / 2) * n + i : i], smooth);
        return;
      }
      var base = loop ? setH * Math.floor(REPS / 2) : 0;
      var top = base + i * itemH + itemH / 2 - scroll.clientHeight / 2;
      scroll.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
    }
    // mobile cover-flow: scale each tile by its distance from the viewport centre
    function coverFlow() {
      if (!horiz) return;
      var vc = scroll.scrollLeft + scroll.clientWidth / 2;
      var best = null, bestD = 1e9, list = scroll.querySelectorAll('[data-advsc-i]');
      list.forEach(function (el) {
        var c = el.offsetLeft + el.offsetWidth / 2;
        var d = Math.abs(c - vc);
        var t = Math.min(1, d / (el.offsetWidth * 1.7));
        el.style.setProperty('--cf', (1 - 0.32 * t).toFixed(3));
        el.style.setProperty('--cf-o', (1 - 0.5 * t).toFixed(3));
        if (d < bestD && !el.hasAttribute('data-advsc-head')) { bestD = d; best = el; }
      });
      if (best) setActive(+best.getAttribute('data-advsc-i'));
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        if (horiz) {
          if (loopH && setW) {
            var sl = scroll.scrollLeft;
            var nl = hrwLoopWrap(sl, setW, scroll.scrollWidth - scroll.clientWidth);
            if (nl !== sl) scroll.scrollLeft = nl;
          }
          coverFlow();
          return;
        }
        if (loop && setH) {
          var st = scroll.scrollTop;
          // keep the viewport inside sets 1..REPS-2 so there's always a full
          // identical set above and below — wrap by exactly one set, invisible.
          var nt = hrwLoopWrap(st, setH, scroll.scrollHeight - scroll.clientHeight);
          if (nt !== st) { scroll.scrollTop = nt; return; }
        }
        var centerY = scroll.scrollTop + scroll.clientHeight / 2;
        setActive(Math.round((centerY - itemH / 2) / itemH));
      });
    }
    scroll.addEventListener('scroll', onScroll, { passive: true });

    function wireRows() {
      rows = scroll.querySelectorAll('[data-advsc-i]');
      rows.forEach(function (el) {
        if (el.hasAttribute('data-advsc-head')) return;
        var i = +el.getAttribute('data-advsc-i');
        function activate() {
          if (horiz) centerEl(el, true);
          else if (loop) { centerRow(el, true); setActive(i, true); }
          else { hoverLocked = true; setActive(i, true); }
        }
        el.addEventListener('click', activate);
        el.addEventListener('mouseenter', function () { if (!loop && !horiz && !hoverLocked) setActive(i); });
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); activate(); }
        });
      });
    }

    function measureSetW() {
      var list = scroll.querySelectorAll('[data-advsc-i]');
      if (loopH && list.length > n) setW = list[n].offsetLeft - list[0].offsetLeft;
    }

    function init() {
      if (horiz) {
        loop = false;
        wireRows();
        measureSetW();
        setActive(startAt, true);
        fitCardHeight();   // sync — the rAF fallback below can stall in a bg tab
        centerItem(startAt, false);
        coverFlow();
        return;
      }
      if (isStatic || grouped) { loop = false; wireRows(); setActive(startAt, true); return; }
      var probe = scroll.querySelector('[data-advsc-i]');
      itemH = (probe && probe.offsetHeight) || 84;
      var oneSet = itemH * n;
      // only loop when one set comfortably exceeds the viewport — otherwise the
      // wrap seam becomes visible and the list "jumps".
      loop = oneSet >= scroll.clientHeight + itemH * 1.5;
      if (loop) {
        var one = scroll.querySelector('.hrw-rp__advsc-set').outerHTML;
        scroll.innerHTML = new Array(REPS + 1).join(one);
        setH = scroll.scrollHeight / REPS;
      }
      wireRows();
      setActive(startAt, true);
      if (loop) centerItem(startAt, false);
    }

    init();
    // re-measure once real layout exists (offsetHeight can be 0 in a hidden tab)
    // a non-rAF safety net — rAF can stall in a background tab, and the first
    // sync fit may have run before the panel had a real width.
    if (horiz) setTimeout(fitCardHeight, 260);
    requestAnimationFrame(function () {
      if (horiz) { fitCardHeight(); measureSetW(); centerItem(active < 0 ? firstReal : active, false); coverFlow(); return; }
      if (loop && (!setH || setH < 1)) {
        setH = scroll.scrollHeight / REPS;
        centerItem(active < 0 ? firstReal : active, false);
      }
    });
  }

  // ---- per-panel item lists -------------------------------------------------
  // Quests grouped by cadence. Coin amounts come from the live catalog earn
  // rules (matched by key / label); a quest with no matching rule yet shows
  // "Reward coming soon" and lights up once PLM adds the rule.
  // difficulty is my first pass — Nick will re-rank later. 1 Easy / 2 Medium / 3 Hard.
  var QUEST_DIFF = ['', 'Easy', 'Medium', 'Hard'];
  var QUEST_GROUPS = [
    { title: 'Main Quests', note: 'One-time - clear each once.', quests: [
      { id: 'account', label: 'Create an account', ruleKeys: ['create_account'], icon: 'create_account', diff: 1,
        desc: 'Make a free customer account and the welcome Credits land straight away.',
        rewards: ['{coins} Credits'] },
      { id: 'newsletter', label: 'Sign up for our newsletter', ruleKeys: ['newsletter_signup'], icon: 'newsletter_signup', diff: 1,
        desc: 'Join the mailing list from the footer of any page - Credits post once you confirm.',
        rewards: ['{coins} Credits', 'First word on restocks & drops'] },
      { id: 'socials', label: 'Follow our socials', ruleKeys: ['instagram_follow', 'facebook_like'], icon: 'instagram_follow', diff: 1,
        desc: 'Follow @haki.magazine on Instagram and Facebook, then come back and claim.',
        rewards: ['{coins} Credits'] },
      { id: 'discord', label: 'Join our Discord', ruleKeys: ['discord_join'], icon: 'discord_join', diff: 2,
        desc: 'Jump into the Haki Discord for drop alerts, early looks and the community.',
        rewards: ['{coins} Credits', 'Member-only channels'] },
      { id: 'quiz', label: 'Take our quiz', ruleKeys: ['anime_quiz'], icon: 'anime_quiz', diff: 2,
        desc: 'Answer a few quick questions so we can point you at the right pieces.',
        rewards: ['{coins} Credits', 'A starting six picked for you'] }
    ] },
    { title: 'Side Quests', note: 'Repeatable - come back and run these again.', quests: [
      { id: 'motw', label: 'Play Manga of the Week', ruleKeys: ['manga_of_the_week'], icon: 'manga_of_the_week', diff: 1,
        desc: 'Read this week’s pick on the Manga of the Week page.',
        rewards: ['{coins} Credits each week'] },
      { id: 'review', label: 'Leave a review', ruleKeys: ['leave_review'], icon: 'leave_review', diff: 2,
        desc: 'Review a piece you’ve bought - Credits post once it’s published.',
        rewards: ['{coins} Credits per review'] },
      { id: 'song', label: 'Suggest a song', ruleKeys: ['song_suggestion'], icon: 'song_suggestion', diff: 2,
        desc: 'Send a track for Haki radio - Credits land if it makes the wall.',
        rewards: ['{coins} Credits per pick that lands'] },
      { id: 'purchase', label: 'Make a purchase', perDollar: true, icon: 'purchase', diff: 3,
        desc: 'Every order earns Credits at your rank’s rate, posted once the order is confirmed.',
        rewards: ['{rate} Credits for every $1 spent'] },
      // Three rules were in the catalogue and on the Light/Dark list but had no
      // quest here, so they were invisible on Start Menu — which is the DEFAULT
      // theme. Between them that is 215 Credits of earning most members could
      // not see, including tag_us and magazine_follow at 100 each, the
      // joint-highest earns in the program (Nick spotted it).
      { id: 'note', label: 'Leave a note on the community page', ruleKeys: ['community_note'], icon: 'community_note', diff: 1,
        desc: 'Drop a note on the community globe - anyone can post, Credits land if you’re signed in.',
        rewards: ['{coins} Credits per note'] },
      { id: 'magazine', label: 'Follow our magazine page', ruleKeys: ['magazine_follow'], icon: 'magazine_follow', diff: 1,
        desc: 'Follow @haki.magazine, then come back and claim.',
        rewards: ['{coins} Credits'] },
      { id: 'tagus', label: 'Tag us in a post', ruleKeys: ['tag_us'], icon: 'tag_us', diff: 3,
        desc: 'Post wearing Haki, tag us, and send the link - we check it by hand.',
        rewards: ['{coins} Credits per post'] }
    ] }
  ];
  var QUEST_LINKS = {
    socials: { href: 'https://www.instagram.com/haki.magazine/', label: 'Open Instagram', blank: true },
    motw: { href: '/pages/manga-of-the-week', label: 'Play now' },
    review: { href: '/pages/reviews', label: 'Leave a review' },
    // Was /pages/community — the globe page, which has no song form on it at
    // all. The suggest form has only ever lived on /pages/radio.
    song: { href: '/pages/radio#haki-suggest', label: 'Suggest a song' },
    note: { href: '/pages/community', label: 'Leave a note' },
    magazine: { href: 'https://www.instagram.com/haki.magazine/', label: 'Follow', blank: true }
  };
  // which quest groups repeat. PLM will own the real per-quest cadence; until
  // then a Side quest is simply "repeatable" and a Main quest is one-and-done.
  var QUEST_REPEATABLE = { 'Side Quests': true };
  // Completed quests are tracked locally per customer: { questId: timesDone }.
  // (PLM is the real source of truth — this is the interim until a claimed-quests
  // endpoint exists. A successful claim in the scroller bumps the count.)
  var HRW_QLOG_KEY = 'hrw-qlog-' + (root.getAttribute('data-customer-id') || 'anon');
  function hrwLoadQLog() { try { var v = JSON.parse(localStorage.getItem(HRW_QLOG_KEY) || '{}'); return (v && typeof v === 'object') ? v : {}; } catch (e) { return {}; } }
  function hrwBumpQuest(id) {
    if (!id) return;
    var log = hrwLoadQLog();
    log[id] = (+log[id] || 0) + 1;
    try { localStorage.setItem(HRW_QLOG_KEY, JSON.stringify(log)); } catch (e) {}
  }
  function hrwRoman(n) {
    n = Math.max(0, Math.floor(+n || 0));
    if (!n) return '';
    var map = [[1000,'M'],[900,'CM'],[500,'D'],[400,'CD'],[100,'C'],[90,'XC'],[50,'L'],[40,'XL'],[10,'X'],[9,'IX'],[5,'V'],[4,'IV'],[1,'I']];
    var out = '';
    for (var i = 0; i < map.length; i++) while (n >= map[i][0]) { out += map[i][1]; n -= map[i][0]; }
    return out;
  }
  function advQuestItems() {
    var rules = hrwCatalog.earnRules || [], tiers = hrwCatalog.tiers || [];
    // Same fix as the Light/Dark card: their rate, not the entry rate.
    var rate = hrwMemberRate != null ? hrwMemberRate : ((tiers[0] && tiers[0].creditsPerDollar) || 0);
    function ruleFor(q) {
      var keys = q.ruleKeys || [];
      for (var i = 0; i < rules.length; i++) {
        var rk = String(rules[i].key || '');
        for (var j = 0; j < keys.length; j++) if (rk === keys[j] || rk.indexOf(keys[j]) >= 0) return rules[i];
      }
      for (var i2 = 0; i2 < rules.length; i2++) {
        if (q.id && String(rules[i2].label || '').toLowerCase().indexOf(q.id) >= 0) return rules[i2];
      }
      return null;
    }
    var qlog = hrwLoadQLog();
    // build one quest tile; `done` renders the "Completed" variant (roman numeral
    // on repeatables, no claim button).
    function buildQuest(q, grp, done) {
      var r = ruleFor(q);
      var coins = (r && r.credits != null) ? r.credits : null;
      function fill(t) {
        return t.replace('{coins}', coins != null ? coins.toLocaleString() : 'Credits').replace('{rate}', rate);
      }
      var diffN = q.diff || 0;
      var diffPips = '';
      for (var dp = 1; dp <= 3; dp++) diffPips += '<i' + (dp <= diffN ? ' class="is-on"' : '') + '></i>';
      var repeatable = !!QUEST_REPEATABLE[grp.title];
      var count = +qlog[q.id] || 0;
      // a completed repeatable carries its tally as a roman numeral (Leave a Review II)
      var title = q.label + (done && repeatable && count >= 1 ? ' ' + hrwRoman(count) : '');
      var it = {
        title: title,
        done: !!done,
        kicker: done ? 'Completed' : (grp.title === 'Main Quests' ? 'Main Quest' : 'Side Quest'),
        meta: done
          ? (repeatable ? 'Done ' + count + '×' : 'Completed')
          : (q.perDollar ? (rate + ' Credits per $1') : (coins != null ? coins.toLocaleString() + " Credits" : 'Reward coming soon')),
        icon: EARN_ICONS[q.icon] || DEFAULT_EARN_ICON,
        body: (diffN ? '<p class="hrw-rp__advsc-card-diff"><span class="hrw-rp__advsc-card-diff-pips" data-diff="' + diffN + '">' + diffPips + '</span> <b>Difficulty:</b> ' + QUEST_DIFF[diffN] + '</p>' : '')
          + '<p class="hrw-rp__advsc-card-lead">' + esc(q.desc) + '</p>'
          + '<div class="hrw-rp__advsc-card-rewards"><p class="hrw-rp__advsc-card-rewards-h">Quest Rewards</p><ul>'
          + q.rewards.map(function (l) { return '<li>' + esc(fill(l)) + '</li>'; }).join('') + '</ul></div>',
        actions: []
      };
      if (!done) {
        // Same decision as the Light/Dark list — hrwCardActions — turned into
        // this panel's action objects. The two renderers used to decide it
        // separately and drifted three times.
        var ql = QUEST_LINKS[q.id] || {};
        hrwCardActions(r || { key: q.id }, {
          earnState: r ? hrwEarnState(r) : null,
          loggedIn: loggedIn,
          questHref: ql.href,
          questLabel: ql.label,
        }).forEach(function (a) {
          if (a.type === 'state') { it.actions.push({ label: a.label, disabled: true }); return; }
          if (a.type === 'form') {
            // The real form, in the card. It used to link to "the card that has
            // one" — but on the rewards page that link goes nowhere visible, so
            // it was a dead button (Nick: "there's no text box to subscribe
            // here"). The quest card has plenty of room; my "no room" claim was
            // wrong.
            it.formHtml = hrwSubscribeFormHtml();
            return;
          }
          if (a.type === 'link') {
            it.actions.push({ label: a.label, href: a.href, blank: !!a.blank,
              claims: a.claims ? a.ruleKey : undefined });
            return;
          }
          if (a.action === 'quiz') {
            it.actions.push({ label: a.label, fn: function (b, onStatus) { openQuizForm(onStatus); } });
          } else if (a.action === 'referral') {
            it.actions.push({ label: a.label, fn: function (b, onStatus) { hrwReferral(b, onStatus); } });
          } else if (a.action === 'tagus') {
            it.actions.push({ label: a.label, fn: function (b, onStatus) { openTagUsForm(onStatus); } });
          } else {
            it.actions.push({ label: a.label, fn: function (b, onStatus) {
              claimEarnRule(b, { ruleKey: a.ruleKey, onStatus: onStatus, onDone: function () {
                hrwBumpQuest(q.id);
                setTimeout(hrwRefreshAdvPanels, 1800);
              } });
            } });
          }
        });
      }
      return it;
    }
    var out = [], completed = [];
    QUEST_GROUPS.forEach(function (grp) {
      var repeatable = !!QUEST_REPEATABLE[grp.title];
      var live = grp.quests.filter(function (q) {
        var done = (+qlog[q.id] || 0) > 0;
        if (done) completed.push(buildQuest(q, grp, true));
        return repeatable || !done;   // one-time quests drop out once done; repeatables stay
      });
      if (!live.length) return;
      out.push({ type: 'header', title: grp.title, meta: grp.note });
      live.forEach(function (q) { out.push(buildQuest(q, grp, false)); });
    });
    if (completed.length) {
      out.push({ type: 'header', title: 'Completed Quests', meta: 'Cleared - nice work.' });
      completed.forEach(function (it) { out.push(it); });
    }
    return out;
  }
  // Reward rarity: prefer the catalog value (editable in PLM), else derive it
  // from the coin cost / product value. Returns a key into INV_RARITY.
  function rewardRarity(r) {
    var key = typeof r.rarity === 'string' ? r.rarity.toLowerCase().trim() : '';
    if (INV_RARITY[key]) return key;
    if (r.retailValueUsd) return rarityForPrice(+r.retailValueUsd);
    return rarityForCoins(+r.costCredits || +r.cost || 0);
  }
  // A few catalog rewards get a bespoke icon by name (the generic reward-type
  // icon is the fallback). Storefront presentation knowledge, like EARN_ICONS —
  // deliberately not in PLM's catalog response.
  function shopIconFor(label, rewardType, fallback) {
    var s = String(label || '').toLowerCase();
    if (/crunchyroll/.test(s)) return INV_ICONS.crunchyroll;
    // /voucher/ used to be in here for the $500 Flight Voucher, but it also
    // caught the "$20 Store Voucher" and gave store credit a plane icon.
    // 'flight' alone still matches the reward this rule is for.
    if (/flight/.test(s)) return INV_ICONS.plane;
    if (/manga of the month/.test(s)) return INV_ICONS.mangabook;
    if (/\bhat\b|ballcap|\bcap\b/.test(s)) return INV_ICONS.hat;
    if (/sock/.test(s)) return INV_ICONS.socks;
    if (/hoodie/.test(s)) return INV_ICONS.hoodie;
    if (/jacket/.test(s)) return INV_ICONS.jacket;
    if (/crewneck|sweater/.test(s)) return INV_ICONS.crewneck;
    if (/shorts/.test(s)) return INV_ICONS.shorts;
    if (/\bpants\b|trousers/.test(s)) return INV_ICONS.pants;
    if (/tee\b|t-shirt|\bshirt\b/.test(s)) return INV_ICONS.shirt;
    return fallback || REWARD_ICONS[rewardType] || DEFAULT_REWARD_ICON;
  }
  // PLM's catalog has no product_url/product_handle column yet (REWARD_COLS
  // in lib/loyalty/db.ts doesn't carry one) — every product reward's "View
  // product" link falls back to /collections/all until that's added. A
  // couple of specific rewards need a real destination now, so match them
  // by label here, same pattern as shopIconFor above. Whichever comes back
  // from the catalog (r.productUrl / r.productHandle) still wins if PLM ever
  // does start sending one (Nick).
  function shopUrlFor(label) {
    var s = String(label || '').toLowerCase().trim();
    if (s === 'haki "star" socks') return 'https://haki-studios.com/products/haki-socks';
    if (s === 'take your pick: hat') return 'https://haki-studios.com/collections/hats';
    return null;
  }
  // shared "more info" tooltip open/close wiring — used by both the
  // Light/Dark reward-grid card and the Start Menu Item Shop card, which
  // used to each carry their own identical copy of this.
  function wireInfoToggle(mi) {
    if (!mi) return;
    mi.addEventListener('click', function (e) { e.preventDefault(); mi.classList.toggle('is-open'); });
    mi.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); mi.classList.toggle('is-open'); }
      if (e.key === 'Escape') mi.classList.remove('is-open');
    });
  }
  // How to redeem / use a reward — placeholder copy for now; the real text
  // should come from the PLM catalog (e.g. r.redeemHelp) once it's authored
  // there. Keyed off reward type. Inline markup only (the tooltip lives inside
  // a <span> — no block elements) — sentences separated by <br><br>.
  // The same test lib/loyalty/first-order-gate.ts makes on the server, so the
  // lock the member sees and the refusal they would get are one rule.
  // C6 + A2. Two things a member can only otherwise discover at checkout: that
  // a product reward has to ride along with a real order, and that a cash code
  // has a cart floor. Both come from PLM (fulfilment_mode, minimumOrderUsd) so
  // the page never hardcodes a number the catalogue can change.
  function hrwRewardFootnote(r) {
    if (!r) return '';
    var min = +r.minimumOrderUsd || 0;
    if (r.fulfilmentMode === 'ship_with_next_order') {
      // C12 — "pick any" ONLY when the reward really is a set. A collection
      // reward shows a hero product from that set, and without this line the
      // image reads as THE item rather than an example of it — which is the
      // difference between "Any Hat" and "that specific hat", and the member
      // finding out at checkout.
      var pick = r.isCollection ? 'Pick any · ' : '';
      return '<span class="hrw-rp__node-foot">' + pick + 'Held for your next order'
        + (min ? ' over $' + min : '') + '</span>';
    }
    if (min) return '<span class="hrw-rp__node-foot">On orders over $' + min + '</span>';
    return '';
  }

  // READ FROM THE REWARD, NOT ITS TYPE (2026-09-10). This used to gate only
  // cash codes. The final rule locks EVERYTHING except the $5 code, which is a
  // per-reward fact PLM sends as requiresFirstOrder — a type test cannot
  // express it, and a hardcoded id list here would be a second catalogue to
  // keep in step with the first.
  //
  // ABSENT READS AS **OPEN** HERE, the opposite of the server's default, and
  // deliberately so. A PLM that has not deployed 0443 sends no
  // requiresFirstOrder at all; treating that as locked would grey out the whole
  // catalogue on the live site at once. The server is the gate and fails
  // closed; the page is the explanation and fails open.
  function hrwNeedsFirstOrder(r) {
    if (!r || hrwHasPurchased) return false;
    return r.requiresFirstOrder === true;
  }

  function redeemHelp(r) {
    // C9 — THE OPERATOR'S OWN WORDS WIN. Everything below this line is a
    // type-guess, and it has been wrong twice: it told members to paste a code
    // for the $20 voucher (store credit, no code is ever minted) and described
    // a 90-day expiry that matches nothing. Both were guesses about a specific
    // reward made by code that only knows its type, and the person who knew the
    // right answer had nowhere to write it down. Now they do, in PLM.
    //
    // The fallback stays for every reward nobody has written copy for, which is
    // most of them — this makes the built-in text the default rather than the
    // only option.

    var contact = 'Questions? Email <a href="mailto:' + esc(HRW_SUPPORT_EMAIL) + '">' + esc(HRW_SUPPORT_EMAIL) + '</a>.';

    // C9 — THE OPERATOR'S OWN WORDS WIN over everything below. All of it is a
    // type-guess, and it has been wrong twice: it told members to paste a code
    // for the $20 voucher (store credit, no code is ever minted) and described
    // a 90-day expiry that matches nothing any more. Both were guesses about a
    // specific reward made by code that only knows its type, and the person who
    // knew the right answer had nowhere to write it down. Now they do, in PLM.
    //
    // Escaped, not trusted as HTML: it is operator input, and the contact line
    // is appended here so written copy never has to remember to include it.
    if (r && typeof r.moreInfo === 'string' && r.moreInfo.trim()) {
      return esc(r.moreInfo.trim()) + '<br><br>' + contact;
    }
    // STORE CREDIT, NOT A DISCOUNT CODE (Nick). plm 0376 changed the delivery
    // mechanism — redeeming now calls Shopify's storeCreditAccountCredit and
    // the money lands on the member's account balance. This copy still
    // described the old code-based voucher, and worse, it was keyed on the
    // 'voucher' alias only: the live catalog row is reward_type
    // 'store_credit', so it did not match here at all and fell through to the
    // discount-code paragraph below — telling members to paste a code that is
    // never issued. Both names are matched here for the same reason they are
    // matched in the redeem label.
    if (r.rewardType === 'store_credit' || r.rewardType === 'voucher') {
      var amt = r.voucherAmount || r.discountAmount || 0;
      return 'Redeeming adds <b>$' + amt + ' of store credit</b> to your account. It is not a discount code - there is nothing to copy and nothing to enter at checkout.<br><br>'
        + 'Because it is credit and not a discount, it never clashes with anything: use it alongside a sale, free shipping, your tier perk or another reward. It does not expire, and whatever you don’t spend stays on your account.<br><br>'
        + 'It lands on the account you redeemed with, within a few seconds - just be signed in to that account at checkout.<br><br>' + contact;
    }
    if (r.rewardType === 'product' || r.fulfillment === 'manual') {
      return 'Hit <b>Buy Now</b> and the Credits leave your balance right away. Our team then emails you within <b>2 business days</b> to arrange delivery or send your code - no shipping charge. Redemptions can’t be reversed once placed.<br><br>' + contact;
    }
    var kind = r.rewardType === 'discount_percent'
      ? (r.discountPercent ? r.discountPercent + '% off' : 'a percentage off')
      : ('$' + (r.discountAmount || 0) + ' off');
    return 'Redeeming mints a <b>one-time code</b> for ' + esc(kind) + ' an order. Copy it from the confirmation, then paste it into the <b>Discount code</b> box at checkout - it must be used against a purchase, not on its own.<br><br>'
      // A YEAR, not 90 days, and from the day it entered your bank rather than
      // the day the code was minted (0436/§0.3). And codes DO stack with a
      // promo code now (B10) — the minimum is what caps the combined discount.
      + 'One reward code per order, and it expires <b>a year</b> after you redeem it. It can be used alongside a promo code.<br><br>' + contact;
  }
  function advShopItems() {
    var rewards = hrwCatalog.rewards || [];
    var items = rewards.map(function (r) {
      var cost = +r.costCredits || +r.cost || 0;
      var valueLabel = r.rewardType === 'discount_percent' ? (r.discountPercent + '% off') : ('$' + (r.discountAmount || 0) + ' off');
      var afford = hrwCoinBalance >= cost;
      var locked = hrwNeedsFirstOrder(r);
      var rk = rewardRarity(r), rar = INV_RARITY[rk] || INV_RARITY.common;
      var it = {
        title: r.label || valueLabel,
        rarityRank: rar.rank,
        info: redeemHelp(r),
        meta: cost.toLocaleString() + " Credits",
        // the card shows the cost as {coin} 500 COINS in the accent colour — no
        // "Cost:" preface, no duplicate line in the body.
        metaHtml: '<span class="hrw-rp__advsc-card-cost">' + HRW_COIN_MINI
          + '<span>' + cost.toLocaleString() + ' ' + coinWord() + '</span></span>',
        rarity: rar.label, rarityColor: rar.color,
        icon: shopIconFor(r.label, r.rewardType),
        body: '<p class="hrw-rp__advsc-card-lead">' + esc(shopBlurb(r)) + '</p>'
          + (r.retailValueUsd ? '<p class="hrw-rp__advsc-card-note">Retail value ~$' + r.retailValueUsd + '</p>' : '')
          + (hrwRewardFootnote(r)
              ? '<p class="hrw-rp__advsc-card-note">' + hrwRewardFootnote(r).replace(/<[^>]*>/g, '') + '</p>'
              : ''),
        actions: []
      };
      if (!loggedIn) it.actions.push({ label: 'Log in to buy', disabled: true });
      // BEFORE the affordability branch on purpose. A member who is both locked
      // and short of credits should be told the thing they cannot fix by
      // waiting — "1,000 more Credits needed" is a lie when the reward would
      // still refuse at 1,000.
      else if (locked) it.actions.push({ label: 'Unlocks after your first order', disabled: true, ghost: true });
      else if (afford) it.actions.push({
        label: 'Buy Now',
        fn: function (b, onStatus) { redeemReward(b, { rewardId: r.id, label: r.label, cost: cost, onStatus: onStatus }); }
      });
      // C10 — ENDOWED PROGRESS. "1,000 more Credits needed" states the gap; the
      // member's own credits are invisible in it, so a new member who has done
      // the start-here tasks reads their 550 as nothing. "550 / 1,000" says the
      // same arithmetic with the progress already made in it.
      //
      // Nunes & Drèze (2006): a 10-stamp card with 2 pre-filled was completed
      // by 34% against 19% for an 8-stamp card needing identical effort. The
      // credits are the pre-filled stamps; showing only the remainder throws
      // the effect away.
      else it.actions.push({
        label: hrwCoinBalance.toLocaleString() + ' / ' + cost.toLocaleString(),
        disabled: true, ghost: true,
      });
      // physical products: the meta-line link becomes a direct "View product"
      // link out to the storefront instead of the generic redemption-help
      // "More info" tooltip (Nick) — see renderCard's meta-line branch below.
      if (r.rewardType === 'product') {
        it.productUrl = r.productUrl || (r.productHandle ? '/products/' + r.productHandle : null) || shopUrlFor(r.label) || '/collections/all';
      }
      return it;
    });
    // Item Shop reads top-to-bottom by rarity: Common first, Legendary last.
    // Ties keep catalog order (stable sort in modern engines; index fallback).
    items.forEach(function (it, i) { it.__i = i; });
    items.sort(function (a, b) { return (a.rarityRank - b.rarityRank) || (a.__i - b.__i); });
    return items;
  }
  function advLoreItems() {
    var out = [];
    // Game-Menu-only lore entry: how spend maps to XP (mirrors XP_PER_DOLLAR).
    var rate = (hrwCatalog.tiers && hrwCatalog.tiers[0] && hrwCatalog.tiers[0].creditsPerDollar) || 0;
    out.push({
      title: 'How does XP work?',
      body: '<p>Every <b>$1</b> you spend is <b>' + XP_PER_DOLLAR + ' XP</b> on the map - so a $50 order is '
        + xp(50).toLocaleString() + ' XP. XP never resets; it only ever climbs, and each rank unlocks at a set XP total.'
        + (rate ? ' You also earn ' + rate + ' Credits per $1 to spend in the Item Shop - that’s separate from XP.' : '')
        + '</p>',
      icon: ADVSC_ICO
    });
    root.querySelectorAll('.hrw-rp__faq-item').forEach(function (d) {
      var q = ((d.querySelector('summary') || {}).textContent || '').trim();
      var a = (d.querySelector('.hrw-rp__faq-answer') || {}).innerHTML || '';
      if (q) out.push({ title: q, body: a, icon: ADVSC_ICO });
    });
    return out;
  }

  function hrwRefreshAdvPanels() {
    var q = root.querySelector('[data-advsc="quests"]');
    var s = root.querySelector('[data-advsc="shop"]');
    if (q) renderAdvScroller(q, advQuestItems(), { kicker: 'Quest', empty: 'More ways to earn are on their way.' });
    if (s) renderAdvScroller(s, advShopItems(), { kicker: 'Item', empty: 'The shop is being restocked.', grouped: true });
    renderHeroJournal();
    hrwRenderAdvHud();
    // Inventory was missing here — a session that lands on Start Menu with
    // "inventory" as the remembered panel but hasn't been through the resize
    // handler (the only other caller that happened to also call this
    // separately) never got its content rendered at all: the panel just sat
    // on its raw pre-JS placeholder ("Loading your inventory…") forever,
    // including for a logged-out visitor, who should instead see the sign-in
    // gate that renderInventory()'s own !loggedIn check already produces —
    // that check simply never ran (Nick).
    if (typeof renderInventory === 'function') renderInventory();
  }
  // the scrollers render a different layout above/below 780px — rebuild on a
  // real breakpoint crossing (rotate / resize).
  (function () {
    var wasNarrow = window.matchMedia && window.matchMedia(HRW_ADVSC_MOBILE_MQ).matches;
    var t = null;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var isNarrow = window.matchMedia && window.matchMedia(HRW_ADVSC_MOBILE_MQ).matches;
        if (isNarrow === wasNarrow) return;
        wasNarrow = isNarrow;
        if (root.getAttribute('data-hrw-theme') === 'start-menu') hrwRefreshAdvPanels();  // now covers inventory itself, see above
      }, 200);
    }, { passive: true });
  })();

  // ---- Hero's Journal: Lore (FAQ) + Accolades (trophies) tabs --------------
  var HRW_ACC_KEY = 'hrw-acc-' + (root.getAttribute('data-customer-id') || 'anon');
  function hrwLoadAccolades() {
    try { var v = JSON.parse(localStorage.getItem(HRW_ACC_KEY) || '{}'); return v && typeof v === 'object' ? v : {}; }
    catch (e) { return {}; }
  }
  var ACC_TROPHY = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M7 4h10v4a5 5 0 0 1-10 0V4Z"/><path d="M7 5H4v2a3 3 0 0 0 3 3M17 5h3v2a3 3 0 0 1-3 3"/><path d="M12 13v4M9 21h6M10 17h4"/></svg>';
  // Curated list. `earned` comes from localStorage[HRW_ACC_KEY] keyed by id — a
  // future job (globe / radio / MOTW) flips these on. Everything is locked for now.
  var HRW_ACCOLADES = [
    { id: 'listen_month', title: 'Monthly Listening Contributor', desc: 'Kept the community globe alive - logged listening time every month this season.' },
    { id: 'motw_streak_3', title: 'Manga of the Week - 3 Week Streak', desc: 'Voted on Manga of the Week three weeks running.' },
    { id: 'motw_streak_10', title: 'Manga of the Week - 10 Week Streak', desc: 'Ten straight weeks of Manga of the Week votes. Committed.' },
    { id: 'first_drop', title: 'Day One', desc: 'Placed an order during a drop’s first 24 hours.' },
    { id: 'globe_pin', title: 'On the Map', desc: 'Appeared as a live pin on the community globe.' },
    { id: 'reviewer', title: 'Field Notes', desc: 'Left five published product reviews.' },
    { id: 'the_chosen', title: 'The Chosen', desc: 'Reached the top rank of the Members Club.' }
  ];
  function renderAccolades(host) {
    if (!loggedIn) { host.innerHTML = hrwAuthGate('accolades'); return; }
    var earned = hrwLoadAccolades();
    var got = HRW_ACCOLADES.filter(function (a) { return earned[a.id]; }).length;
    host.innerHTML =
      '<p class="hrw-rp__advsc-accnote">' + got + ' of ' + HRW_ACCOLADES.length + ' unlocked. Accolades light up as you take part in drops, the globe, Manga of the Week and more.</p>' +
      '<ul class="hrw-rp__accgrid">' + HRW_ACCOLADES.map(function (a) {
        var on = !!earned[a.id];
        return '<li class="hrw-rp__acc' + (on ? ' is-earned' : '') + '">' +
          '<span class="hrw-rp__acc-ico">' + ACC_TROPHY + '</span>' +
          '<span class="hrw-rp__acc-title">' + esc(a.title) + '</span>' +
          '<span class="hrw-rp__acc-desc">' + esc(a.desc) + '</span>' +
          '<span class="hrw-rp__acc-state">' + (on ? 'Unlocked' : 'Locked') + '</span>' +
        '</li>';
      }).join('') + '</ul>';
  }
  var hjTab = 'lore';
  function renderHeroJournal() {
    var host = root.querySelector('[data-herojournal]');
    if (!host) return;
    if (!host.querySelector('[data-hj-tab]')) {
      host.innerHTML =
        '<div class="hrw-rp__hjtabs" role="group" aria-label="Journal">' +
          '<button type="button" class="hrw-rp__hjtab is-active" data-hj-tab="lore" aria-pressed="true">Lore</button>' +
          '<button type="button" class="hrw-rp__hjtab" data-hj-tab="accolades" aria-pressed="false">Accolades</button>' +
          '<button type="button" class="hrw-rp__hjtab" data-hj-tab="log" aria-pressed="false">Log</button>' +
        '</div>' +
        '<div class="hrw-rp__advsc" data-advsc="lore"></div>' +
        '<div class="hrw-rp__accwrap" data-accwrap hidden></div>' +
        '<div class="hrw-rp__hjlog" data-hjlog hidden></div>';
      host.querySelectorAll('[data-hj-tab]').forEach(function (b) {
        b.addEventListener('click', function () { hjTab = b.getAttribute('data-hj-tab'); paintHJ(); });
      });
    }
    paintHJ();
  }
  function paintHJ() {
    var host = root.querySelector('[data-herojournal]');
    if (!host) return;
    host.querySelectorAll('[data-hj-tab]').forEach(function (b) {
      var on = b.getAttribute('data-hj-tab') === hjTab;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var loreEl = host.querySelector('[data-advsc="lore"]');
    var accEl = host.querySelector('[data-accwrap]');
    var logEl = host.querySelector('[data-hjlog]');
    loreEl.hidden = hjTab !== 'lore';
    accEl.hidden = hjTab !== 'accolades';
    if (logEl) logEl.hidden = hjTab !== 'log';
    if (hjTab === 'accolades') {
      renderAccolades(accEl);
    } else if (hjTab === 'log') {
      renderJournalLog(logEl);
    } else {
      renderAdvScroller(loreEl, advLoreItems(), { kicker: 'Entry', empty: 'The journal is still being written.', static: true });
    }
  }
  // "Log" tab — the same rewards ledger the Light / Dark pages show, in the
  // Game-Menu Journal.
  function renderJournalLog(host) {
    if (!host) return;
    if (!loggedIn) { host.innerHTML = hrwAuthGate('rewards activity'); return; }
    var entries = hrwHistory || [];
    if (!entries.length) { host.innerHTML = '<p class="hrw-rp__advsc-empty">No activity yet - earn your first Credits from the Quests.</p>'; return; }
    var running = typeof hrwCoinBalance === 'number' ? hrwCoinBalance : 0;
    host.innerHTML = '<ul class="hrw-rp__hjlog-list">' + entries.map(function (e) {
      var positive = e.credits > 0;
      var balAfter = running;
      running -= e.credits;
      return '<li class="hrw-rp__hjlog-row">'
        + '<div class="hrw-rp__hjlog-main"><span class="hrw-rp__hjlog-label">' + esc(e.label) + '</span>'
        + '<span class="hrw-rp__hjlog-date">' + esc(formatLedgerDate(e.date)) + '</span></div>'
        + '<div class="hrw-rp__hjlog-amt"><span class="hrw-rp__hjlog-c ' + (positive ? 'is-pos' : 'is-neg') + '">'
        + (positive ? '+' : '') + e.credits + '</span>'
        + '<span class="hrw-rp__hjlog-bal">' + balAfter + ' bal</span></div>'
        + '</li>';
    }).join('') + '</ul>';
  }

  // ---- balance + ledger history (App Proxy — logged-in customers only) ----
  // ONE fetch feeds both the hero balance panel and the "Your Activity"
  // ledger at the bottom — app/api/loyalty/balance bundles history
  // alongside the balance (plm PR #778) specifically so this page never
  // needs a second signed App Proxy round trip for data shown on the same
  // load.
  if (!loggedIn) {
    // no balance to fetch — swap the "Loading…" chip for a plain 0 so the
    // header doesn't sit on a permanent spinner.
    var lo = root.querySelector('[data-balance-loading]');
    var co = root.querySelector('[data-balance-content]');
    if (lo) lo.hidden = true;
    if (co) {
      co.hidden = false;
      var ce = co.querySelector('[data-balance-credits]'); if (ce) ce.textContent = '0';
      var te = co.querySelector('[data-balance-tier]'); if (te) te.textContent = '-';
    }
  }
  // Extracted so it can be called again after something changes the
  // balance — subscribing from a reward card, for one. It was inline at top
  // level, which meant the only way to see a new balance was a page reload.
  // PAINT THE SAVED COPY FIRST (2026-09-24). Nick: "everytime i refresh the
  // rewards or account pages it is doing a fresh server pull." /balance took
  // ~2.8s on every load and this whole page waited on it. HakiMemberCache
  // (snippets/haki-member-cache.liquid) holds this member's last response on
  // this device; it is painted at once and the fresh one lands on top.
  //
  // Only on the FIRST call per page. loadBalance runs again after an earn or a
  // redeem, and that call must show the new number, not the saved one.
  //
  // The saved copy PAINTS but does not ACT: applyBalance(…, true) skips the
  // "You've received" and "You've earned" pop-ups (each fires once per page
  // load, so a stale copy would spend that one chance on old data) and the
  // tier map's spend, which is set only once and would otherwise freeze on the
  // stale figure. The fresh response does all of that as it always has.
  var hrwBalanceFreshSeen = false;
  function loadBalance() {
    if (!loggedIn) return;
    if (!hrwBalanceFreshSeen && window.HakiMemberCache) {
      var saved = window.HakiMemberCache.read('/balance');
      // A microtask, not inline: loadBalance's first call can come before the
      // rest of this file has run, and applyBalance needs all of it. The
      // microtask still lands before any network reply. It also yields to a
      // fresh response that somehow beat it, rather than painting over it.
      if (saved) Promise.resolve().then(function () {
        if (hrwBalanceFreshSeen) return;
        try { applyBalance(saved, true); } catch (e) {}
      });
    }
    fetch(proxyBase + '/balance')
      .then(function (r) { if (!r.ok) throw new Error('balance ' + r.status); return r.json(); })
      .then(function (data) {
        hrwBalanceFreshSeen = true;
        if (window.HakiMemberCache) window.HakiMemberCache.write('/balance', data);
        applyBalance(data, false);
      })
      .catch(function () {
        var loadingEl = root.querySelector('[data-balance-loading]');
        var errorEl = root.querySelector('[data-balance-error]');
        if (loadingEl) loadingEl.hidden = true;
        if (errorEl) errorEl.hidden = false;
        var levelupLoading = root.querySelector('[data-levelup-loading]');
        if (levelupLoading) levelupLoading.textContent = 'Couldn’t load your progress right now - try refreshing.';
        var ledgerLoading = root.querySelector('[data-ledger-loading]');
        if (ledgerLoading) ledgerLoading.textContent = 'Couldn’t load your activity right now - try refreshing.';
        // balance unknown — let the tier-map fall back to the "start of the
        // journey" view rather than blocking the toggle forever
        if (typeof window.__hrwTierMapSpend !== 'number') window.__hrwTierMapSpend = 0;
      });
  }

  // The balance render, shared by the saved copy and the fresh response.
  function applyBalance(data, fromCache) {
    // What they have already done. Repaint the earn list once it lands so
    // finished rewards go grey — before this the page had no idea, and the
    // only record was this browser's localStorage.
    // Both halves are repainted TOGETHER, and the repaint sits outside
    // either check. It used to live inside the `earned` branch, so a
    // response carrying a tier but no earned map — an older PLM, or an
    // earned read that failed and returned nothing — set the member's rate
    // and never drew it.
    var changed = false;
    if (data && data.tier && data.tier.creditsPerDollar != null) {
      hrwMemberRate = data.tier.creditsPerDollar;
      changed = true;
    }
    if (data && data.earned && typeof data.earned === 'object') {
      hrwEarned = data.earned;
      changed = true;
    }
    // EVERYTHING THE RENDERS READ, SET BEFORE THEY RUN. These four were
    // assigned ~60 lines below, after this block — so renderEarn re-ran
    // with hrwSpend still null and the rewards list was never re-rendered
    // at all. The visible result: the first-order lock never appeared, a
    // reward never showed "550 / 1,000", and the purchase card never said
    // "$97 to go". None of it errored; it just silently kept the values it
    // had before the member was known. Caught by rendering the page, not by
    // reading it.
    if (data) {
      if (data.creditBalance != null) { hrwCoinBalance = data.creditBalance; changed = true; }
      if (data.hasPurchased != null) { hrwHasPurchased = data.hasPurchased !== false; changed = true; }
      if (data.referralCode) { hrwReferralCode = data.referralCode; changed = true; }
      var spendNow = HRW_SPEND_OVERRIDE != null ? HRW_SPEND_OVERRIDE
        : (data.qualifyingSpend != null ? data.qualifyingSpend
           : (data.lifetimeSpend != null ? data.lifetimeSpend : null));
      if (spendNow != null) { hrwSpend = spendNow; changed = true; }
    }
    if (changed) {
      if (hrwLastCatalog) {
        renderEarn(hrwLastCatalog.rules, hrwLastCatalog.tiers);
        // The rewards list depends on hrwHasPurchased (the lock) and
        // hrwCoinBalance (the progress), neither of which exists at
        // catalogue time. Re-rendering here is what makes B1 and C10 real.
        renderRewards(hrwLastCatalog.rewards || []);
      }
      if (typeof hrwRefreshAdvPanels === 'function') { try { hrwRefreshAdvPanels(); } catch (e) {} }
    }
    var loadingEl = root.querySelector('[data-balance-loading]');
    var contentEl = root.querySelector('[data-balance-content]');
    if (loadingEl) loadingEl.hidden = true;
    if (contentEl) {
      contentEl.hidden = false;
      var creditsEl = contentEl.querySelector('[data-balance-credits]');
      var tierEl = contentEl.querySelector('[data-balance-tier]');
      if (creditsEl) creditsEl.textContent = data.creditBalance != null ? data.creditBalance : 0;
      if (tierEl) tierEl.textContent = (data.tier && data.tier.name) || '-';

      // Store credit — real money on the Shopify account, where the $20
      // voucher now lands. Shown only when there IS some: null means the
      // read failed, and a confident "$0.00" during an outage would look
      // like the member's voucher had vanished.
      hrwFillRewardsHeading(data);
      var scEl = contentEl.querySelector('[data-balance-storecredit]');
      var scAmt = contentEl.querySelector('[data-balance-storecredit-amount]');
      var sc = data.storeCredit;
      if (scEl) {
        var has = sc && typeof sc.amount === 'number' && sc.amount > 0;
        scEl.hidden = !has;
        if (has && scAmt) scAmt.textContent = '$' + sc.amount.toFixed(2);
      }
    }
    hrwCoinBalance = data.creditBalance != null ? data.creditBalance : 0;
    // Only an explicit false locks anything — see hrwHasPurchased.
    hrwHasPurchased = data.hasPurchased !== false;
    if (data.referralCode) hrwReferralCode = data.referralCode;
    hrwTierName = (data.tier && data.tier.name) || '';
    // `activity` is the merged feed (credits + tier-ups + token events).
    // `history` is the credits-only list and stays the fallback, so a PLM
    // that has not deployed the merge yet still renders a ledger rather
    // than an empty panel.
    renderLedger(data.activity || data.history || [], data.creditBalance != null ? data.creditBalance : 0);
    hrwHistory = data.history || [];
    renderInventory();
    hrwRefreshAdvPanels();   // Item Shop affordability, Inventory coin purse
    if (!fromCache) hrwCheckNewItems();   // "You've received" pop-up — once per page load, see above
    // "You've earned N credits" — after the items pop-up so the two queue
    // rather than overlap. Uses hrwHistory, set just above, to name the
    // reason when the ledger accounts for the delta exactly.
    if (!fromCache) hrwCheckCreditsEarned(hrwCoinBalance, hrwHistory);
    // QUALIFYING spend, not lifetime: tier standing runs on a rolling
    // 3-year window server-side, so a progress bar drawn from all-time
    // spend would eventually show a member further along than the tier
    // they actually hold. Falls back to lifetimeSpend so an older server
    // that does not send the field still renders something sensible.
    levelUpState.lifetimeSpend = HRW_SPEND_OVERRIDE != null
      ? HRW_SPEND_OVERRIDE
      : (data.qualifyingSpend != null ? data.qualifyingSpend
         : (data.lifetimeSpend != null ? data.lifetimeSpend : 0));
    // QUALIFYING, not lifetime — it is what the tier is actually computed
    // from (0367/0435), so "$97 to go" matches the threshold the member
    // will really cross rather than a number that includes refunded spend.
    hrwSpend = levelUpState.lifetimeSpend;
    // seed the tier-map with the spend it should draw (override wins), unless
    // the map was already built with one
    if (!fromCache && typeof window.__hrwTierMapSpend !== 'number') {
      window.__hrwTierMapSpend = levelUpState.lifetimeSpend;
    }
    maybeRenderLevelUp();
  }
  // Before loadBalance, so the confirmation is on screen while the balance is
  // still in flight rather than after it.
  hrwDiscordReturn();
  loadBalance();

  /**
   * The two figures either side of the "Rewards" heading: spendable credits on
   * the right, banked store credit on the left.
   *
   * Both stay hidden until /balance answers. A heading that flashes "0 CREDITS"
   * on every load before correcting itself is worse than one that grows into
   * place — and store credit stays hidden for good when there is none, because
   * `null` here means the Shopify read FAILED, and a confident "$0.00" during an
   * outage would read as a member's voucher having vanished. That is the same
   * rule the hero's store-credit line follows.
   */
  function hrwFillRewardsHeading(data) {
    var crWrap = root.querySelector('[data-rewards-cr]');
    var crNum = root.querySelector('[data-rewards-cr-amount]');
    if (crWrap && crNum) {
      var credits = data && data.creditBalance != null ? data.creditBalance : null;
      if (credits == null) { crWrap.hidden = true; }
      else { crNum.textContent = String(credits); crWrap.hidden = false; }
    }
    hrwRenderShipTokens(data && data.shippingTokens);
    var scWrap = root.querySelector('[data-rewards-sc]');
    var scNum = root.querySelector('[data-rewards-sc-amount]');
    if (scWrap && scNum) {
      var sc = data && data.storeCredit;
      var has = sc && typeof sc.amount === 'number' && sc.amount > 0;
      if (has) { scNum.textContent = '$' + sc.amount.toFixed(2); scWrap.hidden = false; }
      else { scWrap.hidden = true; }
    }
  }

  // ---- Free-shipping tokens -------------------------------------------------
  // What the member HOLDS. Distinct from the tier card's "N× free shipping
  // tokens/yr", which is the advertised allowance — this row is the ones in
  // hand, and the only place they can be spent.
  var hrwShipTokens = [];

  function hrwShipSay(msg, bad) {
    // Reuses the bank's status line — the token now lives in that list, so its
    // errors belong where the list's other errors already appear.
    try { bankStatus(msg || '', !bad); } catch (e) {}
  }

  function hrwRenderShipTokens(tokens) {
    hrwShipTokens = (tokens || []).slice();
    // No surface of its own any more (Nick): the tokens are rendered by
    // "Your Rewards" and by the Start Menu's Consumables tab, both of which
    // read the joined list. Re-render whichever is on screen.
    try { if (hrwBankData || hrwShipTokens.length) renderBank(hrwBankData || { rewards: [] }); } catch (e) {}
    try { if (typeof renderInventory === 'function') renderInventory(); } catch (e) {}
  }

  function hrwShipUse(btn) {
    if (!btn || btn.disabled) return;
    // THE BUTTON CARRIES ITS OWN TOKEN. This used to scan the list and take
    // the first usable one, which meant a member holding an active token could
    // press Redeem on a fresh row, get matched to the ACTIVE one, and be sent
    // to the shop with the old code — the fresh row never minting and never
    // changing (Nick). With several rows on screen, "the first one" is never
    // the one that was clicked.
    var id = btn.getAttribute('data-ship-use');
    var token = hrwShipTokens.filter(function (t) { return t.id === id; })[0];
    if (!token) return;

    // ALREADY MINTED: nothing to do but go and spend it.
    if (token.status === 'active' && token.code) {
      window.location.href = '/discount/' + encodeURIComponent(token.code) + '?redirect=/collections/all';
      return;
    }
    if (token.status !== 'available') return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Redeeming…';
    hrwShipSay('');

    fetch(proxyBase + '/shipping-token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ tokenId: token.id })
    })
      .then(function (r) { return r.json().then(function (j) { return { status: r.status, body: j }; }); })
      .then(function (res) {
        var b = res.body || {};
        if (b.activated && b.code) {
          // REDEEM SHOWS THE CODE; IT DOES NOT LEAVE THE PAGE. Redeeming and
          // going to the shop are two steps on purpose — the member asked for
          // the code, so the honest response is to hand it to them and let the
          // row become "Ready to use" with a Use button beside it. Navigating here
          // meant the code was minted and never seen (Nick: "it sends me to
          // the shop page, but the code doesn't display here in rewards").
          token.status = 'active';
          token.code = b.code;
          hrwRenderShipTokens(hrwShipTokens);
          hrwShipSay('Redeemed - your code is ready.');
          return;
        }
        btn.disabled = false;
        btn.textContent = original;
        hrwShipSay(b.message || 'That did not go through - try again shortly.', true);
        // The server's answer is the truth about what they hold; re-reading
        // beats patching our copy from a guess.
        try { loadBalance(); } catch (e) {}
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
        hrwShipSay('We couldn’t reach the shop just now - try again shortly.', true);
      });
  }


  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-ship-use]');
    if (b) { e.preventDefault(); hrwShipUse(b); }
  });

  // A small mark so an event reads as a different KIND of row at a glance,
  // rather than a credit row that lost its number.
  var HRW_ACTIVITY_ICON = {
    tier_up: '<span class="hrw-rp__ledger-mark" aria-hidden="true">\u25B2</span>',
    token_granted: '<span class="hrw-rp__ledger-mark" aria-hidden="true">\u2708</span>',
    token_redeemed: '<span class="hrw-rp__ledger-mark" aria-hidden="true">\u2708</span>',
    token_used: '<span class="hrw-rp__ledger-mark" aria-hidden="true">\u2708</span>'
  };

  function renderLedger(entries, currentBalance) {
    var list = root.querySelector('[data-ledger-list]');
    if (!list) return; // section only renders this block for logged-in customers
    if (!entries.length) {
      list.innerHTML = '<p class="hrw-rp__ledger-empty">No activity yet - earn your first credits above.</p>';
      return;
    }
    // entries are newest-first. Walk down carrying a running balance from the
    // real current balance, so each row shows the balance right after it —
    // the "reward growth" view.
    var running = typeof currentBalance === 'number' ? currentBalance : 0;
    var rows = entries.map(function (e) {
      var dateLabel = formatLedgerDate(e.date);
      // NOT EVERY ROW IS A CREDIT ROW any more (Nick: tier-ups and shipping
      // tokens belong here too). Those are events, not amounts: they carry no
      // number and must not touch the running balance, or every row above them
      // would show a balance the member never had.
      var isCredits = !e.kind || e.kind === 'credits';
      if (!isCredits) {
        return '<div class="hrw-rp__ledger-row is-event">' +
          '<div class="hrw-rp__ledger-main">' +
            '<div class="hrw-rp__ledger-label">' + HRW_ACTIVITY_ICON[e.kind] + escapeHtml(e.label) + '</div>' +
            '<div class="hrw-rp__ledger-date">' + escapeHtml(dateLabel) + '</div>' +
          '</div>' +
        '</div>';
      }
      var positive = e.credits > 0;
      var sign = positive ? '+' : '';
      var balAfter = running;
      running -= e.credits; // balance before this entry = the next (older) row's "after"
      return '<div class="hrw-rp__ledger-row">' +
        '<div class="hrw-rp__ledger-main">' +
          '<div class="hrw-rp__ledger-label">' + escapeHtml(e.label) + '</div>' +
          '<div class="hrw-rp__ledger-date">' + escapeHtml(dateLabel) + '</div>' +
        '</div>' +
        '<div class="hrw-rp__ledger-amt">' +
          '<div class="hrw-rp__ledger-credits ' + (positive ? 'is-positive' : 'is-negative') + '">' + sign + e.credits + '</div>' +
          '<div class="hrw-rp__ledger-balance">' + balAfter + ' bal</div>' +
        '</div>' +
      '</div>';
    }).join('');
    list.innerHTML = rows;
  }

  function formatLedgerDate(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    try {
      return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    } catch (e) {
      return d.toISOString().slice(0, 10);
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---- Start Menu "Inventory": rewards the member has claimed --------------
  // The /balance history shows a redemption happened (label + date + spend) but
  // NEVER carries the discount code — that only comes back from /redeem, once.
  // So we keep a per-customer local log of redemptions done on this page (code
  // included) and merge it with the history. "Used" is a state the member sets
  // themselves — pressing "Use" copies the code and files it under Used. Older
  // redemptions (before this feature, or from another device) show read-only
  // from history under Unused.
  var hrwHistory = null;
  // The localStorage redemption store (hrw-inv-*) is GONE (0374). Redeemed
  // rewards live in the server bank now, so they survive clearing this browser
  // and are the same on every device — which the old store could not do,
  // because the discount code came back exactly once at redemption and
  // /balance never carried it.
  //
  // No migration path is needed: zero redemptions had ever happened when this
  // changed, so no member had anything stored to lose.

  // ---- Inventory "NEW" tracking + the "You've received" pop-up ----------
  // Two SEPARATE localStorage sets, both keyed by invItemKey() (type+name):
  //  - HRW_INV_SEEN_KEY: every item the member has ever opened the About
  //    card for. Drives the "NEW" badge on a card (invCardIsNew below) —
  //    cleared the moment that item is actually looked at, any item type.
  //  - HRW_INV_KNOWN_KEY: every EARNED item (redeemed rewards only — not the
  //    evergreen key items or the wardrobe samples, which exist for every
  //    member regardless of activity) seen on a PAST page load. Diffed once
  //    per session against the current list to drive the "You've received"
  //    pop-up — a new item shows the pop-up "next time they log in", not
  //    immediately in the same session it was redeemed (that redemption
  //    already gets its own "Redeemed!" toast).
  var HRW_INV_SEEN_KEY = 'hrw-inv-seen-' + (root.getAttribute('data-customer-id') || 'anon');
  var HRW_INV_KNOWN_KEY = 'hrw-inv-known-' + (root.getAttribute('data-customer-id') || 'anon');
  // The credit balance as this browser last saw it, so a member who comes back
  // to a bigger number is told why. Keyed per customer like every other key
  // here — a shared device would otherwise show one person another's windfall.
  var HRW_LAST_CREDITS_KEY = 'hrw-last-credits-' + (root.getAttribute('data-customer-id') || 'anon');
  function hrwLoadSet(key) {
    try { var v = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function hrwSaveSet(key, arr) {
    try { localStorage.setItem(key, JSON.stringify(arr)); } catch (e) {}
  }
  // seenSet is optional — pass the array in when checking many items in a
  // loop (e.g. renderInventory's grid) so the same localStorage read/parse
  // isn't repeated once per item; omitted, it loads fresh for a one-off check.
  function invCardIsNew(it, seenSet) {
    if (!loggedIn) return false;
    return (seenSet || hrwLoadSet(HRW_INV_SEEN_KEY)).indexOf(invItemKey(it)) === -1;
  }
  function invMarkSeen(it) {
    var seen = hrwLoadSet(HRW_INV_SEEN_KEY);
    var key = invItemKey(it);
    if (seen.indexOf(key) === -1) { seen.push(key); hrwSaveSet(HRW_INV_SEEN_KEY, seen); }
  }
  // Runs ONCE per page load (called right after the balance fetch resolves,
  // not from renderInventory() — that fires on every redemption too, which
  // would pop this in the SAME session an item was earned, not "next time
  // they log in").
  function hrwCheckNewItems() {
    if (!loggedIn) return;
    var notifiable = [].concat(
      invConsumables(),
      invWearables().filter(function (w) { return w.ts != null; })   // real redemptions only, not the wardrobe samples
    );
    var raw = null;
    try { raw = localStorage.getItem(HRW_INV_KNOWN_KEY); } catch (e) {}
    var known = raw ? (function () { try { return JSON.parse(raw); } catch (e2) { return []; } })() : [];
    var isFirstVisit = raw === null;
    var newOnes = isFirstVisit ? notifiable.slice() : notifiable.filter(function (it) {
      return known.indexOf(invItemKey(it)) === -1;
    });
    hrwSaveSet(HRW_INV_KNOWN_KEY, notifiable.map(invItemKey));
    if (newOnes.length) hrwShowItemsReceived(newOnes);
  }
  // "You've earned N credits" — shown when the balance is higher than the last
  // one this browser saw (2026-09-09). Nick: "everytime someone logs in to a
  // different credit value than before".
  //
  // WHY A STORED BALANCE RATHER THAN A LIST OF LEDGER IDS. Credits arrive from
  // paths the page never witnesses: a purchase settling, the manga-of-the-week
  // play credited server-side by /balance itself, an operator adjustment. The
  // balance is the one number that moves for all of them, and comparing it
  // needs no agreement with the server about what counts as "new".
  //
  // FIRST VISIT IS SILENT, unlike the items pop-up above. With nothing stored
  // there is no "before", and treating it as zero would greet a long-standing
  // member with "You've earned 1,250 credits" for money they earned over a
  // year. Store the baseline and say nothing.
  function hrwCheckCreditsEarned(balance, history) {
    if (!loggedIn) return;
    // A failed read must never be read as zero — that would bank a 0 baseline
    // and then announce the member's whole balance as a windfall next load.
    if (typeof balance !== 'number' || !isFinite(balance)) return;
    var raw = null;
    try { raw = localStorage.getItem(HRW_LAST_CREDITS_KEY); } catch (e) {}
    var prev = raw == null ? null : parseInt(raw, 10);
    if (prev != null && isNaN(prev)) prev = null;   // corrupt value: re-baseline
    // Stored BEFORE showing, on purpose: if building the modal throws, the
    // member misses one pop-up. Storing after would re-announce the same
    // credits on every single reload until it stopped throwing.
    try { localStorage.setItem(HRW_LAST_CREDITS_KEY, String(balance)); } catch (e) {}
    if (prev == null) return;
    var delta = balance - prev;
    // Spending is not a celebration, and a clawed-back refund certainly is not.
    if (delta <= 0) return;
    hrwShowCreditsEarned(delta, hrwEarnReasons(delta, history));
  }

  // Name what the credits were for, but only when the ledger accounts for the
  // delta EXACTLY. A partial match would put a confident wrong reason on the
  // pop-up ("Play Manga of the Week" over a purchase's credits), which is worse
  // than the honest bare number. Walks newest-first and stops at the first
  // negative row, since a redemption in the window means the delta is a net
  // figure that no run of positives can be trusted to explain.
  function hrwEarnReasons(delta, history) {
    var out = [], sum = 0;
    var rows = history || [];
    for (var i = 0; i < rows.length; i++) {
      var e = rows[i];
      if (!e || typeof e.credits !== 'number') break;
      if (e.credits < 0) break;
      if (e.credits === 0) continue;
      sum += e.credits;
      if (sum > delta) return [];
      // celebrationLabel is the operator's own wording for this rule, set in
      // PLM (0427). `label` is the LEDGER's category, which is why following
      // the magazine, following TikTok, joining Discord and liking a post all
      // used to celebrate with the identical words "Social follow". Null when
      // nobody has typed one, which keeps the old behaviour.
      var reason = e.celebrationLabel || e.label;
      if (reason) out.push(reason);
      if (sum === delta) return out;
    }
    return [];
  }

  function hrwShowCreditsEarned(delta, reasons) {
    // Queue behind a rank-up or items pop-up rather than stacking on it —
    // same guard hrwShowItemsReceived uses.
    function attempt() {
      if (document.querySelector('[data-hrw-tierup]')) { setTimeout(attempt, 400); return; }
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var ov = document.createElement('div');
      ov.className = 'hrw-rp__tierup';
      hrwStampTheme(ov);
      ov.setAttribute('data-hrw-tierup', '');
      var sub = reasons && reasons.length
        ? '<p class="hrw-rp__tierup-sub">' + reasons.map(function (r) { return '<strong>' + esc(r) + '</strong>'; }).join(', ') + '</p>'
        : '';
      ov.innerHTML =
        '<div class="hrw-rp__tierup-box" role="dialog" aria-modal="true" aria-label="Credits earned">'
        + '<button type="button" class="hrw-rp__tierup-x" aria-label="Close">&times;</button>'
        + '<p class="hrw-rp__tierup-eyebrow">You&rsquo;ve earned</p>'
        + '<p class="hrw-rp__tierup-name">' + esc(delta + (delta === 1 ? ' Credit' : ' Credits')) + '</p>'
        + sub
        // A quiet dismiss, not the filled primary the tier-up modal uses. This
        // pop-up has no action behind it — the credits are already banked — so a
        // default-styled button offers a decision that does not exist. "Nice"
        // was placeholder wording standing in as that default (Nick).
        + '<button type="button" class="hrw-rp__tierup-cta hrw-rp__tierup-cta--quiet" data-hrw-credits-ok>Got it</button>'
        + '</div>';
      document.body.appendChild(ov);
      function close() { ov.classList.remove('is-open'); window.setTimeout(function () { ov.remove(); }, 240); }
      ov.querySelector('.hrw-rp__tierup-x').addEventListener('click', close);
      ov.querySelector('[data-hrw-credits-ok]').addEventListener('click', close);
      ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
      document.addEventListener('keydown', function onEsc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', onEsc); } });
      if (reduce) { ov.classList.add('is-open'); return; }
      void ov.offsetWidth;
      ov.classList.add('is-open');
    }
    attempt();
  }

  function hrwShowItemsReceived(items) {
    // don't stack over a rank-up modal firing in the same tick — wait for it
    function attempt() {
      if (document.querySelector('[data-hrw-tierup]')) { setTimeout(attempt, 400); return; }
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var ov = document.createElement('div');
      ov.className = 'hrw-rp__tierup';
      hrwStampTheme(ov);
      ov.setAttribute('data-hrw-tierup', '');
      var names = items.map(function (it) { return it.name; });
      var isMany = names.length > 1;
      ov.innerHTML =
        '<div class="hrw-rp__tierup-box" role="dialog" aria-modal="true" aria-label="Items received">'
        + '<button type="button" class="hrw-rp__tierup-x" aria-label="Close">&times;</button>'
        + '<p class="hrw-rp__tierup-eyebrow">You&rsquo;ve received</p>'
        + '<p class="hrw-rp__tierup-name">' + (isMany ? esc(names.length + ' New Items') : esc(names[0])) + '</p>'
        + (isMany ? '<p class="hrw-rp__tierup-sub">' + names.map(function (n) { return '<strong>' + esc(n) + '</strong>'; }).join(', ') + '</p>' : '')
        + '<button type="button" class="hrw-rp__tierup-cta" data-hrw-tierup-see>View in Inventory</button>'
        + '</div>';
      document.body.appendChild(ov);
      function close() { ov.classList.remove('is-open'); window.setTimeout(function () { ov.remove(); }, 240); }
      ov.querySelector('.hrw-rp__tierup-x').addEventListener('click', close);
      ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
      document.addEventListener('keydown', function onEsc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', onEsc); } });
      ov.querySelector('[data-hrw-tierup-see]').addEventListener('click', function () {
        close();
        if (root.getAttribute('data-hrw-theme') === 'start-menu' && typeof window.__hrwAdvNav === 'function') window.__hrwAdvNav('inventory', true);
      });
      if (reduce) { ov.classList.add('is-open'); return; }
      void ov.offsetWidth;
      ov.classList.add('is-open');
    }
    attempt();
  }
  // hrwSetUsed is gone with it: "used" was a per-browser opinion that also let
  // a member un-use a spent code. It is now a server fact, set when an order
  // actually carries the code (markBankEntryUsed).
  function looksRedeemed(e) {
    if (!e || typeof e.credits !== 'number' || e.credits >= 0) return false;
    return /redeem|reward|discount|voucher|code|claim/i.test(e.label || '');
  }
  function cleanRewardName(s) { return String(s || 'Reward').replace(/^\s*redeemed[:\s-]*/i, '').trim(); }

  // ---- rarity (Borderlands tiers) ----------------------------------------
  var INV_RARITY = {
    common:    { label: 'Common',    color: '#78746a', rank: 0 },   /* dark enough that the selection ring reads on a tan tile */
    uncommon:  { label: 'Uncommon',  color: '#4c9e3a', rank: 1 },
    rare:      { label: 'Rare',      color: '#3778d6', rank: 2 },
    epic:      { label: 'Epic',      color: '#9a3fd0', rank: 3 },
    legendary: { label: 'Legendary', color: '#e08a2b', rank: 4 }
  };
  function rarityForPrice(usd) {
    if (usd == null || isNaN(usd)) return 'uncommon';
    if (usd >= 120) return 'legendary';
    if (usd >= 80) return 'epic';
    if (usd >= 50) return 'rare';
    if (usd >= 30) return 'uncommon';
    return 'common';
  }
  function rarityForCoins(c) {
    c = +c || 0;
    if (c >= 3500) return 'legendary';
    if (c >= 2000) return 'epic';
    if (c >= 1000) return 'rare';
    if (c >= 500) return 'uncommon';
    return 'common';
  }
  function rarRank(r) { return (INV_RARITY[r] || INV_RARITY.common).rank; }
  var INV_ICONS = {
    purse: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9c0-2 2-3 6-3s6 1 6 3l1.5 9a2 2 0 0 1-2 2.4H6.5a2 2 0 0 1-2-2.4L6 9Z"/><path d="M9 6c0-2 1-3 3-3s3 1 3 3"/><circle cx="12" cy="13.5" r="2"/></svg>',
    map: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2Z"/><path d="M9 4v14M15 6v14"/></svg>',
    boots: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5h4v7l7 3a3 3 0 0 1 2 2.8V19H4V5Z"/><path d="M4 15h13"/></svg>',
    horse: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20c0-5 3-8 8-8 1-3 3-5 5-5l2-3-1 4 2 2-3 1c0 3-1 5-3 6l1 6h-3l-1-4-3 1 1 3H4Z"/></svg>',
    ship: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14h16l-2 5a3 3 0 0 1-2.8 2H8.8A3 3 0 0 1 6 19l-2-5Z"/><path d="M12 3v11M12 3l6 4-6 2M12 6 7 8l5 1"/></svg>',
    dragon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 15c3 0 4-2 4-4 0-3 3-5 6-5 2 0 3-1 3-3 1 2 0 4-1 5 3 0 5 2 5 5 0 4-3 7-8 7-2 0-3 1-3 3-1-2-1-4 0-5-3 0-5-1-6-3l-1 3-2-2 1-2Z"/><circle cx="15" cy="8.5" r="0.6" fill="currentColor"/></svg>',
    ticket: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8h16v3a2 2 0 0 0 0 4v3H4v-3a2 2 0 0 0 0-4z"/><path d="M13.5 8v11" stroke-dasharray="2 2.2"/></svg>',
    // shirt = the old short-sleeve round-neck crewneck shape (Nick)
    shirt: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 4 4.5 6 3 10.5l2.5 1V21h13v-9.5l2.5-1L19.5 6l-4-2a3.5 3.5 0 0 1-7 0Z"/><path d="M8.6 4c.5 1.4 1.9 2.4 3.4 2.4S14.9 5.4 15.4 4"/></svg>',
    // ---- garment icons — one mirror-symmetric long-sleeve body (about x=12,
    //      same construction as `shirt`: boxy body, triangular sleeves down to
    //      the cuff). jacket / hoodie / crewneck differ only in the neck detail.
    jacket: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 4 4 6 2.4 16.5 5.2 17.2V21H18.8V17.2L21.6 16.5 20 6 15 4C14.4 5 13.3 5.6 12 5.6 10.7 5.6 9.6 5 9 4Z"/><path d="M9 4 12 7.2 15 4"/><path d="M12 7.2V20.4"/></svg>',
    hoodie: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 4 4 6 2.4 16.5 5.2 17.2V21H18.8V17.2L21.6 16.5 20 6 15 4C14.4 5 13.3 5.6 12 5.6 10.7 5.6 9.6 5 9 4Z"/><path d="M9 4C8.7 2.3 9.9 1.4 12 1.4 14.1 1.4 15.3 2.3 15 4"/><path d="M9.6 4.3C10.3 5.9 13.7 5.9 14.4 4.3"/><path d="M10.9 5.1V8.9M13.1 5.1V8.9"/></svg>',
    crewneck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 4 4 6 2.4 16.5 5.2 17.2V21H18.8V17.2L21.6 16.5 20 6 15 4C14.4 5 13.3 5.6 12 5.6 10.7 5.6 9.6 5 9 4Z"/><path d="M9.5 4.4C10.3 5.8 13.7 5.8 14.5 4.4"/></svg>',
    // cargo shorts — baggy leg + a flap pocket on each thigh
    shorts: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16v2.6H4z"/><path d="M4 6.6 4.5 15.6h6L11.3 9.6h1.4l.8 6h6L20 6.6"/><path d="M5.1 9.3h3.3v3.5H5.1zM15.6 9.3h3.3v3.5h-3.3z"/></svg>',
    // sweatpants — tapered leg with an elastic ankle cuff + a waist drawstring
    pants: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 3.5h15V6h-15z"/><path d="M4.5 6 5.2 18.4 5.6 21h4.8L11 18.4 11.7 9.6h.6l.7 8.8L13.6 21h4.8l.4-2.6L19.5 6"/><path d="M5.5 18.4h4.9M13.6 18.4h4.9"/><path d="M11 4v2.6M13 4v2.6"/></svg>',
    hat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 14.5A6.5 6 0 0 1 15.5 8.5 6.5 6 0 0 1 22 14.2"/><path d="M9 14.5h12.2a1 1 0 0 1 0 1.8H9"/><path d="M9 14.5C4.6 14.5 1.8 15.3 1.8 16.4S4.6 18.3 9 16.3"/><path d="M15 8.6A1.1 1.1 0 0 1 17.2 8.6"/></svg>',
    socks: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(24,0) scale(-1,1)"><path d="M8 3h5v9l4 2.6a3 3 0 0 1-3.4 4.9L8 16V3Z"/><path d="M8 8.5h5"/></g></svg>',
    gameboy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2.5" width="14" height="19" rx="2"/><rect x="7.5" y="5" width="9" height="7" rx="0.8"/><path d="M9 16h2.4M10.2 14.8v2.4"/><circle cx="15" cy="16" r="1"/><path d="M9 19.5h6"/></svg>',
    // ---- item-shop-only icons
    mangabook: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="3" width="12" height="18" rx="1"/><path d="M9 3v18"/><path d="M12 7.5h3.5M12 10.5h3.5"/></svg>',
    // Crunchyroll — the solid "C" crescent (outer disc minus an offset disc,
    // even-odd) with the round "eye" floating in its mouth, in the mono icon
    // colour (Nick supplied the reference logo).
    crunchyroll: '<svg viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.7a9.3 9.3 0 1 0 0 18.6 9.3 9.3 0 0 0 0-18.6Zm3.5 1.9a7.4 7.4 0 1 1 0 14.8 7.4 7.4 0 0 1 0-14.8Z"/><circle cx="16.7" cy="8.7" r="2.1"/></svg>',
    plane: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M10.5 3.4a1.5 1.5 0 0 1 3 0V9l7.5 4.2v2L13.5 13v4l2.2 1.7V21L12 19.8 8.3 21v-1.3L10.5 17v-4L3 15.2v-2L10.5 9V3.4Z"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="1.6"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>',
    cassette: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="5.5" width="19" height="13" rx="2"/><circle cx="8.5" cy="12" r="2.2"/><circle cx="15.5" cy="12" r="2.2"/><path d="M10.7 12h2.6"/><path d="M6.5 18.5 8.1 15.3h7.8l1.6 3.2"/></svg>',
    magazine: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 6.5C9.8 5.2 7 4.5 4 4.5v13c3 0 5.8.7 8 2 2.2-1.3 5-2 8-2v-13c-3 0-5.8.7-8 2Z"/><path d="M12 6.5v11"/></svg>',
    pager: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="6.5" width="19" height="11" rx="1.6"/><rect x="5" y="9" width="9.5" height="6" rx="0.6"/><circle cx="18" cy="10.2" r="0.9" fill="currentColor"/><circle cx="18" cy="13.8" r="0.9" fill="currentColor"/></svg>',
    vaultkey: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="7.5" cy="12" r="3.6"/><circle cx="7.5" cy="12" r="1"/><path d="M11.1 12H20"/><path d="M17 12v3.4M20 12v2.6"/></svg>',
    brokenkey: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="7.5" r="3.2"/><circle cx="6" cy="7.5" r="0.9"/><path d="M8.3 9.8 12.4 13.9l-1.7.4"/><path d="M13.7 16.1 15.4 15.6 19.6 19.8"/><path d="M17.6 18.2 19.1 16.7M19.6 19.8 21.1 18.3"/></svg>',
    tome: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3.5h11a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6a2 2 0 0 1-2-2V5.5a2 2 0 0 1 2-2Z"/><path d="M4 17.5h14"/><path d="M9 3.5v16"/><path d="M12 7.5h3.5M12 10.5h3.5"/></svg>'
  };

  var INV_TYPE_ORDER = { key: 0, mount: 1, consumable: 2, wearable: 3 };
  var INV_TYPE_LABEL = { key: 'Key item', mount: 'Mount', consumable: 'Consumable', wearable: 'Wearable' };
  var invFilter = 'all', invSort = 'rarity';
  // the selected item, tracked by a STABLE key (name+type) so it survives a
  // re-sort / re-filter / re-render — the old index-based tracking is what made
  // the selection border "pop up only after clicking elsewhere".
  var invSelKey = null;
  function invItemKey(it) { return (it && it.type) + '␟' + (it && it.name); }

  function invCurTierIndex() {
    var tiers = (levelUpState && levelUpState.tiers) || [];
    var spend = (levelUpState && levelUpState.lifetimeSpend) || 0;
    return tiers.length ? computeCurrentTier(tiers, spend).currentIndex : 0;
  }
  // Only mounts the member has actually unlocked show up — no "locked" teasers.
  // "On foot" is always there so they can un-equip a mount for a replay.
  function invMounts() {
    var cur = invCurTierIndex();
    var maxU = mountMaxUnlocked(cur);
    var eq = equippedMount(cur).key;
    var out = [];
    for (var i = 0; i <= maxU; i++) {
      var d = MOUNTS[i];
      out.push({
        name: d.name, type: 'mount', rarity: d.rarity, icon: d.icon, mountKey: d.key,
        equipped: d.key === eq,
        sub: d.key === eq ? 'Equipped' : (d.key === 'foot' ? 'Starting kit' : 'In the stable'),
        desc: d.key === 'foot'
          ? 'A pair of regular running shoes. These may have something to do with the quest map.'
          : (d.desc + ' Equip it to ride this mount on the map.')
      });
    }
    return out;
  }
  function hrwVaultKeyBroken() {
    try { return localStorage.getItem('hrw-vaultkey-broken') === '1'; } catch (e) { return false; }
  }
  // When a *new* Rusty Vault Key is ever granted (a future reward), whatever
  // grants it should call this so the member gets the full break sequence again
  // — the "broken" flag is otherwise permanent per browser.
  window.__hrwGrantVaultKey = function () {
    try { localStorage.removeItem('hrw-vaultkey-broken'); } catch (e) {}
    if (root.getAttribute('data-hrw-theme') === 'start-menu' && typeof renderInventory === 'function') renderInventory();
  };
  function invKeyItems() {
    return [
      { name: 'Coin Purse', type: 'key', rarity: 'common', icon: INV_ICONS.purse, sub: 'Always with you', goPanel: 'shop', useLabel: 'Go To Item Shop', desc: 'Holds ' + hrwCoinBalance.toLocaleString() + ' ' + coinWord() + '. Spend them in the Item Shop.' },
      { name: 'Quest Map', type: 'key', rarity: 'uncommon', icon: INV_ICONS.map, sub: 'Always with you', useMap: true, desc: 'An odd map that seems to track your progress as you rank up.' },
      { name: 'Hakiboy Advance', type: 'key', rarity: 'rare', icon: INV_ICONS.gameboy, sub: 'Batteries low', useGameBoy: true, desc: 'A scuffed handheld console. Boot it up for a tiny overworld that reads out your balance, rank and stash.' },
      // these "use" straight to another corner of the site
      { name: 'Portable Cassette Player', type: 'key', rarity: 'uncommon', icon: INV_ICONS.cassette, sub: 'Pocket-sized', go: '/pages/radio?autoplay=1', desc: 'A portable cassette player. Contains a tape with the latest hits from HAKI Radio.' },
      { name: 'HAKI Magazine', type: 'key', rarity: 'rare', icon: INV_ICONS.magazine, sub: 'Latest issue', go: '/blogs/magazine', desc: 'A chic print magazine. The tagline reads, "The latest on all things animanga!"' },
      { name: 'Pager', type: 'key', rarity: 'rare', icon: INV_ICONS.pager, sub: 'Buzzing', go: '/pages/community', desc: 'A small pager. Send and view messages from other members of the HAKI Community.' },
      // The Rusty Vault Key breaks the first time it's used (see the vault page's
      // ?rewardskey= sequence); after that it shows as "A Broken Key".
      hrwVaultKeyBroken()
        ? { name: 'A Broken Key', type: 'key', rarity: 'common', icon: INV_ICONS.brokenkey, sub: 'Snapped', desc: 'The remains of a rusty key, likely used to open something important.' }
        : { name: 'Rusty Vault Key', type: 'key', rarity: 'epic', icon: INV_ICONS.vaultkey, sub: 'Heavy, cold', go: '/pages/vault?rewardskey=1', desc: 'An old and rusty key. Looks like it could crumble to pieces any second.' },
      { name: 'Ancient Tome', type: 'key', rarity: 'legendary', icon: INV_ICONS.tome, sub: 'Hand-bound', go: '/pages/about-us', desc: 'An old text that details the founding of Haki Studios.' }
    ];
  }
  function invConsumables() {
    // FROM THE SERVER BANK, not localStorage (0374). This used to read
    // hrwLoadRedemptions() — a per-browser store — so a member who cleared
    // their browser or opened the site on their phone saw an empty Inventory
    // and had no way to reach a reward they had paid credits for. The code
    // itself only ever came back once, at redemption, and /balance never
    // carries it.
    //
    // Reading the same array the Light/Dark "Your Rewards" section renders also
    // means the two themes cannot disagree about what a member owns.
    // Joined with the shipping tokens for the same reason the bank list is —
    // one list, so Classic's "Your Rewards" and this tab cannot disagree.
    var out = hrwBank.concat(hrwShipAsBankEntries()).map(function (r) {
      var m = String(r.label || '').match(/\$(\d+(?:\.\d+)?)/);
      var pct = String(r.label || '').match(/(\d+)%/);
      var rar = m ? rarityForPrice(+m[1]) : (pct ? rarityForPrice(+pct[1] * 1.2) : 'uncommon');
      var isActive = r.status === 'active';
      var isUsed = r.status === 'used';
      // Store credit never becomes a code (0376) — it lands straight on the
      // member's account. Describing it as "used" or offering "Take it out"
      // would be a lie about something they can already spend.
      var isCredit = r.rewardType === 'store_credit';
      return {
        name: cleanRewardName(r.label), type: 'consumable', rarity: rar,
        // purse, not ticket: this is money on the account, not a coupon.
        icon: isCredit ? INV_ICONS.purse : INV_ICONS.ticket,
        used: isUsed && !isCredit,
        // The bank entry id, not a timestamp — the actions below act on the
        // server row, so they need its identity.
        entryId: r.id,
        status: r.status,
        isCredit: isCredit,
        exclusive: r.exclusive !== false,
        ts: r.createdAt ? Date.parse(r.createdAt) : 0,
        code: isActive ? (r.code || '') : '',
        sub: isCredit
          ? (isUsed ? 'On your account' : 'Being added…')
          : (isUsed ? 'Used' : (isActive ? 'Ready to use' : 'In your bank')),
        desc: isCredit
          ? (isUsed
              ? 'Added to your store credit. It is applied automatically at checkout - nothing to copy, nothing to remember.'
              : 'We are adding this to your store credit. If it has not appeared, use the button below to try again - your credits are safe.')
          : isUsed
            ? 'You have used this reward.'
            : isActive
              ? 'Discount code: ' + (r.code || '') + '. Apply it at checkout, or use the link below.'
              : 'In your bank. Take it out when you are ready.'
      };
    });

    // Redemptions visible in the ledger history that the bank has no row for.
    // Only really possible for older rows predating the bank, or a redemption
    // whose bank write failed (which alerts ops) — shown read-only rather than
    // hidden, so a member is never told they own nothing when they paid.
    var known = hrwBank.map(function (r) { return cleanRewardName(r.label).toLowerCase(); });
    (hrwHistory || []).filter(looksRedeemed).forEach(function (h) {
      if (known.indexOf(cleanRewardName(h.label).toLowerCase()) >= 0) return;
      out.push({
        name: cleanRewardName(h.label), type: 'consumable', rarity: rarityForCoins(Math.abs(h.credits)),
        icon: INV_ICONS.ticket, used: false, sub: 'Contact us',
        desc: 'Redeemed for ' + Math.abs(h.credits) + ' ' + coinWord() + '. Get in touch and we will sort it out.'
      });
    });
    return out;
  }
  // Sample garments — one of every piece type we make, so the Wardrobe reads as
  // a real collection while order-history sync is still being built.
  var WARDROBE_SAMPLES = [
    { name: 'Jacket', icon: INV_ICONS.jacket, rarity: 'rare' },
    { name: 'Hoodie', icon: INV_ICONS.hoodie, rarity: 'uncommon' },
    { name: 'Crewneck', icon: INV_ICONS.crewneck, rarity: 'uncommon' },
    { name: 'Shirt', icon: INV_ICONS.shirt, rarity: 'common' },
    { name: 'Shorts', icon: INV_ICONS.shorts, rarity: 'common' },
    { name: 'Pants', icon: INV_ICONS.pants, rarity: 'common' },
    { name: 'Hat', icon: INV_ICONS.hat, rarity: 'uncommon' },
    { name: 'Socks', icon: INV_ICONS.socks, rarity: 'common' }
  ];
  function invWearables() {
    // EVERYTHING THE MEMBER OWNS FROM US. Not "physical rewards" — this tab is
    // their wardrobe, so it is their real purchase history, with returns
    // already netted off server-side (a piece they sent back is not theirs).
    //
    // Product rewards they redeemed belong here too: a pair of socks won from
    // the Item Shop is as owned as a pair they bought.
    var out = hrwWardrobe.map(function (p) {
      return {
        name: p.title, type: 'wearable',
        // Owned pieces are graded by how many we made, on the ladder set in
        // PLM (/loyalty → Rarity); PLM sends the tier. The account card's
        // "1/X" uses the same tier.
        rarity: INV_RARITY[p.rarity] ? p.rarity : 'common',
        icon: shopIconFor(p.title, '', INV_ICONS.shirt),
        img: p.image || null,
        sub: p.qty > 1 ? (p.qty + '\u00d7 owned') : 'Owned',
        ts: p.firstOwnedAt ? Date.parse(p.firstOwnedAt) : 0,
        href: p.handle ? '/products/' + p.handle : null,
        desc: 'Yours since ' + fmtOwnedDate(p.firstOwnedAt) + '.'
          + (p.qty > 1 ? ' You own ' + p.qty + '.' : '')
      };
    });

    // Redeemed PRODUCT rewards that have not shipped yet — they are owed the
    // item but it will not be in their order history until it goes out.
    hrwBank.filter(function (r) { return !r.code && r.status !== 'used'; }).forEach(function (r) {
      out.push({
        name: cleanRewardName(r.label), type: 'wearable', rarity: 'rare',
        icon: shopIconFor(r.label, '', INV_ICONS.shirt),
        sub: 'On its way', ts: r.createdAt ? Date.parse(r.createdAt) : 0,
        desc: 'Won from the Item Shop. Our team is arranging delivery - it will join your wardrobe once it ships.'
      });
    });

    // Samples ONLY while the member owns nothing, so an empty tab still reads
    // as a collection rather than a blank panel. Once they own a single real
    // piece the placeholders would be confusing next to it, so they go.
    if (!hrwWardrobe.length) {
      WARDROBE_SAMPLES.forEach(function (g) {
        out.push({
          name: g.name, type: 'wearable', rarity: g.rarity, icon: g.icon, sub: 'Sample',
          desc: 'A sample ' + g.name.toLowerCase() + ' from the Haki collection. Your own pieces appear here once you order.'
        });
      });
    }
    return out;
  }

  function fmtOwnedDate(iso) {
    if (!iso) return 'your first order';
    try {
      return new Date(iso).toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
    } catch (e) { return 'your first order'; }
  }

  // ---- tag_us: submit proof of a post -------------------------------------
  //
  // Submitting earns NOTHING. An operator looks at the post in PLM and
  // approves, and approving is what writes the credits. 100 credits for an
  // unverifiable click would be the most abusable thing in the program, and
  // this is the one rule where there is a public artifact to check.
  //
  // ONE MODAL, DRESSED THREE WAYS. The page ships Light, Dark and Start Menu,
  // and a dialog that ignores that reads as bolted on. The overlay mirrors the
  // page's data-hrw-theme so the CSS can dress it — a parchment quest scroll in
  // Start Menu, a clean sheet in Light/Dark — rather than three implementations
  // drifting apart. Same overlay/escape/backdrop mechanics as the rank-up
  // dialog, so it behaves like the rest of the page.
  var hrwTagBusy = false;
  // ---------------------------------------------------------------------
  // anime_quiz — the member profiling quiz (plm 0417, 2026-09-08).
  //
  // The rule paid 25 credits for a CLAIM until this shipped: a member pressed
  // a button, was believed, and told us nothing. Now completing it is what
  // pays, and the answers land in loyalty_quiz_responses where a segment can
  // reach them.
  //
  // WHY A DIALOG AND NOT A PAGE. The chrome, the three themes and the
  // open/close mechanics are already solved by the tag-us form — this reuses
  // those rules rather than adding a second implementation to drift. A member
  // also never leaves the rewards page, so their new balance appears in front
  // of them rather than after a redirect.
  //
  // THE FIRST FOUR ARE REQUIRED; birthday, socials and the closing free
  // response are not (Nick, 2026-09-09). The four that matter are the ones the
  // answers are actually FOR — what to make and who for — and a quiz that can
  // be clicked through in four Skips tells us nothing while still paying 25
  // credits. The three optional ones ask for personal data or an opinion, which
  // is exactly where a required field turns a favour into a chore.
  //
  // Skip is hidden rather than disabled on a required question: a visible
  // control that refuses to work reads as broken. The server still refuses only
  // a submission that answered nothing at all — this gate is the storefront's.
  //
  // ONE EXCEPTION, ON THE GIFT BRANCH (Nick, 2026-09-09). Somebody buying for
  // someone else often does not know their favourite series or character, and
  // requiring an answer there forces a guess — which is worse than no answer,
  // because a guess still lands in loyalty_quiz_responses looking like a real
  // preference. `giftOptional` un-requires those two when "Someone else" is
  // chosen, which reveals the Skip control that was already there. It is
  // resolved per render like the rest of the branch, so going back and
  // switching to "Myself" makes them required again.
  // ---------------------------------------------------------------------

  var hrwQuizBusy = false;

  // The gift branch is a REWORDING, not a different quiz — resolved as each
  // question renders, so somebody who goes back and changes their answer sees
  // the wording change with it rather than answering the wrong question.
  var HRW_QUIZ = [
    { key: 'shoppingFor', type: 'one', q: 'Who are you shopping for?', required: true,
      opts: [{ v: 'self', label: 'Myself' }, { v: 'gift', label: 'Someone else' }] },

    { key: 'series', type: 'list', q: 'Do you have a favorite series?', required: true,
      giftOptional: true,
      giftQ: 'Do they have a favorite series?',
      help: 'Feel free to add more than one!',
      // The gift branch says the skip out loud. Un-requiring the question only
      // un-hides the Skip button down in the footer, which is a long way from
      // where the member is looking and easy to read as "I have to guess".
      giftHelp: 'Add as many as you like - or skip if you’re not sure.',
      placeholder: 'Type a series…',
      note: 'We’ll consider your answer when planning new releases.' },

    { key: 'characters', type: 'list', q: 'How about a favorite character?', required: true,
      giftOptional: true,
      help: 'Again, you may add more than one!',
      giftHelp: 'Skip this one too if you’re not sure.',
      placeholder: 'Type a character…' },

    { key: 'wantMore', type: 'many', q: 'Anything you’d like to see more of?', required: true,
      giftQ: 'What are they most likely to wear?',
      help: 'What do you actually wear?',
      giftHelp: 'Pick as many as you like.',
      grid: true,
      opts: [
        { v: 'tees', label: 'Tees' }, { v: 'sweatshirts', label: 'Sweatshirts' },
        { v: 'shorts', label: 'Shorts' }, { v: 'pants', label: 'Pants' },
        { v: 'accessories', label: 'Accessories' }, { v: 'jackets_coats', label: 'Jackets/Coats' }
      ] },

    // SIZES (§3.5). Placed after "what do you wear" and before the birthday,
    // because it is the same train of thought — the member is already picturing
    // themselves in the clothes. Both optional: a wrong size stored is worse
    // than no size, since the fit guide and drop targeting will trust it.
    //
    // ONE QUESTION PER GARMENT, not a single "size", because people are
    // genuinely different top and bottom and a single answer would be wrong for
    // most of them.
    { key: 'topSize', type: 'one', q: 'What size do you wear on top?',
      help: 'So we can recommend the right fit - and make enough of it.',
      grid: true,
      opts: [
        { v: 'xxs', label: 'XXS' }, { v: 'xs', label: 'XS' }, { v: 's', label: 'S' },
        { v: 'm', label: 'M' }, { v: 'l', label: 'L' }, { v: 'xl', label: 'XL' },
        { v: 'xxl', label: '2XL' }, { v: 'xxxl', label: '3XL' }
      ] },

    // BOTH WAYS OF KNOWING IT. Waists first because that is how most bottoms
    // are bought, letters after for anyone who does not know their waist —
    // forcing one loses the answer from whoever thinks in the other.
    { key: 'bottomSize', type: 'one', q: 'And on the bottom?',
      help: 'Waist size, or a letter if that’s easier.',
      grid: true,
      opts: [
        { v: '24', label: '24' }, { v: '26', label: '26' }, { v: '28', label: '28' },
        { v: '30', label: '30' }, { v: '32', label: '32' }, { v: '34', label: '34' },
        { v: '36', label: '36' }, { v: '38', label: '38' }, { v: '40', label: '40' },
        { v: 'xs', label: 'XS' }, { v: 's', label: 'S' }, { v: 'm', label: 'M' },
        { v: 'l', label: 'L' }, { v: 'xl', label: 'XL' }, { v: 'xxl', label: '2XL' }
      ] },

    { key: 'birthdayMonth', type: 'month', q: 'When’s your birthday?',
      help: 'We’ll use this info to send you a gift if you qualify!' },

    // Sits before the free response on purpose: it is the last ASK, and the
    // open box is the last word. Wholly optional — the section earns nothing
    // and blocks nothing, which is why it says what it is for rather than just
    // demanding two handles.
    { key: 'socials', type: 'handles', q: 'Add your social handles:',
      help: 'To qualify for our brand-wide giveaways.',
      fields: [
        { key: 'instagram', label: 'Instagram', placeholder: 'your-handle' },
        { key: 'tiktok', label: 'TikTok', placeholder: 'your-handle' }
      ] },

    { key: 'feedback', type: 'text', q: 'Do you have any other thoughts or suggestions?',
      placeholder: 'Type as much or as little as you like…' }
  ];

  var HRW_QUIZ_SLOTS_MIN = 1;
  var HRW_QUIZ_SLOTS_MAX = 5;   // must match MAX_RANKED in plm lib/loyalty/quiz.ts
  var HRW_MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  function openQuizForm(onStatus) {
    if (document.querySelector('[data-hrw-quiz]')) return;
    var theme = root.getAttribute('data-hrw-theme') || 'light';
    var adv = theme === 'start-menu';

    var ov = document.createElement('div');
    ov.className = 'hrw-rp__quiz';
    ov.setAttribute('data-hrw-quiz', '');
    ov.setAttribute('data-hrw-theme', theme);
    // The skin travels with the theme. These dialogs mount on <body>, outside
    // .hrw-rp, so a rule scoped to .hrw-rp[data-hrw-skin="classic"] can never
    // reach them — without this attribute Classic had no way to restyle the
    // dialog at all and it fell through to the Start Menu's green accent.
    var skin = root.getAttribute('data-hrw-skin');
    if (skin) ov.setAttribute('data-hrw-skin', skin);
    ov.innerHTML =
      '<div class="hrw-rp__quiz-box" role="dialog" aria-modal="true" aria-label="Member quiz">'
      + '<button type="button" class="hrw-rp__quiz-x" aria-label="Close">&times;</button>'
      + '<p class="hrw-rp__quiz-eyebrow">' + (adv ? 'Quest' : 'Members Club') + '</p>'
      + '<div class="hrw-rp__quiz-top"><span data-quiz-step></span>'
      + '<button type="button" class="hrw-rp__quiz-skip" data-quiz-skip>Skip</button></div>'
      + '<div class="hrw-rp__quiz-bar"><span data-quiz-bar style="width:0%"></span></div>'
      + '<div data-quiz-stage></div>'
      + '<p class="hrw-rp__quiz-msg" data-quiz-msg role="status"></p>'
      + '<div class="hrw-rp__quiz-actions">'
      + '<button type="button" class="hrw-rp__quiz-cancel" data-quiz-back>Back</button>'
      + '<button type="button" class="hrw-rp__quiz-go" data-quiz-next>Next</button>'
      + '</div>'
      + '</div>';
    document.body.appendChild(ov);
    requestAnimationFrame(function () { ov.classList.add('is-open'); });

    var stage = ov.querySelector('[data-quiz-stage]');
    var stepEl = ov.querySelector('[data-quiz-step]');
    var barEl = ov.querySelector('[data-quiz-bar]');
    var msgEl = ov.querySelector('[data-quiz-msg]');
    var nextEl = ov.querySelector('[data-quiz-next]');
    var backEl = ov.querySelector('[data-quiz-back]');
    var skipEl = ov.querySelector('[data-quiz-skip]');
    var answers = {};
    var idx = 0;
    var sent = false;

    function close() {
      ov.classList.remove('is-open');
      window.setTimeout(function () { ov.remove(); }, 220);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', onKey);
    ov.querySelector('.hrw-rp__quiz-x').addEventListener('click', close);
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });

    function say(text, bad) {
      msgEl.textContent = text || '';
      msgEl.classList.toggle('is-bad', !!bad);
    }
    var isGift = function () { return answers.shoppingFor === 'gift'; };
    var qText = function (q) { return isGift() && q.giftQ ? q.giftQ : q.q; };
    var hText = function (q) { return isGift() && q.giftHelp !== undefined ? q.giftHelp : q.help; };
    // Required is a branch-resolved question, not a static flag — see
    // giftOptional above.
    var isRequired = function (q) { return !!(q && q.required) && !(isGift() && q.giftOptional); };

    // Pre-fill from a previous run. Retaking should start from what they told
    // us last time — asking someone to retype it all is how a re-ask becomes a
    // thing nobody does twice.
    fetch(proxyBase + '/quiz', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (b) {
        if (!b || !b.answers) return;
        answers.shoppingFor = b.answers.shoppingFor || undefined;
        answers.series_raw = (b.answers.series || []).slice();
        answers.characters_raw = (b.answers.characters || []).slice();
        answers.wantMore = (b.answers.wantMore || []).slice();
        answers.birthdayMonth = b.answers.birthdayMonth || undefined;
        answers.feedback = b.answers.feedback || undefined;
        answers.instagram = b.answers.instagram || undefined;
        answers.tiktok = b.answers.tiktok || undefined;
        if (b.taken) say('Welcome back - we have filled in your last answers. Change anything you like.');
        render();
      })
      .catch(function () { /* a failed pre-fill is a blank quiz, not an error */ });

    function renderList(q) {
      var raw = answers[q.key + '_raw'] || [''];
      while (raw.length < HRW_QUIZ_SLOTS_MIN) raw.push('');
      answers[q.key + '_raw'] = raw;

      stage.innerHTML =
        '<p class="hrw-rp__quiz-q">' + escapeHtml(qText(q)) + '</p>'
        + (hText(q) ? '<p class="hrw-rp__quiz-help">' + escapeHtml(hText(q)) + '</p>' : '')
        + '<div class="hrw-rp__quiz-slots">'
        + raw.map(function (v, i) {
            return '<div class="hrw-rp__quiz-slot"><span class="rank">' + (i + 1) + '</span>'
              + '<input type="text" autocomplete="off" spellcheck="false" data-i="' + i + '" maxlength="80"'
              + ' placeholder="' + escapeHtml(q.placeholder) + '"'
              + ' aria-label="' + escapeHtml(qText(q)) + ' - ' + (i + 1) + '"'
              + ' value="' + escapeHtml(String(v)) + '" />'
              + '<button type="button" class="x" data-rm="' + i + '" aria-label="Remove ' + (i + 1) + '"'
              + (i < HRW_QUIZ_SLOTS_MIN ? ' hidden' : '') + '>&times;</button></div>';
          }).join('')
        + '<button type="button" class="hrw-rp__quiz-more" data-more'
        + (raw.length >= HRW_QUIZ_SLOTS_MAX ? ' hidden' : '') + '>+ Add more</button>'
        + '</div>'
        + (q.note ? '<p class="hrw-rp__quiz-note">' + escapeHtml(q.note) + '</p>' : '');

      // Typing must NOT re-render: rebuilding the DOM on every keystroke
      // destroys the focused input and drops the caret after one character.
      function commit() {
        answers[q.key + '_raw'] = [].map.call(stage.querySelectorAll('[data-i]'), function (el) {
          return el.value.trim();
        });
        // The gate has to move with the ANSWER, not with the re-render. These
        // inputs deliberately do not re-render on keystroke (it would drop the
        // caret), so without this Next stayed disabled until something else
        // forced a render — which is why it only woke up after "+ Add more".
        // Both list questions shared this one commit(), so both were stuck.
        syncGate();
      }
      [].forEach.call(stage.querySelectorAll('[data-i]'), function (el) {
        el.addEventListener('input', commit);
      });
      var moreBtn = stage.querySelector('[data-more]');
      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          commit();
          answers[q.key + '_raw'] = answers[q.key + '_raw'].concat(['']);
          render();
          var boxes = stage.querySelectorAll('[data-i]');
          if (boxes.length) boxes[boxes.length - 1].focus();
        });
      }
      [].forEach.call(stage.querySelectorAll('[data-rm]'), function (b) {
        b.addEventListener('click', function () {
          commit();
          var n = +b.getAttribute('data-rm');
          answers[q.key + '_raw'] = answers[q.key + '_raw'].filter(function (_, i) { return i !== n; });
          render();
        });
      });
    }

    /**
     * Has this question been answered?
     *
     * Per type, because "answered" is not one shape: a single choice is a
     * value, a multi-select is a non-empty array, and the ranked list stores
     * its rows in `<key>_raw` with blank slots that do not count.
     */
    function answered(q) {
      if (!q) return true;
      if (q.type === 'one') return !!answers[q.key];
      if (q.type === 'many') return (answers[q.key] || []).length > 0;
      if (q.type === 'list') {
        return (answers[q.key + '_raw'] || []).some(function (v) { return String(v || '').trim(); });
      }
      if (q.type === 'month') return !!answers[q.key];
      if (q.type === 'text') return !!String(answers[q.key] || '').trim();
      return true;
    }

    /** Next disabled and Skip hidden until a required question is answered. */
    function syncGate() {
      var q = HRW_QUIZ[idx];
      var blocked = isRequired(q) && !answered(q);
      nextEl.disabled = blocked;
      nextEl.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      // Hidden on a required question, and on the LAST one (Nick): there the
      // button already says Finish, and skipping and finishing do exactly the
      // same thing — two controls for one action, one of which sounds like it
      // throws the answers away.
      skipEl.hidden = isRequired(q) || idx === HRW_QUIZ.length - 1;
    }

    function render() {
      var q = HRW_QUIZ[idx];
      if (!q) return finish();

      backEl.style.visibility = idx === 0 ? 'hidden' : 'visible';
      nextEl.textContent = idx === HRW_QUIZ.length - 1 ? 'Finish' : 'Next';
      stepEl.textContent = 'Question ' + (idx + 1) + ' of ' + HRW_QUIZ.length;
      barEl.style.width = Math.round(((idx + 1) / HRW_QUIZ.length) * 100) + '%';

      syncGate();
      if (q.type === 'list') return renderList(q);

      var head = '<p class="hrw-rp__quiz-q">' + escapeHtml(qText(q)) + '</p>'
        + (hText(q) ? '<p class="hrw-rp__quiz-help">' + escapeHtml(hText(q)) + '</p>' : '');

      if (q.type === 'handles') {
        stage.innerHTML = head + '<div class="hrw-rp__quiz-handles">'
          + q.fields.map(function (f) {
              return '<label class="hrw-rp__quiz-handle">'
                + '<span>' + escapeHtml(f.label) + '</span>'
                + '<span class="hrw-rp__quiz-at">@</span>'
                + '<input type="text" data-h="' + escapeHtml(f.key) + '" autocomplete="off"'
                + ' autocapitalize="none" spellcheck="false" maxlength="30"'
                + ' placeholder="' + escapeHtml(f.placeholder) + '"'
                + ' aria-label="' + escapeHtml(f.label) + ' handle"'
                + ' value="' + escapeHtml(answers[f.key] || '') + '" /></label>';
            }).join('')
          + '</div>';
        // Same no-re-render rule as the ranked slots: rebuilding on every
        // keystroke destroys the focused input and drops the caret.
        [].forEach.call(stage.querySelectorAll('[data-h]'), function (el) {
          el.addEventListener('input', function () {
            // The @ is furniture, not data — the server strips it too, but
            // storing it here would show it back doubled on a retake.
            answers[el.getAttribute('data-h')] = el.value.trim().replace(/^@+/, '') || undefined;
            syncGate();
          });
        });
        return;
      }

      if (q.type === 'text') {
        stage.innerHTML = head + '<textarea class="hrw-rp__quiz-free" maxlength="600" placeholder="'
          + escapeHtml(q.placeholder) + '">' + escapeHtml(answers[q.key] || '') + '</textarea>';
        var ta = stage.querySelector('textarea');
        ta.addEventListener('input', function () { answers[q.key] = ta.value.trim() || undefined; syncGate(); });
        return;
      }

      if (q.type === 'month') {
        stage.innerHTML = head + '<div class="hrw-rp__quiz-months">'
          + HRW_MONTHS.map(function (m, i) {
              return '<button type="button" class="hrw-rp__quiz-month" data-v="' + (i + 1) + '" aria-pressed="'
                + (answers[q.key] === i + 1) + '">' + m + '</button>';
            }).join('') + '</div>';
      } else {
        var chosen = answers[q.key];
        stage.innerHTML = head + '<div class="hrw-rp__quiz-opts' + (q.grid ? ' is-grid' : '') + '">'
          + q.opts.map(function (o) {
              var on = q.type === 'many' ? (chosen || []).indexOf(o.v) >= 0 : chosen === o.v;
              return '<button type="button" class="hrw-rp__quiz-opt" data-v="' + escapeHtml(o.v) + '" aria-pressed="'
                + on + '"><span>' + escapeHtml(o.label) + '</span>'
                + '<span class="tick" aria-hidden="true">&#9679;</span></button>';
            }).join('') + '</div>';
      }

      [].forEach.call(stage.querySelectorAll('[data-v]'), function (b) {
        b.addEventListener('click', function () {
          var v = b.getAttribute('data-v');
          if (q.type === 'many') {
            var cur = answers[q.key] || [];
            answers[q.key] = cur.indexOf(v) >= 0
              ? cur.filter(function (x) { return x !== v; })
              : cur.concat([v]);
          } else if (q.type === 'month') {
            answers[q.key] = answers[q.key] === +v ? undefined : +v;
          } else {
            answers[q.key] = answers[q.key] === v ? undefined : v;
          }
          render();
        });
      });
    }

    function payload() {
      return {
        shoppingFor: answers.shoppingFor,
        series: (answers.series_raw || []).filter(Boolean),
        characters: (answers.characters_raw || []).filter(Boolean),
        wantMore: answers.wantMore || [],
        birthdayMonth: answers.birthdayMonth,
        feedback: answers.feedback,
        instagram: answers.instagram,
        tiktok: answers.tiktok
      };
    }

    function finish() {
      if (hrwQuizBusy || sent) return;
      var body = payload();
      var answeredSomething = !!(body.shoppingFor || body.series.length || body.characters.length
        || body.wantMore.length || body.birthdayMonth || body.feedback
        || body.instagram || body.tiktok);
      if (!answeredSomething) {
        // Clicking through six questions answering none of them is not
        // completing the quiz. Said here rather than round-tripping for it.
        idx = 0;
        render();
        say('Answer at least one question and we’ll add your credits.', true);
        return;
      }

      hrwQuizBusy = true;
      nextEl.disabled = true;
      say('Saving…');

      fetch(proxyBase + '/quiz', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (b) {
          hrwQuizBusy = false;
          nextEl.disabled = false;
          if (b && b.saved) {
            sent = true;
            stage.innerHTML = '<p class="hrw-rp__quiz-q">Thanks!</p>'
              + '<p class="hrw-rp__quiz-help">' + escapeHtml(b.message || 'Saved.') + '</p>';
            stepEl.textContent = 'Complete';
            barEl.style.width = '100%';
            skipEl.hidden = true;
            backEl.style.visibility = 'hidden';
            nextEl.textContent = 'Done';
            say('');
            if (onStatus) onStatus(b.message || 'Saved.');
            // The quiz was the ONE earn path that never said it had earned
            // (Nick: hexagon stayed lit, no credits, no pop-up until reload).
            // Every other path calls this; it marks the rule done so the tile
            // greys straight away and re-fetches the balance, which is also
            // what raises the "You've earned" pop-up.
            //
            // Deliberately NOT bumping hrwCoinBalance by b.credits the way the
            // click-to-claim path does: this route returns the rule's FACE
            // VALUE even on a retake that paid nothing, so adding it locally
            // would inflate the balance on every retake until loadBalance
            // corrected it. Letting the server's number be the only number is
            // both simpler and right.
            hrwAfterEarn('anime_quiz');
            nextEl.onclick = close;
            window.setTimeout(close, 2600);
          } else {
            say((b && b.message) || 'Could not save that - try again shortly.', true);
          }
        })
        .catch(function () {
          hrwQuizBusy = false;
          nextEl.disabled = false;
          say('Could not reach us just now - try again shortly.', true);
        });
    }

    nextEl.addEventListener('click', function () {
      if (sent) return close();
      // Belt and braces: the button is disabled, but a stray Enter or a script
      // could still reach this.
      var cur = HRW_QUIZ[idx];
      if (isRequired(cur) && !answered(cur)) { say('Please answer this one to continue.', true); return; }
      if (idx >= HRW_QUIZ.length - 1) return finish();
      idx += 1;
      say('');
      render();
    });
    backEl.addEventListener('click', function () { idx = Math.max(0, idx - 1); say(''); render(); });
    skipEl.addEventListener('click', function () { nextEl.click(); });

    render();
  }

  function openTagUsForm(onStatus) {
    if (document.querySelector('[data-hrw-tagus]')) return;
    var theme = root.getAttribute('data-hrw-theme') || 'light';
    var adv = theme === 'start-menu';

    var ov = document.createElement('div');
    ov.className = 'hrw-rp__tagus';
    ov.setAttribute('data-hrw-tagus', '');
    ov.setAttribute('data-hrw-theme', theme);
    // The skin travels with the theme. These dialogs mount on <body>, outside
    // .hrw-rp, so a rule scoped to .hrw-rp[data-hrw-skin="classic"] can never
    // reach them — without this attribute Classic had no way to restyle the
    // dialog at all and it fell through to the Start Menu's green accent.
    var skin = root.getAttribute('data-hrw-skin');
    if (skin) ov.setAttribute('data-hrw-skin', skin);
    ov.innerHTML =
      '<form class="hrw-rp__tagus-box" role="dialog" aria-modal="true" aria-label="Submit your post">'
      + '<button type="button" class="hrw-rp__tagus-x" aria-label="Close">&times;</button>'
      + '<p class="hrw-rp__tagus-eyebrow">' + (adv ? 'Quest' : 'Tag us') + '</p>'
      + '<p class="hrw-rp__tagus-title">' + (adv ? 'Show us your post' : 'Tag us in a post') + '</p>'
      + '<p class="hrw-rp__tagus-sub">Post wearing Haki and tag us, then tell us where to look. '
      + 'We check it by hand and add your credits - usually within a day.</p>'
      + '<div class="hrw-rp__tagus-seg" role="radiogroup" aria-label="Platform">'
      + '<button type="button" class="hrw-rp__tagus-segbtn is-on" data-platform="instagram" role="radio" aria-checked="true">Instagram</button>'
      + '<button type="button" class="hrw-rp__tagus-segbtn" data-platform="tiktok" role="radio" aria-checked="false">TikTok</button>'
      + '</div>'
      + '<label class="hrw-rp__tagus-label"><span>Your handle</span>'
      + '<span class="hrw-rp__tagus-field"><span class="hrw-rp__tagus-at">@</span>'
      + '<input type="text" data-tagus-handle autocomplete="off" autocapitalize="none" spellcheck="false" '
      + 'placeholder="your-handle" maxlength="30" /></span></label>'
      + '<label class="hrw-rp__tagus-label"><span>Link to the post <em class="hrw-rp__tagus-opt">required - one click for us to check</em></span>'
      + '<input type="url" class="hrw-rp__tagus-input" data-tagus-url autocomplete="off" spellcheck="false" required '
      + 'placeholder="https://instagram.com/p/..." /></label>'
      + '<p class="hrw-rp__tagus-msg" data-tagus-msg role="status"></p>'
      + '<div class="hrw-rp__tagus-actions">'
      + '<button type="button" class="hrw-rp__tagus-cancel" data-tagus-cancel>Cancel</button>'
      + '<button type="submit" class="hrw-rp__tagus-go" data-tagus-go>' + (adv ? 'Submit for review' : 'Submit') + '</button>'
      + '</div>'
      + '</form>';
    document.body.appendChild(ov);
    requestAnimationFrame(function () { ov.classList.add('is-open'); });

    var box = ov.querySelector('.hrw-rp__tagus-box');
    var handleEl = ov.querySelector('[data-tagus-handle]');
    var urlEl = ov.querySelector('[data-tagus-url]');
    var msgEl = ov.querySelector('[data-tagus-msg]');
    var goEl = ov.querySelector('[data-tagus-go]');
    var platform = 'instagram';

    function close() {
      ov.classList.remove('is-open');
      window.setTimeout(function () { ov.remove(); }, 220);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', onKey);
    ov.querySelector('.hrw-rp__tagus-x').addEventListener('click', close);
    ov.querySelector('[data-tagus-cancel]').addEventListener('click', close);
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });

    ov.querySelectorAll('[data-platform]').forEach(function (b) {
      b.addEventListener('click', function () {
        platform = b.getAttribute('data-platform');
        ov.querySelectorAll('[data-platform]').forEach(function (o) {
          var on = o === b;
          o.classList.toggle('is-on', on);
          o.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        // Show the shape of link we expect, so "a link to the post" is not a
        // guess.
        urlEl.placeholder = platform === 'tiktok'
          ? 'https://tiktok.com/@you/video/...'
          : 'https://instagram.com/p/...';
      });
    });

    function say(text, bad) {
      msgEl.textContent = text || '';
      msgEl.classList.toggle('is-bad', !!bad);
    }

    box.addEventListener('submit', function (e) {
      e.preventDefault();
      if (hrwTagBusy) return;
      var handle = (handleEl.value || '').trim().replace(/^@+/, '');
      if (!handle) { say('Add your handle so we know whose post to look for.', true); handleEl.focus(); return; }
      // The link is required (plm, 2026-09-07) — checked here as well as on the
      // server so the member is corrected in place instead of round-tripping.
      var postUrl = (urlEl.value || '').trim();
      if (!postUrl) { say('Paste the link to your post so we can check it.', true); urlEl.focus(); return; }
      hrwTagBusy = true;
      goEl.disabled = true;
      say('Sending…');

      fetch(proxyBase + '/tag-us', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ platform: platform, handle: handle, postUrl: postUrl })
      })
        .then(function (r) { return r.json(); })
        .then(function (body) {
          hrwTagBusy = false;
          goEl.disabled = false;
          if (body && body.submitted) {
            say(body.message || 'Thanks - we will check your post.');
            if (onStatus) onStatus(body.message || 'Sent for review.');
            window.setTimeout(close, 1600);
          } else {
            // Every refusal from the server is a normal thing a person does
            // (one already waiting, a link we cannot read), so it is shown in
            // the form rather than as an error state.
            say((body && body.message) || 'Could not send that - check the details.', true);
          }
        })
        .catch(function () {
          hrwTagBusy = false;
          goEl.disabled = false;
          say('Could not reach us just now - try again shortly.', true);
        });
    });

    handleEl.focus();
  }

  var hrwWardrobeFreshSeen = false;
  function loadWardrobe() {
    if (!loggedIn) return Promise.resolve();
    if (!hrwWardrobeFreshSeen && window.HakiMemberCache) {
      var savedW = window.HakiMemberCache.read('/wardrobe');
      if (savedW) {
        try {
          hrwWardrobe = savedW.products || [];
          if (root.getAttribute('data-hrw-theme') === 'start-menu' && typeof renderInventory === 'function') renderInventory();
        } catch (e) {}
      }
    }
    return fetch(proxyBase + '/wardrobe', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('wardrobe ' + r.status); return r.json(); })
      .then(function (data) {
        hrwWardrobeFreshSeen = true;
        if (window.HakiMemberCache && data && Array.isArray(data.products)) window.HakiMemberCache.write('/wardrobe', data);
        hrwWardrobe = (data && data.products) || [];
        if (root.getAttribute('data-hrw-theme') === 'start-menu' && typeof renderInventory === 'function') renderInventory();
      })
      // Never surface this: an unreachable wardrobe falls back to the samples,
      // which is better than an error where a member's clothes should be.
      .catch(function () {});
  }

  function invAllItems() {
    return [].concat(invKeyItems(), invMounts(), invConsumables(), invWearables());
  }

  function invSortItems(items) {
    var a = items.slice();
    if (invSort === 'az') a.sort(function (x, y) { return x.name.localeCompare(y.name); });
    else if (invSort === 'za') a.sort(function (x, y) { return y.name.localeCompare(x.name); });
    else if (invSort === 'type') a.sort(function (x, y) {
      var d = (INV_TYPE_ORDER[x.type] || 0) - (INV_TYPE_ORDER[y.type] || 0);
      return d || (rarRank(y.rarity) - rarRank(x.rarity)) || x.name.localeCompare(y.name);
    });
    else a.sort(function (x, y) {
      return (rarRank(y.rarity) - rarRank(x.rarity)) || x.name.localeCompare(y.name);
    });
    return a;
  }

  var invAboutId = null;
  // Builds the About card's CONTENT into `about` — no side effects (no NEW-
  // badge clearing, no invAboutId tracking), so this same function can also
  // render into an off-screen clone purely to MEASURE an item's natural
  // height (see invSyncAboutHeight) without marking it "seen" (Nick).
  function invRenderAboutInto(about, it) {
    var rar = INV_RARITY[it.rarity] || INV_RARITY.common;
    about.style.setProperty('--rar', rar.color);
    about.className = 'hrw-rp__invabout is-shown' + (it.locked ? ' is-locked' : '');
    // .invabout-head wraps icon + rarity/name — column (icon above, centred)
    // on desktop as before, row (icon beside the text) on mobile, so the
    // icon doesn't stack a full icon-height on top of everything else in
    // the space-constrained mobile card (Nick).
    about.innerHTML =
      '<div class="hrw-rp__invabout-head">' +
        '<span class="hrw-rp__invabout-ico">' + (it.locked ? INV_ICONS.lock : it.icon) + '</span>' +
        '<div class="hrw-rp__invabout-head-t">' +
          '<p class="hrw-rp__invabout-rar">' + esc(rar.label) + '</p>' +
          '<h3 class="hrw-rp__invabout-name">' + esc(it.name) + '</h3>' +
        '</div>' +
      '</div>' +
      '<p class="hrw-rp__invabout-tags">' + esc(INV_TYPE_LABEL[it.type] || '') + (it.sub ? ' &middot; ' + esc(it.sub) : '') + '</p>' +
      '<p class="hrw-rp__invabout-lbl">About</p>' +
      '<p class="hrw-rp__invabout-desc">' + esc(it.desc || '') + '</p>' +
      '<div class="hrw-rp__invabout-act" data-inva-act></div>';
    var act = about.querySelector('[data-inva-act]');
    // Consumable actions act on the SERVER bank (0374), so Inventory and the
    // Light/Dark "Your Rewards" list drive the same rows. The old buttons
    // flipped a localStorage flag, which meant "used" was a per-browser
    // opinion rather than a fact — and a member could un-use a spent code.
    if (it.type === 'consumable' && it.entryId && it.status === 'banked') {
      var takeOut = document.createElement('button');
      takeOut.type = 'button'; takeOut.className = 'hrw-rp__advsc-card-btn';
      // Blocking is PER REWARD (0375): only the plain money-off codes compete
      // for the one slot, because only they compound on a single order. The
      // server sends `activatable`, so this page never re-derives that rule.
      // A store-credit entry still sitting in the bank means delivery failed —
      // its button retries, and the retry is idempotent server-side.
      var canTake = hrwBankData && hrwBankData.activatable
        ? hrwBankData.activatable.indexOf(it.entryId) !== -1
        : true;
      if (it.isCredit) {
        takeOut.textContent = 'Add it to my account';
      } else {
        takeOut.textContent = canTake ? 'Take it out' : 'Put the other one back first';
        takeOut.disabled = !canTake;
      }
      takeOut.addEventListener('click', function () { bankAction('activate', it.entryId, takeOut); });
      act.appendChild(takeOut);
    } else if (it.type === 'consumable' && it.entryId && it.status === 'active') {
      if (it.code) {
        var copy = document.createElement('button');
        copy.type = 'button'; copy.className = 'hrw-rp__advsc-card-btn';
        copy.textContent = 'Copy code';
        copy.addEventListener('click', function () {
          try { if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(it.code); } catch (e) {}
          copy.textContent = 'Copied ✓';
        });
        act.appendChild(copy);
        var apply = document.createElement('a');
        apply.className = 'hrw-rp__advsc-card-btn';
        apply.href = '/discount/' + encodeURIComponent(it.code);
        apply.textContent = 'Apply & shop';
        act.appendChild(apply);
      }
      var back = document.createElement('button');
      back.type = 'button'; back.className = 'hrw-rp__advsc-card-btn is-subtle';
      back.textContent = 'Put it back';
      back.addEventListener('click', function () { bankAction('return', it.entryId, back); });
      act.appendChild(back);
    }
    if (it.type === 'consumable' || it.type === 'wearable') {
      var ret = document.createElement('a');
      ret.className = 'hrw-rp__advsc-card-btn is-subtle';
      // Our pages, never Shopify's account portal (operator, 2026-10-01):
      // returns start on the track page, everything else lives on the account page.
      ret.href = it.type === 'wearable' ? '/pages/track' : '/pages/account';
      ret.textContent = it.type === 'wearable' ? 'Request a return'
        : it.isCredit ? 'See it in My Account'
        : 'Manage in My Account';
      act.appendChild(ret);
    }
    // Mounts: equip / un-equip. The choice sticks (localStorage) so you can
    // replay a leg of the map with a different mount. "On foot" un-equips.
    if (it.type === 'mount') {
      var cur = invCurTierIndex();
      var canChoose = mountMaxUnlocked(cur) >= 1;   // at least one real mount unlocked
      if (canChoose && !it.equipped) {
        var eqb = document.createElement('button');
        eqb.type = 'button'; eqb.className = 'hrw-rp__advsc-card-btn';
        eqb.textContent = it.mountKey === 'foot' ? 'Travel on foot' : 'Equip this mount';
        eqb.addEventListener('click', function () {
          hrwSaveMount(it.mountKey === 'foot' ? 'foot' : it.mountKey);
          hrwAfterMountChange();
        });
        act.appendChild(eqb);
      } else if (canChoose && it.equipped && it.mountKey !== 'foot') {
        var uneq = document.createElement('button');
        uneq.type = 'button'; uneq.className = 'hrw-rp__advsc-card-btn is-subtle';
        uneq.textContent = 'Un-equip (travel on foot)';
        uneq.addEventListener('click', function () { hrwSaveMount('foot'); hrwAfterMountChange(); });
        act.appendChild(uneq);
      }
    }
    // Quest Map: open the map as an overlay over the current screen.
    if (it.type === 'key' && it.useMap) {
      var useMap = document.createElement('button');
      useMap.type = 'button'; useMap.className = 'hrw-rp__advsc-card-btn';
      useMap.textContent = 'Use';
      useMap.addEventListener('click', function () {
        if (typeof window.__hrwOpenMap === 'function') window.__hrwOpenMap();
      });
      act.appendChild(useMap);
    }
    // Hakiboy Advance: bring the Game Boy up as an overlay over the current screen.
    if (it.type === 'key' && it.useGameBoy) {
      var useGb = document.createElement('button');
      useGb.type = 'button'; useGb.className = 'hrw-rp__advsc-card-btn';
      useGb.textContent = 'Use';
      useGb.addEventListener('click', function () {
        if (typeof window.__hrwOpenGameBoy === 'function') window.__hrwOpenGameBoy();
      });
      act.appendChild(useGb);
    }
    // key items that "use" straight to another page of the site
    if (it.type === 'key' && it.go) {
      var goLink = document.createElement('a');
      goLink.className = 'hrw-rp__advsc-card-btn';
      goLink.href = it.go;
      goLink.textContent = it.useLabel || 'Use';
      act.appendChild(goLink);
    }
    // key items that "use" by jumping to another Start Menu panel (Coin Purse → Shop)
    if (it.type === 'key' && it.goPanel) {
      var panelBtn = document.createElement('button');
      panelBtn.type = 'button'; panelBtn.className = 'hrw-rp__advsc-card-btn';
      panelBtn.textContent = it.useLabel || 'Use';
      panelBtn.addEventListener('click', function () {
        if (typeof window.__hrwAdvNav === 'function') window.__hrwAdvNav(it.goPanel, true);
      });
      act.appendChild(panelBtn);
    }
  }
  function invShowAbout(it) {
    var about = root.querySelector('[data-inv-about]');
    if (!about || !it) return;
    invAboutId = it._i;
    // "looked at" = the About card actually showed it — clear its NEW badge
    // (in the live DOM directly, not a full re-render, so this doesn't lose
    // scroll position / focus on the grid).
    if (invCardIsNew(it)) {
      invMarkSeen(it);
      var grid = root.querySelector('[data-inventory-list]');
      var openBtn = grid && grid.querySelector('[data-inv-i="' + it._i + '"]');
      if (openBtn) {
        var badge = openBtn.querySelector('.hrw-rp__invcard-new');
        if (badge) badge.remove();
        var lbl = openBtn.getAttribute('aria-label') || '';
        openBtn.setAttribute('aria-label', lbl.replace(/, new$/, ''));
      }
    }
    invRenderAboutInto(about, it);
  }
  // Mobile: the About card sits ABOVE the grid (order:-1) and used to be a
  // fixed height with a scrollbar so picking a different item never changed
  // the page's layout — Nick's call: no scrollbar, just size the card to
  // whatever the TALLEST item actually needs, once, so nothing ever jumps
  // NOR scrolls. Renders every item into one hidden, off-screen clone (same
  // width as the real card, so text wraps identically) and keeps the tallest
  // natural height seen. Cheap enough for an inventory of a few dozen items;
  // runs once whenever the filtered/sorted item list changes.
  function invSyncAboutHeight(items) {
    var about = root.querySelector('[data-inv-about]');
    if (!about || !items.length) return;
    var mq = window.matchMedia && window.matchMedia('(max-width: 860px)');
    if (!mq || !mq.matches) { about.style.removeProperty('--inv-about-h'); return; }
    var probe = about.cloneNode(false);
    probe.style.cssText = 'position:absolute; visibility:hidden; pointer-events:none; height:auto; min-height:0; left:-9999px; top:0;';
    probe.style.width = about.getBoundingClientRect().width + 'px';
    document.body.appendChild(probe);
    var max = 0;
    items.forEach(function (it) {
      invRenderAboutInto(probe, it);
      max = Math.max(max, probe.scrollHeight);
    });
    probe.remove();
    if (max > 0) about.style.setProperty('--inv-about-h', max + 'px');
  }
  // re-measure across the mobile breakpoint (rotating a device, resizing a
  // desktop window down) — width feeds the probe's own width, so the
  // wrapped/measured height genuinely changes at that point.
  (function () {
    var mq = window.matchMedia && window.matchMedia('(max-width: 860px)');
    if (!mq) return;
    var pending = false;
    function fn() {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; invSyncAboutHeight(invAllItems()); });
    }
    (mq.addEventListener ? mq.addEventListener('change', fn) : mq.addListener(fn));
    window.addEventListener('resize', fn, { passive: true });
  })();
  // Re-render everything a mount change touches: the HUD label, the inventory
  // (equipped flag), and the map (it re-reads the equipped mount on build).
  function hrwAfterMountChange() {
    try { hrwRenderAdvHud(); } catch (e) {}
    renderInventory();
    try {
      // the RAW hand-pick ('' = none = auto). The map treats a non-empty value as
      // "hold this mount"; '' lets it auto-swap at each checkpoint.
      var mk = hrwLoadMount() || '';
      window.__hrwTierMapMount = mk;
      if (typeof window.__hrwSetMapMount === 'function') window.__hrwSetMapMount(mk);
    } catch (e) {}
  }

  function renderInventory() {
    var grid = root.querySelector('[data-inventory-list]');
    if (!grid) return;
    var layout = root.querySelector('.hrw-rp__invlayout');
    if (!loggedIn) {
      grid.innerHTML = hrwAuthGate('inventory');
      // Was only ever as wide as the grid's OWN column, leaving the About
      // card visible (with its "Select an item to inspect it." placeholder)
      // in the second column — looked like two unrelated, off-centre boxes
      // instead of one gate. `.is-gated` collapses the layout to one column
      // and hides About entirely so the gate card is centred on the FULL
      // panel width (Nick).
      grid.classList.add('is-gated');
      if (layout) layout.classList.add('is-gated');
      var aboutEl = root.querySelector('[data-inv-about]');
      if (aboutEl) { aboutEl.className = 'hrw-rp__invabout'; aboutEl.innerHTML = ''; }
      var invHead = root.querySelector('.hrw-rp__invhead');
      // .hidden relies on the UA stylesheet's [hidden]{display:none}, which
      // this element's own (higher-specificity, theme-scoped) display:flex
      // rule was still beating — set the inline style directly instead.
      if (invHead) invHead.style.display = 'none';
      return;
    }
    grid.classList.remove('is-gated');
    if (layout) layout.classList.remove('is-gated');
    var items = invAllItems();
    // measured against the FULL, unfiltered list — the card's height must
    // stay put across a filter-tab change too, not just across picking a
    // different item within the same filter.
    invSyncAboutHeight(items);
    // Mounts live under the "Key Items" tab now (no separate Mounts tab)
    if (invFilter !== 'all') items = items.filter(function (it) {
      return it.type === invFilter || (invFilter === 'key' && it.type === 'mount');
    });
    items = invSortItems(items);
    items.forEach(function (it, i) { it._i = i; });
    var about = root.querySelector('[data-inv-about]');
    if (!items.length) {
      grid.innerHTML = '<p class="hrw-rp__inv-note">Nothing of that kind in your pack yet.</p>';
      if (about) { about.className = 'hrw-rp__invabout'; about.innerHTML = ''; }
      return;
    }
    // Stardew-style pack: a fixed grid of square slots. The item is just its
    // icon sitting in a slot — no per-item card / border / colour block. Slots
    // beyond the last item render empty so it always reads as a full grid.
    var SLOT_STEP = 12;   // pad to a multiple of 12 (divides cleanly by 3/4/6 cols)
    var slotCount = Math.max(24, Math.ceil(items.length / SLOT_STEP) * SLOT_STEP);
    if (invSelKey && !items.some(function (it) { return invItemKey(it) === invSelKey; })) invSelKey = null;
    if (!invSelKey && items[0]) invSelKey = invItemKey(items[0]);
    var seenSet = hrwLoadSet(HRW_INV_SEEN_KEY);
    var cells = items.map(function (it, i) {
      var rar = INV_RARITY[it.rarity] || INV_RARITY.common;
      var isNew = invCardIsNew(it, seenSet);
      var cls = 'hrw-rp__invcard' + (it.locked ? ' is-locked' : '') + (it.used ? ' is-used' : '') + (it.equipped ? ' is-equipped' : '')
        + (invItemKey(it) === invSelKey ? ' is-open' : '');
      return '<button type="button" class="' + cls + '" style="--rar: ' + rar.color + ';" data-inv-i="' + i + '" ' +
        'aria-label="' + esc(it.name + ', ' + rar.label + ' ' + (INV_TYPE_LABEL[it.type] || '') + (it.equipped ? ', equipped' : '') + (isNew ? ', new' : '')) + '" title="' + esc(it.name) + '">' +
        '<span class="hrw-rp__invcard-ico">' + (it.locked ? INV_ICONS.lock : it.icon) + '</span>' +
        (it.equipped ? '<span class="hrw-rp__invcard-eq" aria-hidden="true">▲</span>' : '') +
        (it.used ? '<span class="hrw-rp__invcard-flag" aria-hidden="true">✓</span>' : '') +
        (isNew ? '<span class="hrw-rp__invcard-new" aria-hidden="true">New</span>' : '') +
      '</button>';
    });
    for (var s = items.length; s < slotCount; s++) cells.push('<span class="hrw-rp__invslot" aria-hidden="true"></span>');
    grid.innerHTML = cells.join('');

    function itFor(b) { return items[+b.getAttribute('data-inv-i')]; }
    // Click / keyboard is the ONLY thing that selects — no hover preview.
    function select(b, userAction) {
      var it = itFor(b); if (!it) return;
      // picking an item only ever changes the About card's CONTENT — it must
      // never move the page's scroll position (removed the mobile
      // scrollIntoView here per Nick). The residual jump turned out to be a
      // native browser behaviour, not our JS: clicking a <button> focuses it,
      // and the About card (reordered above the grid on mobile) changing
      // height right under a still-focused control makes some mobile
      // browsers auto-scroll to keep it in view. Blur BEFORE mutating the DOM
      // so there's no focused element for the browser to chase.
      if (userAction && b.blur) { try { b.blur(); } catch (e) {} }
      invSelKey = invItemKey(it);
      grid.querySelectorAll('[data-inv-i]').forEach(function (x) { x.classList.toggle('is-open', x === b); });
      invShowAbout(it);
    }
    grid.__invPick = select;
    if (!grid.__invClickWired) {
      grid.__invClickWired = true;
      // delegated — bound once on the stable grid element; catches clicks that
      // land on the inner icon and survives any per-node binding gap.
      grid.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-inv-i]');
        if (b && grid.__invPick) grid.__invPick(b, true);
      });
    }
    grid.querySelectorAll('[data-inv-i]').forEach(function (b) {
      // :focus-visible is false for a mouse/touch-focused button, true for a
      // real keyboard Tab — so a click's native focus no longer re-triggers
      // select() (and its DOM mutation) while the button is still focused;
      // the click handler below already selects it, after blurring first.
      b.addEventListener('focus', function () { if (b.matches && b.matches(':focus-visible')) select(b); });
    });
    // feed the About panel from the (already-highlighted in the HTML) selection
    var keep = grid.querySelector('.hrw-rp__invcard.is-open') || grid.querySelector('[data-inv-i="0"]');
    if (keep) { var it0 = itFor(keep); if (it0) invShowAbout(it0); }
  }

  (function wireInvControls() {
    // themed dropdown (a native <select>'s open list can't be styled) — used for
    // both the Filter and the Sort controls in the inventory head.
    function wireDropdown(wrap, valSel, onPick) {
      if (!wrap) return;
      var btn = wrap.querySelector('button');
      var menu = wrap.querySelector('.hrw-rp__invsort-menu');
      var valEl = wrap.querySelector(valSel);
      var opts = [].slice.call(wrap.querySelectorAll('.hrw-rp__invsort-opt'));
      function closeMenu() { menu.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
      function openMenu() { menu.hidden = false; btn.setAttribute('aria-expanded', 'true'); }
      btn.addEventListener('click', function (e) { e.stopPropagation(); menu.hidden ? openMenu() : closeMenu(); });
      opts.forEach(function (o) {
        o.addEventListener('click', function () {
          opts.forEach(function (x) { x.classList.toggle('is-sel', x === o); x.setAttribute('aria-selected', x === o ? 'true' : 'false'); });
          if (valEl) valEl.textContent = o.textContent.trim();
          closeMenu();
          onPick(o.getAttribute('data-val'));
        });
      });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) closeMenu(); });
      wrap.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMenu(); btn.focus(); } });
    }
    // Filter has two faces — the desktop tab row and the mobile dropdown. One
    // setter keeps both in sync so switching viewports never shows a stale state.
    var filterWrap = root.querySelector('[data-inv-filter-wrap]');
    var filterTabs = [].slice.call(root.querySelectorAll('[data-inv-filter-btn]'));
    function setInvFilter(v) {
      invFilter = v;
      filterTabs.forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-inv-filter-btn') === v); });
      if (filterWrap) {
        var val = filterWrap.querySelector('[data-inv-filter-value]');
        filterWrap.querySelectorAll('.hrw-rp__invsort-opt').forEach(function (o) {
          var on = o.getAttribute('data-val') === v;
          o.classList.toggle('is-sel', on); o.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on && val) val.textContent = o.textContent.trim();
        });
      }
      renderInventory();
    }
    filterTabs.forEach(function (b) {
      b.addEventListener('click', function () { setInvFilter(b.getAttribute('data-inv-filter-btn')); });
    });
    wireDropdown(filterWrap, '[data-inv-filter-value]', setInvFilter);
    wireDropdown(root.querySelector('[data-inv-sort-wrap]'), '[data-inv-sort-value]', function (v) {
      invSort = v; renderInventory();
    });
  })();

  // ---- Start Menu "start screen": one panel shows at a time --------------
  (function initAdvNav() {
    var menu = root.querySelector('.hrw-rp__advmenu');
    if (!menu || !menu.querySelector('[data-adv-go]')) return;
    var PANELS = ['progress', 'quests', 'shop', 'inventory', 'lore'];   // 'map' moved to the Retro menu (Nick)
    var panelEls = {};
    PANELS.forEach(function (n) { panelEls[n] = root.querySelector('[data-adv-panel="' + n + '"]'); });
    function go(name, persist) {
      if (PANELS.indexOf(name) < 0) name = 'progress';
      PANELS.forEach(function (n) { if (panelEls[n]) panelEls[n].classList.toggle('is-active', n === name); });
      // re-query every call — the mobile carousel clones these buttons
      root.querySelectorAll('[data-adv-go]').forEach(function (b) {
        var on = b.getAttribute('data-adv-go') === name;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-current', on ? 'true' : 'false');
      });
      // mobile carousel: slide the picked label to the centre so it's obvious
      // there are more pages behind a scroll
      if (typeof menu.__centerActive === 'function') menu.__centerActive(name);
      if (persist) { try { localStorage.setItem('hrw-adv-panel', name); } catch (e) {} }
      // only DO anything expensive when Start Menu is actually the live theme
      if (root.getAttribute('data-hrw-theme') !== 'start-menu') return;
      if (name === 'inventory') renderInventory();
      if (name === 'progress' && levelUpState.tiers) renderSkillTreeH(levelUpState.tiers, levelUpState.lifetimeSpend);
      // the scrollers need the panel visible to measure — (re)build on activate
      if (name === 'quests') renderAdvScroller(root.querySelector('[data-advsc="quests"]'), advQuestItems(), { kicker: 'Quest', empty: 'More ways to earn are on their way.' });
      if (name === 'shop') renderAdvScroller(root.querySelector('[data-advsc="shop"]'), advShopItems(), { kicker: 'Item', empty: 'The shop is being restocked.', grouped: true });
      if (name === 'lore') renderHeroJournal();
      // keep the menu in view when the reader taps between panels (not on load)
      if (persist) {
        try {
          var top = root.querySelector('[data-advscreen]').getBoundingClientRect().top + window.pageYOffset - 12;
          if (window.pageYOffset > top + 40) window.scrollTo({ top: top, behavior: 'smooth' });
        } catch (e) {}
      }
    }
    // delegated — survives the mobile carousel cloning its buttons
    menu.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-adv-go]');
      if (b && menu.contains(b)) go(b.getAttribute('data-adv-go'), true);
    });
    var saved; try { saved = localStorage.getItem('hrw-adv-panel'); } catch (e) {}
    go(PANELS.indexOf(saved) > -1 ? saved : 'progress', false);
    window.__hrwAdvNav = go;

    // ---- Deep links from the account page (operator, 2026-09-24) ----------
    // #rewards    -> the reward shop     (Spend credits)
    // #my-rewards -> the member's rewards (My rewards)
    // The VIEW is whichever one they used last — it is already remembered in
    // localStorage ('hrw-theme') and applied before first paint — so this only
    // decides where to land within it: Classic scrolls to the section, Start
    // Menu opens the matching panel (shop / inventory) and brings its screen
    // into view.
    //
    // KEEPS LANDING while the page fills in. The hero, tiers and quests above
    // render from async calls and move the target; opening the Shop panel also
    // scrolls its first item into view. Some of those shifts change neither
    // the page's height nor its scroll position (one block shrinks as another
    // grows), so no resize or scroll event reports them — measured: the Shop
    // landing sat 99px off with both listeners in place. So for 4 seconds the
    // target's position is simply checked every 100ms and re-aimed if it has
    // drifted, and all of it stops the moment the member scrolls, taps or
    // types.
    (function landOnHash() {
      var HASH_TO = {
        rewards: { panel: 'shop', el: '#rewards' },
        'my-rewards': { panel: 'inventory', el: '#my-rewards' }
      };
      var dest = HASH_TO[(window.location.hash || '').replace(/^#/, '')];
      if (!dest) return;
      var startMenu = root.getAttribute('data-hrw-theme') === 'start-menu';
      if (startMenu) go(dest.panel, false);
      function target() {
        return startMenu ? root.querySelector('[data-advscreen]') : root.querySelector(dest.el);
      }
      function aim() {
        var t = target();
        if (!t) return;
        var header = document.querySelector('.haki-header, sticky-header, .section-header');
        var off = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        window.scrollTo(0, t.getBoundingClientRect().top + window.pageYOffset - off - 12);
      }
      var stopped = false;
      function stop() { stopped = true; }
      ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) {
        window.addEventListener(ev, stop, { passive: true, once: true });
      });
      function expected() {
        var header = document.querySelector('.haki-header, sticky-header, .section-header');
        return (header ? Math.max(0, header.getBoundingClientRect().bottom) : 0) + 12;
      }
      aim();
      var ticks = 0;
      var timer = setInterval(function () {
        ticks++;
        if (stopped || ticks > 40) { clearInterval(timer); return; }
        var t = target();
        if (t && Math.abs(t.getBoundingClientRect().top - expected()) > 2) aim();
      }, 100);
    })();

    // ---- Mobile: 3-up infinitely-looping carousel of the menu labels --------
    (function initAdvMenuCarousel() {
      var MQ = window.matchMedia && window.matchMedia(HRW_ADVSC_MOBILE_MQ);
      if (!MQ) return;
      var originals = [].slice.call(menu.querySelectorAll('.hrw-rp__advmenu-btn'));
      if (originals.length < 4) return;
      // 5, not 3: three copies left well under one set of runway either side.
      var COPIES = 5;
      var MID = Math.floor(COPIES / 2);
      var built = false, setW = 0, wrapGuard = false;

      function build() {
        if (built) return;
        built = true;
        // which panel is live right now — carry its underline onto the clones
        // (switching to the carousel used to blank it until the next click).
        var activeEl = menu.querySelector('.hrw-rp__advmenu-btn.is-active');
        var activeGo = activeEl ? activeEl.getAttribute('data-adv-go') : 'progress';
        menu.classList.add('is-carousel');
        menu.textContent = '';
        for (var c = 0; c < COPIES; c++) {
          originals.forEach(function (o) {
            var clone = o.cloneNode(true);
            var on = o.getAttribute('data-adv-go') === activeGo;
            clone.classList.toggle('is-active', on);
            if (on) clone.setAttribute('aria-current', 'true'); else clone.removeAttribute('aria-current');
            if (c !== MID) { clone.setAttribute('tabindex', '-1'); clone.setAttribute('aria-hidden', 'true'); }
            menu.appendChild(clone);
          });
        }
        menu.addEventListener('scroll', onScroll, { passive: true });
        // start with the active label centred (retry until the row has width)
        var tries = 0;
        function centerInitial() {
          // Read whichever panel is ACTUALLY marked active right now, not
          // localStorage — Start Menu's "always land on Progress" override
          // (apply(), further down) calls go('progress', false) WITHOUT
          // persisting, precisely so it doesn't clobber the member's real
          // saved preference. That's correct for storage, but it meant this
          // retry loop kept re-reading the now-stale saved value on every
          // attempt and re-centring on THAT — often winning the race against
          // the override since its own retries fire later, on a real layout
          // pass, than the override's immediate (frequently too-early,
          // zero-width) one. The live DOM class is the one source of truth
          // for "what's actually showing right now" (Nick).
          var activeBtn = menu.querySelector('.hrw-rp__advmenu-btn.is-active');
          var name = activeBtn && activeBtn.getAttribute('data-adv-go');
          if (PANELS.indexOf(name) < 0) {
            var cur; try { cur = localStorage.getItem('hrw-adv-panel'); } catch (e) {}
            name = PANELS.indexOf(cur) > -1 ? cur : 'progress';
          }
          centerActive(name, false, true);
        }
        (function centre() {
          setW = menu.scrollWidth / COPIES;
          if (setW > 40) { centerInitial(); }
          else if (tries++ < 20) { requestAnimationFrame(centre); }
        })();
        // belt-and-braces: a DevTools viewport toggle (desktop -> mobile) can
        // delay layout past the ~20-frame rAF budget above, which used to
        // leave the strip un-centred until a hard reload gave layout more
        // time to settle before the retries gave up (Nick).
        setTimeout(function () {
          setW = menu.scrollWidth / COPIES;
          if (setW > 40) centerInitial();
        }, 450);
      }

      // slide the middle-copy button for `name` to the horizontal centre of the
      // menu viewport — so the neighbouring labels peek in and it reads as a
      // scrollable strip.
      var order = originals.map(function (b) { return b.getAttribute('data-adv-go'); });
      function centerActive(name, smooth, isInitial) {
        if (!built) return;
        var idx = order.indexOf(name);   // DOM order, not PANELS order
        if (idx < 0) return;
        // The panel switch this drives also (re)renders that panel's own
        // content synchronously (renderAdvScroller / renderHeroJournal /
        // renderSkillTreeH) right before this runs — occasionally still
        // mid-reflow at this exact point, which reads clientWidth as 0 and
        // computes every target as 0 too, i.e. "centre" on whatever's
        // already at the very start of the strip: the class/underline still
        // land on the right button (that's separate, in go()), but the
        // strip itself doesn't visibly move. One rAF is enough for layout to
        // catch up (Nick).
        if (!menu.clientWidth) { requestAnimationFrame(function () { centerActive(name, smooth, isInitial); }); return; }
        // deterministic: every button is exactly a third of the menu width.
        // Pick whichever copy's occurrence of `name` is CLOSEST to
        // the current scroll position, not always the canonical middle copy —
        // otherwise picking the panel one slot away (e.g. Journal -> Progress,
        // which wraps from the last button to the first) always re-targeted
        // the middle copy far across the strip instead of sliding one step,
        // reading as "it scrolls all the way back" (Nick). Exception: the very
        // first placement on build (isInitial), before scrollLeft has ever
        // been set — scrollLeft is 0 then, which would read as "closest to
        // copy 0" and start the strip with no room to wrap left; that one
        // call still wants the canonical middle copy.
        var btnW = menu.clientWidth / 3;
        var from = menu.scrollLeft;
        var target = null, bestDist = Infinity;
        for (var c = 0; c < COPIES; c++) {
          var t = (c * originals.length + idx) * btnW - menu.clientWidth / 2 + btnW / 2;
          var d = isInitial ? Math.abs(c - MID) : Math.abs(t - from);
          if (d < bestDist) { bestDist = d; target = t; }
        }
        wrapGuard = true;
        if (smooth === false) {
          menu.scrollLeft = target;
        } else {
          try { menu.scrollTo({ left: target, behavior: 'smooth' }); } catch (e) {}
          // scrollTo+smooth can no-op in some engines — settle it directly too
          setTimeout(function () { if (Math.abs(menu.scrollLeft - target) > 20) menu.scrollLeft = target; }, 320);
        }
        setTimeout(function () {
          wrapGuard = false;
          // Re-normalise into the safe middle third now that the deliberate
          // scroll above has settled — the passive onScroll handler does
          // the same wrap, but wrapGuard suppresses it for exactly this
          // 550ms window (on purpose, so it can't fight this scroll while
          // it's happening). Without this, repeatedly picking "closest
          // copy" while walking the SAME direction (e.g. clicking through
          // every panel left-to-right in order) drifts the strip toward
          // copy 0 or copy 2 and never gets nudged back — eventually there
          // is no copy further in that direction to slide into (copy 2 is
          // the last one), and the browser's own scroll clamping makes it
          // read as "hitting a wall" one way while the other way, which
          // happens to stay nearer the middle copy more often, still
          // looked fine ("infinite" looping) (Nick).
          var sl = menu.scrollLeft;
          var nl = hrwLoopWrap(sl, setW, menu.scrollWidth - menu.clientWidth);
          if (nl !== sl) menu.scrollLeft = nl;
        }, 550);
      }
      menu.__centerActive = centerActive;

      function teardown() {
        if (!built) return;
        built = false;
        menu.classList.remove('is-carousel');
        menu.removeEventListener('scroll', onScroll);
        menu.__centerActive = null;
        menu.textContent = '';
        originals.forEach(function (o) { menu.appendChild(o); });
        // re-assert active state on the restored originals
        var cur; try { cur = localStorage.getItem('hrw-adv-panel'); } catch (e) {}
        go(PANELS.indexOf(cur) > -1 ? cur : 'progress', false);
      }

      var raf = false;
      function onScroll() {
        if (raf) return; raf = true;
        requestAnimationFrame(function () {
          raf = false;
          if (!setW || wrapGuard) return;
          var sl = menu.scrollLeft;
          // keep the viewport inside the middle copy, wrapping by exactly one
          // set (invisible — the copies are identical) well before the true
          // edge of the scrollable content — a fast swipe's momentum can
          // cover a lot of ground in a single frame, and correcting only at
          // [0.5, 2.5] (half a set of buffer either side) let a hard flick
          // reach the ACTUAL end of the scrollable area (a real, physical
          // stop the browser itself enforces, not something this correction
          // can override after the fact) before this ever got a chance to
          // run — reads as "hitting a wall". Correcting earlier, at
          // [0.85, 2.15], leaves much less room for a single flick to
          // outrun it (Nick).
          // Where to wrap: see hrwLoopWrap — a window centred in the real
          // scrollable range, so both directions get the same runway.
          var nl = hrwLoopWrap(sl, setW, menu.scrollWidth - menu.clientWidth);
          if (nl !== sl) { wrapGuard = true; menu.scrollLeft = nl; wrapGuard = false; }
        });
      }

      function sync() { (MQ.matches ? build : teardown)(); }
      sync();
      (MQ.addEventListener ? MQ.addEventListener('change', sync) : MQ.addListener(sync));
    })();
  })();

  // ---- Retro mode: a tiny Game Boy overworld (super-stretch scaffold) ----
  // Toggling the theme to "Retro" hides the page and shows a playable DMG:
  // walk a 10x9 tile overworld, press A at a sign to read your balance / rank
  // / stash / quests (same hrwCoinBalance / hrwTierName / redemptions the rest
  // of the page uses). Inert — the rAF loop only runs while retro is live.
  (function initRetro() {
    var wrap = root.querySelector('[data-retro]');
    var cv = wrap && wrap.querySelector('[data-gb-screen]');
    if (!cv || !cv.getContext) return;
    var ctx = cv.getContext('2d');
    var W = 240, H = 160, TILE = 16;   // real GBA resolution
    // 15 wide x 10 tall. 0 grass · 1 tree · 2 water · 3 tall grass · 4-7 signs.
    var MAP = [
      [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
      [1,0,0,0,4,0,0,3,3,0,0,0,5,0,1],
      [1,0,1,0,0,0,0,3,3,0,0,0,0,0,1],
      [1,0,0,0,0,0,0,0,0,0,1,0,0,0,1],
      [1,0,0,0,0,0,1,0,0,0,0,0,0,0,1],
      [1,0,6,0,0,0,0,0,0,0,0,0,7,0,1],
      [1,0,0,0,0,0,0,1,0,0,0,0,0,0,1],
      [1,0,0,1,0,0,0,0,0,0,3,3,0,0,1],
      [1,0,0,0,0,2,2,2,0,0,3,3,0,0,1],
      [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]
    ];
    var SIGNS = {
      4: { name: 'BANK', info: function () { return 'You are holding ' + fmt(hrwCoinBalance) + ' ' + coinWord().toUpperCase() + '.'; } },
      5: { name: 'RANK BOARD', info: function () { return 'Current rank: ' + (hrwTierName || 'Recruit').toUpperCase() + '. Keep spending to climb.'; } },
      6: { name: 'CHEST', info: function () { var k = countStash(); return k ? ('Your stash holds ' + k + ' unused reward' + (k === 1 ? '' : 's') + '. Open the BAG.') : 'Your stash is empty for now.'; } },
      7: { name: 'QUEST BOARD', info: function () { return 'Quests: buy something, join the newsletter, follow the socials, take the quiz. Menu > QUESTS for the list.'; } }
    };
    // Pokémon-style start menu — "use the pokemon menu directly"
    var MENU = [
      { k: 'MAP', line: null, map: true },
      { k: 'JOURNAL', line: function () { return 'JOURNAL - your lore entries and the trophies you’ve earned. Full view in Start Menu mode.'; } },
      { k: 'QUESTS', line: function () { return 'QUESTS - Main: account, newsletter, socials, Discord, quiz. Side: manga of the week, review, suggest a song, purchase.'; } },
      { k: 'SHOP', line: function () { return 'THE ITEM SHOP - spend ' + coinWord() + ' on discount codes and the odd piece of kit. You have ' + fmt(hrwCoinBalance) + '.'; } },
      { k: 'BAG', line: function () { var k = countStash(); return 'BAG - ' + (k ? (k + ' unused reward' + (k === 1 ? '' : 's') + ' plus your key items and mounts.') : 'key items and mounts; no unused rewards yet.'); } },
      { k: 'RANK', line: function () { return 'RANK - ' + (hrwTierName || 'Recruit').toUpperCase() + '. ' + fmt(hrwCoinBalance) + ' ' + coinWord() + ' banked.'; } },
      { k: 'EXIT', line: null }
    ];
    // Pokémon Emerald (Hoenn) overworld palette — warmer, softer, more saturated
    // than R/B/Y: sandy paths, rounded trees, rippling water.
    var C = {
      grass: '#88c078', grass2: '#78b068', grass3: '#98d088', tgrass: '#4a9048', tgrassDk: '#387038',
      tree: '#3c8c3c', treeDk: '#286028', treeHi: '#6cb85c', trunk: '#8a6038',
      water: '#5878c8', waterLt: '#88a8e8', waterHi: '#b8d0f0',
      path: '#e0c890', pathDk: '#c8a868',
      sign: '#c88a4c', signDk: '#8a5a30', post: '#6a4522',
      ink: '#283038', line: '#48505c', paper: '#f8f4e8', dim: '#8890a0',
      p1: '#d83c34', p2: '#f0f0f0', skin: '#f8d0a8', hair: '#3a2a1c', boot: '#303640'
    };
    var player = { x: 7, y: 4, dir: 'down', px: 0, py: 0, tx: 0, ty: 0, moving: false, step: 0 };
    var dialog = null, menuOpen = false, menuI = 0;
    var running = false, raf = 0;

    function fmt(n) { return (+n || 0).toLocaleString(); }
    // Counts unspent rewards from the SERVER bank, so the number matches what
    // Inventory and Your Rewards actually show.
    function countStash() { try { return hrwBank.filter(function (r) { return r.status !== 'used'; }).length; } catch (e) { return 0; } }
    function tileAt(tx, ty) { return (MAP[ty] && MAP[ty][tx] != null) ? MAP[ty][tx] : 1; }
    function blocked(tx, ty) { var t = tileAt(tx, ty); return t === 1 || t === 2 || !!SIGNS[t]; }
    function px(x, y, w, h, col) { ctx.fillStyle = col; ctx.fillRect(x | 0, y | 0, w | 0, h | 0); }

    var animT = 0;   // advanced once per frame — drives the water shimmer
    function drawTile(t, x, y) {
      // Emerald grass: a soft two-tone checker with a few brighter blades
      var tileI = ((x + y) / TILE) | 0;
      px(x, y, TILE, TILE, tileI % 2 ? C.grass : C.grass2);
      px(x + ((tileI * 7) % 12), y + ((tileI * 5) % 12), 2, 1, C.grass3);
      px(x + ((tileI * 11) % 13), y + ((tileI * 3) % 11) + 3, 1, 2, tileI % 2 ? C.grass2 : C.grass);
      if (t === 1) {
        // rounded canopy + short trunk
        px(x + 3, y + 12, 3, 4, C.trunk);
        px(x + 2, y + 2, 12, 11, C.treeDk);
        px(x + 3, y + 1, 10, 10, C.tree);
        px(x + 4, y + 2, 6, 4, C.treeHi);
        px(x + 1, y + 6, 2, 4, C.tree); px(x + 13, y + 6, 2, 4, C.tree);
      } else if (t === 2) {
        px(x, y, TILE, TILE, C.water);
        var w = (animT + tileI) % 4;
        px(x + 1 + w, y + 3, 5, 1, C.waterLt);
        px(x + 8 - w, y + 9, 5, 1, C.waterHi);
        px(x + 3, y + 12, 4, 1, C.waterLt);
      } else if (t === 3) {
        px(x, y, TILE, TILE, tileI % 2 ? C.grass2 : C.grass);
        px(x + 2, y + 5, 3, 9, C.tgrass); px(x + 7, y + 3, 3, 11, C.tgrassDk); px(x + 11, y + 6, 3, 8, C.tgrass);
        px(x + 3, y + 4, 1, 2, C.tgrassDk); px(x + 12, y + 5, 1, 2, C.tgrassDk);
      } else if (SIGNS[t]) {
        px(x + 7, y + 9, 2, 6, C.post);
        px(x + 1, y + 1, 14, 9, C.signDk);
        px(x + 2, y + 2, 12, 7, C.sign);
        px(x + 3, y + 3, 10, 1, C.signDk); px(x + 3, y + 5, 8, 1, C.signDk); px(x + 3, y + 7, 6, 1, C.signDk);
      }
    }
    function drawPlayer() {
      var x = player.px, y = player.py, bob = (player.moving && (player.step >> 2) % 2) ? 1 : 0;
      px(x + 4, y + 13, 8, 2, C.grass2);
      px(x + 4, y + 6 - bob, 8, 7, C.p1);            // body
      px(x + 4, y + 2 - bob, 8, 5, C.skin);          // head
      px(x + 3, y + 1 - bob, 10, 3, C.p2);           // cap
      px(x + 4, y + 12 - bob, 3, 2, C.boot); px(x + 9, y + 12 - bob, 3, 2, C.boot);
      ctx.fillStyle = C.ink;
      if (player.dir === 'down') { ctx.fillRect(x + 6, y + 4 - bob, 1, 1); ctx.fillRect(x + 9, y + 4 - bob, 1, 1); }
      else if (player.dir === 'up') { px(x + 3, y + 1 - bob, 10, 2, C.hair); }
      else if (player.dir === 'left') ctx.fillRect(x + 5, y + 4 - bob, 1, 1);
      else ctx.fillRect(x + 10, y + 4 - bob, 1, 1);
    }
    function panel(bx, by, bw, bh) {
      px(bx, by, bw, bh, C.ink);
      px(bx + 1, by + 1, bw - 2, bh - 2, C.paper);
      px(bx + 3, by + 3, bw - 6, bh - 6, C.paper);
      ctx.strokeStyle = C.line; ctx.lineWidth = 1;
      ctx.strokeRect(bx + 2.5, by + 2.5, bw - 5, bh - 5);
    }
    function wrapText(t, x, y, maxw, lh) {
      var words = String(t).split(' '), line = '', yy = y;
      for (var i = 0; i < words.length; i++) {
        var test = line + words[i] + ' ';
        if (ctx.measureText(test).width > maxw && line) { ctx.fillText(line.trim(), x, yy); line = words[i] + ' '; yy += lh; }
        else line = test;
      }
      ctx.fillText(line.trim(), x, yy);
    }
    function drawDialog(text) {
      var bh = 50, by = H - bh - 5;
      panel(6, by, W - 12, bh);
      ctx.fillStyle = C.ink;
      ctx.font = '9px "Courier New", Courier, monospace';
      wrapText(text, 14, by + 15, W - 30, 11);
      ctx.fillText('▼', W - 20, by + bh - 8);
    }
    function drawMenu() {
      var bw = 92, bx = W - bw - 6, by = 6, rh = 15, bh = MENU.length * rh + 10;
      panel(bx, by, bw, bh);
      ctx.font = '9px "Courier New", Courier, monospace';
      for (var i = 0; i < MENU.length; i++) {
        var ry = by + 8 + i * rh;
        ctx.fillStyle = i === menuI ? C.ink : C.dim;
        if (i === menuI) ctx.fillText('▶', bx + 6, ry + 8);
        ctx.fillText(MENU[i].k, bx + 16, ry + 8);
      }
    }
    var frameN = 0;
    function frame() {
      if (!running) return;
      if ((++frameN & 7) === 0) animT++;   // water shimmer ~7fps
      if (player.moving) {
        var s = 2; player.step++;
        if (player.px !== player.tx) player.px += Math.sign(player.tx - player.px) * Math.min(s, Math.abs(player.tx - player.px));
        if (player.py !== player.ty) player.py += Math.sign(player.ty - player.py) * Math.min(s, Math.abs(player.ty - player.py));
        if (player.px === player.tx && player.py === player.ty) { player.moving = false; player.step = 0; player.x = player.tx / TILE; player.y = player.ty / TILE; }
      }
      ctx.clearRect(0, 0, W, H);
      for (var ty = 0; ty < MAP.length; ty++) for (var tx = 0; tx < MAP[ty].length; tx++) drawTile(MAP[ty][tx], tx * TILE, ty * TILE);
      drawPlayer();
      if (menuOpen) drawMenu();
      if (dialog) drawDialog(dialog);
      raf = requestAnimationFrame(frame);
    }
    function facing() {
      var dx = player.dir === 'left' ? -1 : player.dir === 'right' ? 1 : 0;
      var dy = player.dir === 'up' ? -1 : player.dir === 'down' ? 1 : 0;
      return SIGNS[tileAt(player.x + dx, player.y + dy)];
    }
    function tryMove(dir) {
      if (dialog || menuOpen) return;
      player.dir = dir;
      if (player.moving) return;
      var dx = dir === 'left' ? -1 : dir === 'right' ? 1 : 0;
      var dy = dir === 'up' ? -1 : dir === 'down' ? 1 : 0;
      if (blocked(player.x + dx, player.y + dy)) return;
      player.tx = (player.x + dx) * TILE; player.ty = (player.y + dy) * TILE; player.moving = true;
    }
    function press(btn) {
      if (btn === 'up' || btn === 'down' || btn === 'left' || btn === 'right') {
        if (menuOpen) { if (btn === 'up') menuI = (menuI + MENU.length - 1) % MENU.length; if (btn === 'down') menuI = (menuI + 1) % MENU.length; return; }
        tryMove(btn); return;
      }
      if (btn === 'a') {
        if (dialog) { dialog = null; return; }
        if (menuOpen) {
          var m = MENU[menuI];
          if (m.map) { menuOpen = false; if (typeof window.__hrwOpenMap === 'function') window.__hrwOpenMap(); return; }
          if (!m.line) { exitRetro(); return; }
          dialog = m.line();
          return;
        }
        var st = facing();
        if (st) dialog = st.name + ' - ' + st.info();
      } else if (btn === 'b') {
        if (dialog) dialog = null;
        else if (menuOpen) menuOpen = false;
        else exitRetro();
      } else if (btn === 'start') {
        if (dialog) return;
        menuOpen = !menuOpen;
      } else if (btn === 'select') {
        if (!dialog && !menuOpen) dialog = 'HAKI BOY ADVANCE - walk with the D-pad, read signs with A, open the menu with Start.';
      }
    }
    function exitRetro() {
      menuOpen = false; dialog = null;
      window.__hrwCloseGameBoy();
    }
    function onKey(e) {
      var m = { ArrowUp: 'up', ArrowDown: 'down', ArrowLeft: 'left', ArrowRight: 'right' };
      if (m[e.key]) { e.preventDefault(); press(m[e.key]); }
      else if (e.key === 'z' || e.key === 'Z' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); press('a'); }
      else if (e.key === 'x' || e.key === 'X' || e.key === 'Escape') { e.preventDefault(); press('b'); }
      else if (e.key === 'Enter') { e.preventDefault(); press('start'); }
    }

    wrap.querySelectorAll('[data-gb-dir]').forEach(function (b) {
      b.addEventListener('click', function () { press(b.getAttribute('data-gb-dir')); });
    });
    wrap.querySelectorAll('[data-gb-btn]').forEach(function (b) {
      b.addEventListener('click', function () { press(b.getAttribute('data-gb-btn')); });
    });
    var back = wrap.querySelector('[data-retro-back]');
    if (back) back.addEventListener('click', exitRetro);
    // click the dimmed backdrop (outside the console) to put it away
    wrap.addEventListener('click', function (e) { if (e.target === wrap) exitRetro(); });

    window.__hrwRetro = function (on) {
      if (!!on === running) return;
      running = !!on;
      if (running) {
        document.addEventListener('keydown', onKey);
        menuOpen = false; menuI = 0;
        player.x = 7; player.y = 4; player.px = 7 * TILE; player.py = 4 * TILE; player.tx = player.px; player.ty = player.py; player.moving = false; player.dir = 'down';
        dialog = 'Welcome to HAKI BOY ADVANCE. D-pad to walk, A to read a sign, Start for the menu.';
        frame();
      } else {
        cancelAnimationFrame(raf);
        document.removeEventListener('keydown', onKey);
        dialog = null; menuOpen = false;
      }
    };
    // The Game Boy is an overlay now (opened from the "Hakiboy Advance" key
    // item) — it floats over whatever panel you were on, dimmed backdrop.
    window.__hrwOpenGameBoy = function () {
      wrap.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      window.__hrwRetro(true);
    };
    window.__hrwCloseGameBoy = function () {
      wrap.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      window.__hrwRetro(false);
    };
  })();

  // ---- theme switch: Light / Dark / Start Menu / Retro -----------------
  // Presentational only. The pre-paint inline script has already set
  // data-hrw-theme from localStorage; this wires the buttons and re-runs the
  // theme-dependent bits (tier drawers vs cards, the map-as-tier-display; the
  // three section renames + the dark backdrop are pure CSS).
  (function initThemeSwitch() {
    var sw = root.querySelector('[data-themeswitch]');
    // REVERTED — "always dock on desktop too" (position:fixed to the
    // viewport) looked right in the isolated section-only test harness, but
    // the real site has its own sticky header that harness can't show —
    // fixed-to-viewport meant the switch stopped tracking the hero/title at
    // all past scroll position 0 and sat pinned near the SITE's header
    // instead, overlapping it. Back to: mobile (≤640px) docks to <body> as
    // before; desktop stays a normal (non-fixed) child of the section, so it
    // scrolls with the hero/title the way "aligned with MEMBERS CLUB" always
    // assumed. Fixed-on-scroll-on-desktop is a real, separate ask (needs
    // position:sticky done properly, which needs knowing the real site
    // header's height/behaviour) — not this quick swap (Nick).
    var swHome = sw ? sw.parentNode : null, swAnchor = sw ? sw.nextSibling : null;
    // The only two views. This was still listing light/dark/adventure/test — a
    // round-14 edit that silently did not apply, then masked when the skin
    // rename turned its `street` key into `classic`. Harmless while migration
    // lines mapped those away; the moment those went, a stored 'light' would
    // have been accepted as a theme and resolved to Start Menu.
    var THEMES = { classic: 1, 'start-menu': 1 };
    // The switch now offers two VIEWS — Classic and Start Menu — while the page
    // still renders three data-hrw-theme values, because light and dark are
    // real, fully-styled treatments and collapsing them in CSS would mean
    // deleting one. Classic is whichever shade is current, dark by default
    // (Nick). The shade is its own preference so flipping to Start Menu and back
    // returns you to the shade you were reading in.
    var SHADE_KEY = 'hrw-shade';
    function savedShade() {
      try { var v = localStorage.getItem(SHADE_KEY); return v === 'light' ? 'light' : 'dark'; }
      catch (e) { return 'dark'; }
    }
    var dockMQ = window.matchMedia && window.matchMedia('(max-width: 640px)');
    function syncDock() {
      if (!sw || !dockMQ) return;
      if (dockMQ.matches) {
        if (sw.parentNode !== document.body) document.body.appendChild(sw);
        sw.classList.add('is-docked');
        return;
      }
      sw.classList.remove('is-docked');
      if (swHome && sw.parentNode !== swHome) {
        swHome.insertBefore(sw, swAnchor && swAnchor.parentNode === swHome ? swAnchor : null);
      }
    }
    function apply(pick, persist) {
      // TWO VIEWS as of 2026-09-09 (Nick): Classic, the default, and Start Menu.
      //
      // Classic is what was built and judged as "Classic" and then "Test" over
      // 2026-09-08/09 — the hexagon quest grid, pill rewards, square corners.
      // The old shade-only Classic and the interim Classic view were deleted
      // once Test won: three of the four buttons existed to settle one
      // question, and keeping the losers would leave three ways to render the
      // same page.
      //
      // Every legacy stored pick folds into one of the two, so a member whose
      // browser remembers a name that no longer exists is not bounced somewhere
      // unexpected.
      // No legacy migration: none of the retired names ever shipped (Nick,
      // 2026-09-09), so anything unrecognised falls to the default below.
      if (pick === 'light' || pick === 'dark') pick = 'classic';    // the shade survives as the toggle
      if (!THEMES[pick]) pick = 'classic';                          // and it is the default now
      var isClassic = pick === 'classic';
      // Classic keeps the light/dark preference the shade toggle writes; Game
      // Menu is a single treatment and has no shade.
      var theme = isClassic ? savedShade() : 'start-menu';
      var hasShade = isClassic;
      if (hasShade) { try { localStorage.setItem(SHADE_KEY, theme); } catch (e) {} }
      root.setAttribute('data-hrw-theme', theme);
      if (isClassic) root.setAttribute('data-hrw-skin', 'classic');
      else root.removeAttribute('data-hrw-skin');
      root.removeAttribute('data-hrw-shade');
      // the switch is always a child of <body> now (see syncDock above), so
      // it can't be reached by [data-hrw-theme="..."] ancestor selectors any
      // more — mirror the pick directly onto it for its own theme-coloured
      // CSS (Nick).
      if (sw) sw.setAttribute('data-hrw-theme-mirror', theme);
      if (persist) { try { localStorage.setItem('hrw-theme', pick); } catch (e) {} }
      // Start Menu now uses the same Neue Metana / system stack as Light + Dark —
      // no extra webfont to load.
      if (sw) {
        sw.querySelectorAll('[data-theme-to]').forEach(function (b) {
          // Both shades light the Classic button — the member picked a view,
          // and neither shade should leave the switch looking unselected.
          var to = b.getAttribute('data-theme-to');
          var on = to === 'start-menu' ? !isClassic : isClassic;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      // The shade toggle is its own control now, a sibling of the switch rather
      // than a segment inside it — so it is found on the section, not on `sw`.
      // Looking it up under `sw` would silently find nothing and leave a button
      // that never hides.
      var shadeBtn = root.querySelector('[data-theme-shade]');
      if (shadeBtn) {
        // Only while Classic is showing. Beside Start Menu it would sit there
        // looking live and doing nothing.
        shadeBtn.hidden = !hasShade;
        shadeBtn.setAttribute('aria-label', theme === 'light' ? 'Switch to dark' : 'Switch to light');
        // INK IS SET HERE, NOT IN CSS. The light-theme rule matched the button,
        // outranked the base rule and carried no !important, and the computed
        // colour was STILL white — a white icon on a white page, which is the
        // "toggle vanishes in light mode" Nick saw. Rather than keep guessing
        // at a cascade that measured as impossible, the one place that already
        // knows the theme sets it directly, where nothing can outrank it.
        shadeBtn.style.color = theme === 'light' ? 'rgba(17,17,17,0.72)' : 'rgba(255,255,255,0.72)';
        if (hasShade) placeShade(shadeBtn);
      }
      if (typeof window.__hrwApplyTierTheme === 'function') window.__hrwApplyTierTheme(theme === 'start-menu');
      if (lastTiersRender && lastTiersRender.tiers) renderTiers(lastTiersRender.tiers, lastTiersRender.currentRank);
      if (levelUpState.tiers && levelUpState.lifetimeSpend !== null) {
        renderLevelUp(levelUpState.tiers, levelUpState.lifetimeSpend);  // $ ↔ XP copy per theme
        renderSkillTreeH(levelUpState.tiers, levelUpState.lifetimeSpend);  // Start Menu horizontal tree
      }
      // REVERTED — this used to force-navigate to "Progress" on EVERY apply()
      // call regardless of saved state, which stomped a legitimately-saved
      // panel back to Progress on every reload. Progress should only be the
      // default when nothing is remembered — true both at page load and on a
      // manual theme switch (Nick). The one-time setup call for
      // window.__hrwAdvNav already handles the load case; re-check here too
      // so a mid-session theme toggle gets the same rule, without touching a
      // real saved panel.
      if (theme === 'start-menu') {
        hrwRefreshAdvPanels();
        var savedPanel; try { savedPanel = localStorage.getItem('hrw-adv-panel'); } catch (e) {}
        if (!savedPanel && typeof window.__hrwAdvNav === 'function') window.__hrwAdvNav('progress', false);
      }
      syncDock();
    }
    if (sw) {
      sw.querySelectorAll('[data-theme-to]').forEach(function (b) {
        b.addEventListener('click', function () { apply(b.getAttribute('data-theme-to'), true); });
      });
      // The shade toggle flips within Classic. It reads the CURRENT theme
      // rather than a remembered one, so it stays correct if something else
      // changed the view since the last click.
      var shadeBtn = root.querySelector('[data-theme-shade]');
      if (shadeBtn) {
        shadeBtn.addEventListener('click', function () {
          var now = root.getAttribute('data-hrw-theme');
          var next = now === 'light' ? 'dark' : 'light';
          // Save the shade FIRST, then re-apply. The shade is a property of
          // Classic, not a view of its own.
          try { localStorage.setItem(SHADE_KEY, next); } catch (e) {}
          apply('classic', true);
        });
      }
      syncDock();
      // syncDock() only ever ran on init and inside apply() (i.e. on a theme
      // click) — crossing the 640px breakpoint by resizing/rotating alone
      // (e.g. devtools device toolbar) fired neither, so the switch stayed
      // parented wherever it was until something else happened to call
      // apply() or the page reloaded (Nick). Listen on both the matchMedia
      // change (the precise breakpoint-cross signal) and plain window resize
      // (belt-and-suspenders — a couple of embedded/older WebViews fire one
      // but not the other on a programmatic viewport change).
      if (dockMQ) (dockMQ.addEventListener ? dockMQ.addEventListener('change', syncDock) : dockMQ.addListener(syncDock));
      window.addEventListener('resize', syncDock);
      window.addEventListener('resize', function () {
        var b = root.querySelector('[data-theme-shade]');
        if (b && !b.hidden) placeShade(b);
      });
    }

    // Mobile hero: drop the Credits chip into the title block (as its last
    // child) so CSS grid can put it on the RANK line, right-aligned. Desktop:
    // move it back to being a plain flex child of the hero.
    (function heroBalanceDock() {
      var title = root.querySelector('.hrw-rp__advtitle');
      var bal = root.querySelector('.hrw-rp__hero-balance');
      if (!title || !bal) return;
      var mq = window.matchMedia && window.matchMedia('(max-width: 900px)');
      if (!mq) return;
      var home = bal.parentNode, anchor = bal.nextSibling;
      function sync() {
        // Start Menu only — this only checked the viewport width, so on
        // Dark/Light mobile it STILL moved Credits into .advtitle, which is
        // `display:none` outside Start Menu. The chip wasn't merely hidden —
        // being a display:none subtree it had zero size too ("the credits
        // disappeared" — Nick).
        var isStartMenu = root.getAttribute('data-hrw-theme') === 'start-menu';
        if (mq.matches && isStartMenu) {
          if (bal.parentNode !== title) title.appendChild(bal);
        } else if (bal.parentNode === title && home) {
          home.insertBefore(bal, anchor && anchor.parentNode === home ? anchor : null);
        }
      }
      sync();
      (mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync));
      new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['data-hrw-theme'] });
    })();

    // Mobile: RANK (left) and Credits (right) sit flush with the GRID's own
    // edges, but "MEMBER'S CLUB" is centred TEXT inside that same box, and its
    // rendered glyphs are a little narrower than the box (the font-size is
    // deliberately sized with a small safety margin so it never wraps) — so
    // RANK/Credits used to look like they overshot the title's own edges.
    // Measure the title's actual rendered text width (a Range, not the span's
    // own box — the span is a grid item stretched to the full row) and expose
    // the gap as a CSS var so RANK/Credits can inset by the same amount (Nick).
    (function syncTitleInset() {
      var title = root.querySelector('.hrw-rp__advtitle');
      var nameEl = title && title.querySelector('span:first-child');
      var mq = window.matchMedia && window.matchMedia('(max-width: 900px)');
      if (!title || !nameEl || !mq) return;
      function measure() {
        if (!mq.matches) { title.style.removeProperty('--hrw-title-inset'); return; }
        var tn = nameEl.firstChild;
        var textW;
        if (tn) {
          try {
            var r = document.createRange();
            r.selectNodeContents(tn);
            textW = r.getBoundingClientRect().width;
          } catch (e) { textW = nameEl.getBoundingClientRect().width; }
        } else { textW = nameEl.getBoundingClientRect().width; }
        // letter-spacing adds a gap AFTER every character, including the last
        // one — so a Range's measured width includes one trailing gap past
        // the actual last-glyph ink, which the box-width side of this
        // subtraction doesn't have. Left uncorrected, that trailing gap reads
        // as extra text width, so the computed inset undershoots by exactly
        // one letter-spacing and RANK/Credits sit a hair past the title's
        // true visual edge (Nick).
        var ls = parseFloat(getComputedStyle(nameEl).letterSpacing) || 0;
        textW = Math.max(0, textW - ls);
        var boxW = title.getBoundingClientRect().width;
        var inset = Math.max(0, (boxW - textW) / 2);
        title.style.setProperty('--hrw-title-inset', inset.toFixed(1) + 'px');
      }
      measure();
      requestAnimationFrame(measure);
      setTimeout(measure, 260);   // settle after web-font swap / late layout
      window.addEventListener('resize', measure, { passive: true });
      (mq.addEventListener ? mq.addEventListener('change', measure) : mq.addListener(measure));
      // Switching FROM Light/Dark TO Start Menu doesn't fire a resize — the
      // title text only exists/lays out once Start Menu is actually active,
      // so without this the inset stayed at whatever (usually 0, or a stale
      // value from before) it last measured, and RANK/Credits sat outside
      // "MEMBERS CLUB"'s edges until a hard reload happened to land directly
      // in Start Menu (Nick).
      new MutationObserver(measure).observe(root, { attributes: true, attributeFilter: ['data-hrw-theme'] });
    })();

    // Desktop Start Menu (>=1181px): Credits sits in the gap between the
    // centred title and the theme switch. Both neighbours' edges are governed
    // by INDEPENDENT formulas — the title by its own vw-scaled font width,
    // the switch by a near-fixed edge offset — that don't stay in a fixed
    // ratio across the breakpoint, so a flat CSS %/px position for Credits
    // kept working at whichever width it was tuned against and drifting into
    // an overlap with one side or the other at every other width (this is
    // the third round this exact spot has needed re-tuning). Measuring the
    // real edges and centring Credits in the actual gap between them is
    // correct at every width, the same way syncTitleInset() above is (Nick).
    (function syncCreditsPosition() {
      var cred = root.querySelector('.hrw-rp__hero-balance');
      var title = root.querySelector('.hrw-rp__advtitle');
      // NOT root.querySelector('[data-themeswitch]') — the switch is ALWAYS
      // docked to <body> now (see syncDock, above), so by the time this runs
      // it's no longer a descendant of root/.hrw-rp at all, and that query
      // would silently return null — which hit the `!sw` guard on the very
      // next line and skipped EVERY step below (measure/rAF/setTimeout/
      // listeners), permanently: Credits just kept whatever position it had
      // (scale(1), i.e. full size) with nothing ever re-checking it, on
      // every load, regardless of viewport width. The outer `sw` (declared
      // at the top of initThemeSwitch, captured before it's ever moved) is
      // the same element — object references stay valid across a
      // reparent — so reuse that instead of re-querying for it (Nick).
      var mq = window.matchMedia && window.matchMedia('(min-width: 1181px)');
      if (!cred || !title || !sw || !mq) return;
      function measure() {
        if (!mq.matches || root.getAttribute('data-hrw-theme') !== 'start-menu') {
          cred.style.removeProperty('left');
          cred.style.removeProperty('transform');
          return;
        }
        var heroEl = root.querySelector('.hrw-rp__hero');
        if (!heroEl) return;
        // measure Credits at its NATURAL (unscaled) size first — if a previous
        // run already shrank it, its own rect would otherwise measure smaller
        // than it actually needs, and the shrink would never recover once the
        // gap widens again.
        cred.style.transform = 'translate(-50%, -50%)';
        var hr = heroEl.getBoundingClientRect();
        var tr = title.getBoundingClientRect();
        var sr = sw.getBoundingClientRect();
        var naturalWidth = cred.getBoundingClientRect().width;
        if (!tr.width || !sr.width || !hr.width || !naturalWidth) return;   // not laid out yet
        var gap = sr.left - tr.right;
        var margin = 12;   // small breathing room on each side once shrunk
        // below ~1420px there just isn't 162px of gap for Credits at full
        // size any more (the title and switch each scale/shift on their own
        // independent formulas) — shrink it down to whatever DOES fit rather
        // than let it overlap either neighbour.
        var scale = Math.min(1, Math.max(0.01, (gap - margin * 2) / naturalWidth));
        var mid = (tr.right + sr.left) / 2 - hr.left;
        cred.style.left = mid.toFixed(1) + 'px';
        cred.style.transform = 'translate(-50%, -50%) scale(' + scale.toFixed(3) + ')';
      }
      measure();
      requestAnimationFrame(measure);
      setTimeout(measure, 260);
      window.addEventListener('resize', measure, { passive: true });
      (mq.addEventListener ? mq.addEventListener('change', measure) : mq.addListener(measure));
      // theme changes (Dark/Light <-> Start Menu) move title/switch without a
      // resize — catch those directly rather than relying on another init
      // block to remember to call this too.
      var themeObserver = new MutationObserver(measure);
      themeObserver.observe(root, { attributes: true, attributeFilter: ['data-hrw-theme'] });
    })();

    // REVERTED — "elongate the XP bar so SP sits equidistant from the title
    // vs. Credits" caused a real overlap on the live site (SP rendered
    // directly on top of "MEMBERS CLUB"): lifting .advhud's own max-width
    // to let the bar grow past it removed the one thing that was actually
    // keeping the HUD block from reaching the title in the first place —
    // the gap1==gap2 target this maintained is only as safe as the
    // measurement behind it, and with real (longer) tier-name text than
    // this was tested against, delta came out bigger than the isolated
    // test harness ever saw. Reverting to the plain fixed bar/max-width
    // CSS below (no JS elongation) restores the version that had zero
    // overlap reports across many previous rounds; the cap-text
    // shrink-to-fit JS (syncCapFit) is unrelated and stays (Nick).

    // Let other init blocks (e.g. Retro's "Back" button) drive the theme.
    window.__hrwSetTheme = function (t) { apply(t, true); };
    // Sync everything to the saved pick. CLASSIC is the default when nothing is
    // stored (Nick, 2026-09-09: "The default should be classic for all new
    // members").
    //
    // This was still 'start-menu', left over from when Start Menu was the
    // default, and it disagreed with the pre-paint script above — which already
    // resolves an empty value to Classic. So a first-time visitor got a Classic
    // first paint and then a JS-driven flip to Start Menu a moment later: the
    // wrong default AND a visible flash, from the same one-word mismatch.
    var initPick = 'classic';
    try { initPick = localStorage.getItem('hrw-theme') || 'classic'; } catch (e) {}
    // 'classic' is a LIVE value again (the switch writes it), so it is no
    // longer migrated away — apply() resolves it to the saved shade. The old
    // line mapped it to 'light', which would have made Classic default to light
    // for anyone carrying that legacy value, the exact opposite of the ask.
    apply(initPick, false);
  })();
})();
